/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */
export const i18nEnUs = {
    false: "No",
    true: "Yes",
    back: 'Back',
    continue: 'Next',
    type: 'Type',
    edit: 'Edit',
    globalShortcuts: 'Global Shortcuts',
    timeClock: 'Time tracking',
    reportBug: "Report bug",
    CTRLM: 'CTRL + M',
    CTRLO: 'CTRL + O',
    CTRLB: 'CTRL + B',
    ImportCsv: "Import CSV",
    ExportCsv: "Export CSV",
    ImportExcel: "Import Excel",
    ExportExcel: "Export Excel",
    Create: "Create",
    Show: "Show",
    Edit: "Edit",
    Copy: "Copy",
    Delete: "Delete",
    Close: "Close",
    Cancel: "Cancel",
    Update: "Update",
    Redo: "Redo",
    Undo: "Undo",
    Reset: "Reset",
    attachment: 'Attachment',
    onThisPage: 'On this page',
    accountCompanyInfoHeader: 'Company Information',
    accountCompanyAddCompany: 'Add new Company',
    accountEmployeeGroupConfirmed: 'Verified user',
    accountEmployeeGroupNotConfirmed: 'Non Verified User',
    accountEmployeeAddUser: 'Add new User',
    accountGeneralHeader: 'Account Data',
    accountSaveBottomBar: 'Save changes',
    accountPersonalInfoHeader: 'Personal Data',
    accountPersonalSignature: "Signature",
    accountPersonalUploadSignature: "Upload Signature",
    companyDetailsUploadLogo: "Upload Logo",
    accountNewDepartment: 'New department',
    accountConfirmationHeader: 'Account successfully confirmed',
    accountConfirmationContent: 'You have Recieved a Confirmation Email',
    accountConfirmationSetNewPasswordHeader: 'Please enter a Password for your new Account',
    accountConfirmationContinueToHome: 'Continue to the Customer Portal',
    userIsVerifiedHint: 'E-Mail-Address confirmed',
    userHasSignatureHint: 'Signature stored digitally',
    addComingSoon: 'Feature to update screenshots coming soon!',
    addFeatureDesc: 'Feature description',
    addFeatureHeader: '{{index}}. feature:',
    addFeatureTitle: 'Feature title',
    productCostTrendYear: 'Year',
    productCostTrendCosts: 'Costs in €',
    addFinish: 'Create {{prodName}}',
    addFinishEdit: 'Update {{prodName}}',
    addLongDesc: 'Long description for {{langCode}}',
    addName: 'Name of the new product',
    addNameEdit: 'Name of the product',
    addPaymentInterval: 'Payment interval (in months)',
    addPricingFeature: 'Billing costs / Feature',
    addProductDiscounts: "Discounts / From license",
    addProductDiscountsEnabled: "Discounts Enabled",
    addPrice: 'Price',
    addProductImage: 'Chose a product image',
    addProductUniversalScreenshot: 'Language Independent Images',
    selectLanguage: "Select language",
    addShortDesc: 'Short description for {{langCode}}',
    addStepFeature: 'Features',
    addStepGeneral: 'General information',
    addStepScreenshot: 'Screenshots',
    addAttachments: 'Attachments',
    addStepLicenseAgreements: 'License agreements',
    addStepPricing: 'Pricing & Discounts',
    pricingFeatures: "Feature overview",
    addressAddNewAddress: 'Add new address',
    addressEditAddress: 'Edit address',
    addressCreateHelpTextPre: "Here you can view or change your company address. Addresses are mostly used as delivery addresses and/or billing addresses.",
    addressCreateHelpTextAfter: "After saving, the address is immediately updated in the overview.",
    addressFederalState: 'Federal state',
    addressLand: 'Country',
    addressNumber: 'House No.',
    addressPageHeader: 'Company Addresses',
    addressStreet: 'Street name',
    addressTown: 'City',
    addressType: 'Address type',
    addressZip: 'Zip code',
    authConfirmationHeader: 'Verification',
    authConfirmationInfoTextOpen: 'To verify your account an E-Mail has been send to {{email}}.',
    accountPwResetConfirmation: 'An email has been sent. Please confirm it.',
    authConfirmationSuccess: 'Congratulations! \n Your account has been successfully verified',
    checkoutAddress: 'Chose an address',
    checkoutAutoRenewMulti: 'Automatically update licence every {{interval}} Months',
    checkoutAutoRenewSingle: 'Automatically update licence every Month',
    checkoutCredit: 'Credit charge',
    checkoutDebit: 'Debit charge',
    checkoutMail: 'E-Mail request',
    checkoutOrder: 'Order details',
    checkoutOwnedBy: 'Owned by {{owner}}',
    checkoutPayPal: 'PayPal',
    checkoutPayment: 'Chose a payment method',
    checkoutRouteToNewAddress: 'Not the right address here? \n Click to add a new one',
    checkoutRouteToNewBank: 'Not the right bank here? \n Click to add a new one',
    checkoutValueContainer: '{{amount}} €',
    checkoutOrderDetailsHeader: 'Order Details',
    checkoutVisa: 'Visa',
    checkoutToolTip: '{{method}} available soon',
    ComboBoxValueEmpty: '--none--',
    confirmationCancelText: 'Are you sure you want to cancel?',
    confirmationNo: 'No',
    confirmationSureText: 'Are you sure?',
    confirmationYes: 'Yes',
    detailTabDownload: 'Downloads',
    detailTabFeatures: 'Features',
    detailTabNews: 'News',
    detailTabReleases: 'Releases',
    detailTabPricing: 'Pricing',
    detailTabDocuments: 'Documents',
    detailTabNoDocuments: 'No license documents available',
    detailTabDocumentsLicenses: 'Licenses',
    detailTabDocumentsDocuments: 'Documents',
    departmentHeader: 'Departments',
    departmentAlreadyExists: 'Department already exists',
    employeeAccountCreate: 'Create new employee',
    employeeAccountUpdate: 'Edit employee',
    employeeBirthdate: 'Birthday',
    employeeCountry: 'Birthplace',
    employeeDegree: 'Degree',
    employeeDepartment: 'Division',
    employeeEmail: 'E-Mail',
    employeeVerified: "Verified",
    employeeLastPasswordChange: "Last password change",
    employeeGivenName: 'First name',
    employeeLastName: 'Surname',
    employeeName: 'Name',
    employeeNoPhone: 'No Number Supplied',
    employeeNoDepartment: 'No Department Assigned',
    employeeNoBirthplace: 'No Birthplace Supplied',
    employeePageHeader: 'Employee Management',
    employeePhone: 'Phone Number',
    employeeRole: 'Privilege',
    employeeRoles: 'Privileges',
    employeeSalutations: 'Salutation',
    employeeSalutationsFemale: 'Mrs.',
    employeeSalutationsMale: 'Mr.',
    employeeSalutationsOther: 'Divers',
    generalTitle: "Title",
    general_to: "to",
    generalSelectedTab: "Tab",
    generalRoute: "Frontend-Route",
    employeeUsername: 'Username',
    generalRequireTasks: "Tasks required",
    generalDetails: 'Details',
    generalFor: "for",
    generalAll:'All',
    generalReset: "Reset",
    generalRole: "Role",
    generalRoles: "Roles",
    generalAlias: 'Aliases',
    generalManagement: 'Management',
    generalRemove: 'Remove',
    generalArchive: 'Archive',
    generalEdit: 'Edit',
    generalChangesSaved: 'Your changes have been saved successfully',
    generalError: "Error",
    generalSuccess: "Success",
    generalBack: 'Back',
    generalCancel: 'Cancel',
    generalCompanyManagingDirectors: 'Managing Directors',
    generalCompanyName: 'Company',
    generalDescription: 'Description',
    generalFileUploadChoseMulti: 'Choose Files',
    generalFileUploadChoseSingle: 'Choose File',
    generalGroupBy: 'Group by',
    generalName: 'Name',
    generalMutability: 'Mutability',
    generalPermissions: "Permissions",
    generalPermission: "Permission",
    permissionActionBase: "Group",
    permissionActionName: "Action",
    navUsers: "User list",
    generalExpiryDate: "Expires at",
    generalId: "Id",
    generalNext: 'Next',
    generalPassword: 'Password',
    generalSecurity: "Security",
    generalNewPassword: "Neues Password",
    generalRegister: 'Register',
    generalSave: 'Save',
    generalSearch: 'Search',
    generalSortBy: 'Sort by:',
    generalUpload: 'Upload',
    generalProduct: 'Product',
    generalProductId: 'Product-Id',
    generalAvailability: 'Availabilities',
    generalCreate: 'Create',
    generalCreated: 'Created',
    generalImport: 'Import',
    generalVouchers: "Vouchers",
    generalRegexExpressions: "Regular expressions",
    homeNews: 'News',
    homeQuickAccess: "Quick access",
    loginChangePassword: 'Change password',
    loginNewPassword: 'New password',
    loginNoAccount: 'No account?',
    accountProfile: "Profile",
    administration: "Administration",
    adminAvailableBackups: "Available backups",
    adminRestoreHelpText: "This function can be used to restore the application data from a backup. Make sure that the backup is up-to-date and comes from the same instance. Note that all application data is replaced by the data from the backup.",
    adminBackupHelpText: "This function can be used to back up the entire application. Please ensure that the 'BackupPath' path has been configured correctly and that the database user has the necessary rights to perform a backup.",
    adminBackupCreatedText: "Successfully Created Backup: {{fileName}} with a Size of {{size}} MB",
    adminCreateBackup: "Create backup",
    generalBackup: "Backup",
    adminRestore: "Restore from backup (Coming soon)",
    loginOneTimePassword: 'One-time password',
    loginSignIn: 'Login',
    loginInsteadHint: 'Back to login',
    loginSignUp: 'Click here to register',
    loginOutOfDate: 'Your Password seems to be out of Date\nPlease Enter a new one',
    newsAddNews: 'Add new News item',
    newsImage: 'Display Image',
    newsProductRelation: 'Product relations',
    newsAttachments: "Attachments",
    newsTranslations: "Translations",
    managementAboutProd: 'About the software:',
    managementAssignmentError: 'User limit reached on current licence',
    managementAutoRenewal: 'Auto-Renewal:',
    managementBoughtLicences: 'Purchased activations:',
    managementDividerFirstname: 'Firstnames with {{sortedKey}}',
    managementDividerLastname: 'Lastnames with {{sortedKey}}',
    managementDividerLicence: 'User with {{sortedKey}} licence',
    managementDividerNoLicence: 'User without licence',
    managementDividerRole: 'User with {{sortedKey}} Clearance',
    managementDividerUsername: 'Usernames that start with {{sortedKey}}',
    managementEditAssignment: 'assign License',
    managementGroup1None: 'None',
    managementGroup2Licences: 'License',
    managementGroup6Roles: 'User Role',
    managementHeader: 'Assigned Licenses',
    managementLicenceFrom: 'Purchased On:',
    managementLicenceId: 'Licence ID:',
    managementLicenceTo: 'Valid Till:',
    managementMiniFabAdd: 'Assign Licence To User',
    managementMiniFabRemove: 'Removes Licence From User',
    managementNewLicence: 'Buy New Licences',
    managementNextRenewal: 'Next Renewal Date:',
    managementNoLicenceOwned: 'This user has no licences assigned',
    managementNoProductsBooked: 'Looks like you don\'t have a licence to any of our products\nClick here to navigate to the product tab',
    managementOwnedLicenceHeader: 'Licences assigned to the user',
    managementRemainingActivations: 'Remaining Activations:',
    managementProductActive: 'Product activated:',
    managementIsDemo: 'Demo version:',
    managementToOverview: 'Back To Overview',
    managementToProduct: 'To Product',
    managementUserWithLicence: 'User with <b>{{product}}</b> License',
    managementUserWithoutLicence: 'User without <b>{{product}}</b> License',
    licenseOrderConfirmation: "Your license has been successfully ordered!",
    licenseCostPerUserYear: "per user",
    licenseDiscountPerAmount: "From <b>{{amount}}</b> licenses:",
    licenseDiscount: "Discounts",
    licenseDiscountSingular: "Discount",
    licenseDiscountInPercent: "Discount in %",
    licenseSavedHint: "You will save",
    licenseDiscountOldLicenseHint: "Possible additional discounts on already existing licenses (e.g. quantity discounts) are automatically applied after ordering. These are only not taken into account in the current calculation.",
    licenseDiscountHint: "The license discount applies to all purchased licenses as well as features, regardless of the time of order",
    licenseCostPerUserFirstYear: "first year",
    licenseCostPerUserSecondYear: "second year",
    licenseCostPerUserThirdYear: "third year onwards",
    licenseCostMwst: 'Vat.',
    licenseCostInklMwst: 'incl. Vat',
    licenseOrderDemo: 'Order demo version',
    managementProductNoUser: 'No assigned User',
    paymentAccountOwner: 'Account Owner',
    paymentAddNewBank: 'Add new bank account',
    paymentBankName: 'Name of Bank',
    paymentBic: 'BIC',
    paymentIban: 'IBAN',
    paymentPageHeader: 'Payment Details',
    productSateDraft: "Draft",
    productSateAvailable: "Published",
    productSateArchived: "Archived",
    productDescriptions: 'Product descriptions',
    productChoseState: "Select product state",
    productManagementSectionText: "This section contains management functions that have a global effect on the product. These functions should be considered and executed with caution, as the actions may potentially impact the ongoing product business.",
    productLicenceSectionText: "As an administrator, you have the option to upload license agreements for each product. These license agreements are displayed in the download section of each product. They are used to provide the end user with clear information about the product's terms of use and restrictions. By uploading these agreements, you can ensure that your customers are always well informed and use the products according to the established guidelines",
    productDeleteHintText: "If you delete this product, it is no longer visible to customers and can no longer be ordered. Only current contracts of existing customers remain.",
    productArchiveHintText: "Archive this product, it is no longer visible to customers. The last change is kept and if necessary you can restore the product.",
    productPricingAndDiscountSectionText: "In this section you have the possibility to edit prices and discounts for your product. These will take effect immediately. The changes will not take effect for existing customer contracts, but only after the next order or reorder of the customer.",
    productFeatureSectionText: "Here you can describe your product based on features for the customer and customize it in detail in preparation for the following pricing model. Changes to the feature set for existing products do not affect existing products from Kudnen. If changes are made here, they will only be effective for future orders.",
    productScreenshotsSectionText: "Product images are the most important thing for your customers. In this section you can edit, delete or add new ones. Make sure that you use high quality and meaningful images here, so that the customer keeps the focus on the essential product features.",
    productAlreadyBoughtLicences: 'Amount of bought licences',
    productAvailableVersions: 'Available downloads:',
    productBuyLicence: "Buy Licence",
    productChooseEmpty: "No Product",
    productChooseProduct: "Choose a Product",
    productChooseVersion: "Choose a Version",
    productMainHeader: 'Our Products',
    productPaymentInterval: 'Payment Interval',
    productPriceOfLicenceAmount: 'Current Order Price',
    productPricePerLicence: 'Price per licence',
    productProcureAmount: 'Number of Requested licences',
    productRelease: "New Product Version",
    productSearch: 'Search User',
    productAvailableFrom: 'Available From',
    productAvailableTo: 'Available To',
    productFeatureOrderableInDemo: 'Orderable in Demo-Version',
    productFeatureOrderableInProd: 'Orderable in Full-Version',
    productSendRequest: 'Send Request',
    productOrderAcceptTermsAndCondtionsStart: 'I accept the terms of the',
    productOrderAcceptTermsAndCondtionsEnd: 'license agreement',
    newsMainHeader: 'News',
    newsSubHeader: "This Page allows employees and administrators to manage current news. Please note that product information is only relevant when specific news pertains to a particular product and not general information. The publication date is only necessary if an entry is intended to be published in the future.",
    newsDraft: "Draft",
    registerConfirmPassword: 'Password (Confirmation)',
    registerHeader: 'Register',
    releaseDialogPlatform: 'Platform',
    releaseDialogRelease: 'Choose a release',
    releaseDialogVersion: 'Version',
    productReleaseDate: "Released on",
    productReleaseSize: "Size",
    sidebarAccount: 'Account',
    sidebarAccountAddresses: 'Addresses',
    sidebarAccountCompany: 'Company',
    sidebarAccountEmployees: 'Employees',
    sidebarAccountGeneral: 'General',
    sidebarAccountPayment: 'Payment',
    sidebarHome: 'Home',
    sidebarLicenceManagement: 'Licences',
    sidebarProducts: 'Products',
    userAddNewUser: 'Add New User',
    userInfo: 'User Info',
    validationCompareEmail: 'Email addresses do not match',
    validationComparePassword: 'Passwords do not match',
    validationErrorTypeDecimal: 'Not an acceptable decimal input',
    validationErrorTypeUpperCase: 'Has to contain uppercase characters.',
    validationErrorTypeNumbers: 'Has to contain numbers.',
    validationErrorTypeLowerCase: 'Has to contain lowercase characters.',
    validationErrorTypeSpecialChar: 'Has to contain special characters.',
    validationErrorTypeNoUpperCase: 'Shall not contain uppercase characters.',
    validationErrorTypeNoNumbers: 'Shall not contain numbers.',
    validationErrorTypeNoLowerCase: 'Shall not contain lowercase characters.',
    validationErrorTypeNoSpecialChar: 'Shall not contain special characters.',
    validationErrorTypeIban: 'not a valid IBan format',
    validationErrorTypeFailedChecksum: 'Iban has Invalid Checksum',
    validationErrorTypeIbanLength: 'Iban is too short',
    validationErrorTypeNoWhiteSpace: 'Must not contain a space',
    validationInvalidEmail: 'Please enter a valid email address',
    validationIcloudInvalid: 'ICloud email addresses are not supported',
    validationInvalidMaxLength: 'Input shall not have more than {{length}} characters!',
    validationInvalidMinLength: 'Input shall have at least {{length}} characters!',
    validationInvalidPassword: 'Password shall contain at least: one number, one uppercase, one lowercase, one special character and shall at least be 8 characters long',
    validationInvalidPattern: 'Input shall match {{pattern}}',
    validationRequired: '{{label}} is required',
    validationErrorTypePhone: "Please enter a valid phone number",
    validationErrorTypeUrl: "Please enter a valid URL (must start with http:// or https://)",
    validationErrorTypeBic: "Please enter a valid BIC/SWIFT code",
    validationErrorTypePattern: "Invalid format",
    validation_invalidTimeInput:'One of the Time inputs is Invalid',
    passwordRecoverConfirmHeader: 'Set new Password',
    passwordRecoverConfirmNewPassword: 'new Password',
    passwordRecoverConfirmNewPasswordCon: 'confirm Password',
    passwordChangeOld: 'Old password',
    passwordRecoverHeader: 'Reset Password',
    passwordRecoverDescription: 'To reset your password please provide your E-Mail address. After confirming the address you will be sent a link to reset your password',
    generalSend: 'Send',
    passwordForgotten: 'Forgot password?',
    addNewsTitle: 'News Title',
    addNewsNewsText: 'News Contents',
    newsChooseProduct: 'Choose the related product',
    newsChooseType: "Chose News type",
    newsReleaseDate: "News release date",
    newsChooseProductVersion: 'Choose the related product version',
    generalSetDefault: 'Set as Default',
    generalDefault: 'Default',
    productExtendButtonRelease: 'Add Release',
    productExtendButtonNews: 'Add News',
    productExtendButtonProduct: 'Edit Product',
    addressTypeDefault: 'Mailing Address',
    addressTypeShipping: 'Shipping Address',
    addressTypeBilling: 'Billing Address',

    // CRM Translation keys
    dialogHeaderContact: 'Contact Details',
    inPerson: 'Personal',
    letter: 'Letter',
    fax: 'Fax',
    carrierPigeon: 'carrier pigeon',
    addBusinessHours: 'Add business hours',
    addRelationType: 'Choose a relation:',
    addRelationMinComm: 'The message is a {{type}} on:',
    addToDoTitle: 'Create a new ToDo',
    addToDoTask: 'Task',
    addToDoText: 'Description',
    generalWatcher: 'Observer',
    addProjectDialogeOptionalInfos: 'optional information',
    communicationEdit: 'Edit',
    communicationAddRelation: 'Relationships',
    communicationAddStatus: 'For Status',
    communicationDelete: 'Remove',
    addCommunicationTitle: 'New entry',
    commDetailEdit: 'Edit Entry',
    commDetailDelete: 'Remove Entry',
    commDetailTitleInput: 'Title',
    commDetailTextInput: 'Notes',
    commDetailTypeInput: 'Message Type',
    commDetailParent: 'This message is a response to:',
    commDetailRelationHeader: 'Reply to this message',
    companyDisplayChangeCompany: 'Change Company',
    companyDisplayLocalTime: 'Local time',
    companyDisplayBusinessHours: 'Business hours',
    companyDisplayContactPerson: 'Contact person',
    companyDisplayAddNewContact: 'Add contact person',
    companyDisplayLinkNewTracker: 'Start new tracker',
    companyCreateHeader: 'Create new company',
    companyCreateSetTimeZone: 'Time zone shift (h):',
    companyCreateSetName: 'Company name',
    companyCreateSetOpeningTime: 'opening hours',
    companyManagerSignatureMissing: 'Note: The following directors do not yet have a valid signature: ',
    companyManagerSignatureMissingSubText: 'This must be specified for outgoing invoices or other correspondence.',
    companyTaxNumber: "Tax number",
    companySalesTaxNumber: "Sales tax number",
    companyTaxOffice: "Responsible tax office",
    companyCourtOffice: "Name local court",
    companyCourtOfficeNr: "Local court number",
    companyCourtOfficePlaceholder: 'e.g. Local Court Braunschweig',
    companyCourtOfficeNrPlaceholder: 'e.g. HRB 4863',
    courtOfficeName: 'Register court',
    courtOfficeNr: 'Commercial register number',
    validationCourtOfficeNrRequired: 'Enter a commercial register number when a court office is configured.',
    validationCourtOfficeRequired: 'Enter a court office when a commercial register number is configured.',
    validationPreferredInvoiceFormatEdiIdRequired: 'EDIFACT and VDA require an EDI partner identifier for this customer.',
    validationPreferredInvoiceFormatVwReferenceRequired: 'Volkswagen VDA 4938 T2 requires a VW Company Reference for this customer.',
    invoiceExportSellerEdiMissing: 'The sender EDI partner identifier is missing. Configure it under Administration → Company data → Electronic invoice exchange.',
    invoiceExportBuyerEdiMissing: 'The recipient EDI partner identifier is missing. Configure it on the customer under Electronic invoice exchange.',
    invoiceExportBuyerVwReferenceMissing: 'Volkswagen VDA 4938 T2 requires a VW Company Reference on the recipient customer.',
    invoiceExportVdaDeliveryDateMissing: 'Volkswagen VDA 4938 T2 requires a delivery date on the invoice.',
    invoiceExportBuyerVwReferenceInvalid: "The recipient customer's VW Company Reference must contain exactly 4 characters.",
    companyProfitDetermination: "Profit determinations type",
    companyFormOfAccounts: "Form of accounts",
    companyWebsite: "Website",
    companyPhone: "Phone number",
    contactDetailHeader: 'Contact detail',
    contactCreateHeader: 'Create a new contact',
    confirmationTitle: 'Delete entry',
    confirmationText: 'Are you sure you want to delete the entry?',
    confirmationDeleteMultipleText: 'Are you sure you want to delete all selected entries?',
    dialogRelationMulti: 'Select responses',
    dialogRelationSingle: 'Select a parent',
    dialogRelationSetParent: 'set message as parent',
    dialogRelationSetAnswer: 'set message as answer',
    filterByWorkflow: 'filter by workflow',
    filterByStatus: 'filter by status',
    groupAdd: '',
    groupName: '',
    quickInputHead: 'Quick documentation',
    quickInputNewCompany: 'Create new company',
    quickInputOldCompany: 'Extend existing company',
    quickInputTextTitle: 'Title',
    quickInputText: 'Text',
    generalAdd: 'Add',
    generalDate: 'Date',
    generalCompany: 'Company',
    generalCount: "Sum",
    generalPronouns: 'Salutation',
    generalFirstName: 'FirstName',
    generalLastName: 'LastName',
    generalEMail: 'Email',
    generalPhone: 'Phone number',
    generalLogin: 'Login',
    generalContactPerson: 'contact person',
    generalNote: 'note',
    generalChooseWorkflow: 'workflow',
    generalStartingStatus: 'Initial Status',
    generalUser: 'User',
    generalDelete: 'Delete',
    generalUpdate: 'Refresh',
    generalCurrency: '€',
    generalLock: "Lockout",
    generalUnlock: "Unlock",
    generalRolesAndPermissions: "Role & Permissions",
    generalServerSettings: "Server settings",
    generalEnvironment: "Environment",
    generalDiagnostics: "Log & Diagnostics",
    generalIntegrations: "Integrations",
    generalVariablesSettings: "Variables",
    generalBackupRestore: "Backup & Restore",
    generalAccessManagement: "Access Management",
    generalUserAndRoles: "Users & Rights",
    generalComingSoon: "Coming Soon",
    generalPaymentMethods: "Payment methods",
    linkTrackerHeader: 'Start new tracker for {{company}} Start',
    linkTrackerProduct: 'Select a product',
    linkTrackerTracker: 'Select a valid tracker',
    linkTrackerStatus: 'Select an initial status',
    trackerName: 'Tracker Name',
    stepLabelLinktTrackerFirst: 'Tracker type + Tracker name',
    stepLabelLinktTrackerSecond: 'Additional informations',
    openingTimeItemOn: 'On',
    openingTimeItemSelectDay: 'Select a day',
    openingTimeItemFrom: 'From',
    openingTimeItemTo: 'Until',
    projectTableCustomer: 'Customer',
    projectTableOrderNr: 'OrderNo (Customer)',
    projectTableOfferNr: 'OfferNo. (yasc)',
    projectTableProjectName: 'Project name',
    projectTableTeam: 'Employee',
    projectTableStatus: 'Project status',
    projectTableNextBill: 'Next invoice',
    projectTableBillFull: 'Total invoice amount',
    projectTableBillPart: 'Part Amount',
    projectTableBillDue: 'Due on',
    projectTableComments: 'Comment',
    projectTable: 'Percentage of completion',
    projectTableTask: 'Task',
    projectTableToDo: 'Next TODO',
    projectTableNoBill: 'No billing found',
    projectTabletNoToDo: 'No tickets found',
    projectTableAddRole: 'Role',
    projectTableAddInvoiceType: 'Billing type',
    projectTableVolume: 'Project volume',
    projectTableInvoiceCnt: 'Number of invoices',
    projectTablePartialAmount: 'Partial Amount',
    projectTableDueDate: 'Due Date',
    projectTableInvoice: 'Invoices',
    projectTableTooSmallDate: 'The selected date is smaller than that of the last paid entry and could not be set',
    projectTableCustomerNr: 'Customer Nr',
    projectTableRemainingAmount: 'Open Amount',
    projectAddNewProject: 'Add new Project',
    projectBillsTitle: 'Rechnungsdetails',
    projectBillsHelpTextPre: "In this section, you can manage and issue invoices for the selected project.",
    projectBillsHelpTextAfter: "Invoices can be edited until the invoice has been sent. Changes are then only possible via a revision.",
    projectSlideOutTeamHeader: 'Team Details',
    projectTabGeneralTitle: "Project details",
    projectTabGeneralName: "Details",
    projectTabTeamTitle: "Project Team",
    projectTabTeamName: "Team",
    projectBudgetTitle: "Budgets and billing components",
    billingPreferredInvoiceFormat: 'Preferred invoice format',
    companyFormSectionGeneral: 'General',
    companyCustomerNumberPlaceholder: 'Automatic when empty',
    companyCustomerNumberHint: 'Optional when creating a company. If left empty, the next available customer number is assigned automatically.',
    validationCustomerNumberRequired: 'The customer number must not be empty when editing.',
    companyFormSectionTax: 'Tax and registration',
    companyFormSectionBilling: 'Billing',
    companyFormSectionEdi: 'Electronic invoice exchange',
    companyDescriptionPlaceholder: 'Short internal description of the company',
    billingPreferredInvoiceFormatHint: 'Preselects the preferred export and delivery format for new invoices for this customer.',
    billingEdifactInterchangeId: 'EDI partner identifier',
    billingEdifactInterchangeIdPlaceholder: 'e.g. GLN or agreed interchange ID',
    billingEdifactInterchangeIdCustomerHint: 'Technical EDIFACT recipient identifier of this customer. Required only for EDIFACT and VDA exports.',
    billingEdifactCompanyReference: 'VW Company Reference',
    billingEdifactCompanyReferencePlaceholder: 'Company Reference provided by the Volkswagen partner',
    billingEdifactCompanyReferenceHint: 'Required only for Volkswagen VDA 4938 T2. The Company Reference must contain exactly 4 characters.',
    billingEdifactSellerSectionTitle: 'Electronic invoice exchange',
    billingEdifactSellerSectionSubtitle: 'Technical sender identifier for EDIFACT and VDA invoices',
    billingEdifactSellerHint: 'This identifier applies centrally to your company as invoice sender. The EDI recipient identifier is maintained separately on each customer.',
    projectFormSectionGeneral: 'General',
    projectFormSectionBilling: 'Billing',
    projectFormSectionPlanning: 'Planning',
    projectFormSectionSettings: 'Additional settings',
    general_color: 'Color',
    generalBackendRequestFailed: 'The request could not be processed.',
    general_validationSummary: 'Please check the highlighted inputs or apply pending list entries.',
    projectBudgetEmployee: "Employee / shared pool",
    projectBudgetReference: "Contract reference",
    projectBudgetStart: "Budget or contract start",
    projectBudgetEnd: "Budget or contract end",
    projectBudgetTotalHours: "Budget hours",
    projectBudgetUsedHours: "Invoiced hours",
    projectBudgetActualWorkedHours: "Actual hours",
    projectBudgetOperationalRemainingHours: "Remaining budget",
    projectBudgetRemainingHours: "Remaining hours to invoice",
    projectBudgetHourlyRate: "Net hourly rate",
    projectBudgetTotalNetto: "Net budget value",
    projectBudgetRemainingNetto: "Net remaining value",
    projectBudgetSourceOffer: "Source offer",
    projectBudgetPricingModel: "Pricing model",
    projectBudgetCurrencyCode: "Currency",
    projectBudgetPlannedHours: "Planned hours (optional)",
    projectBudgetIncludedHours: "Included hour allowance",
    projectBudgetDefaultHourlyRate: "Net hourly rate",
    projectBudgetFixedPrice: "Net flat amount",
    projectBudgetAmountLimit: "Net cost cap",
    projectBudgetRecurrenceType: "Recurrence / provisioning",
    projectBudgetRecurrenceInterval: "Custom interval",
    projectBudgetCarryOverType: "Unused budget carry over",
    projectBudgetCarryOverLimitHours: "Maximum carried hours",
    projectBudgetCarryOverLimitAmount: "Maximum carried amount",
    projectBudgetCarryOverPercentage: "Carry over percentage",
    projectBudgetCarryOverExpirationPeriods: "Expire after periods",
    projectBudgetOveragePolicy: "Overage policy",
    projectBudgetOverageHourlyRate: "Overage hourly rate",
    projectBudgetFormDescription: "A budget is one billing component of the project or a contract, for example an hours allowance, retainer, on site service or additional time and material work. Define the assignment first and then choose the pricing model.",
    projectBudgetSectionAssignment: "Assignment",
    projectBudgetSectionBillingModel: "Pricing model",
    projectBudgetSectionTerm: "Term",
    projectBudgetSectionConditions: "Budget and conditions",
    projectBudgetSectionRecurrence: "Recurrence",
    projectBudgetSectionCarryOver: "Carry over",
    projectBudgetSectionOverage: "Overage",
    projectBudgetSectionAdditional: "Additional details",
    projectBudgetPricingModelHint: "Choose the business pricing model first. The remaining inputs are shown or hidden automatically based on that choice.",
    projectBudgetPricingModelDescription: "Time & material: every worked hour is billed. Fixed price: one flat total price. Capped time & material: hourly billing up to an hour or cost cap. Hour package: a fixed included hour allowance for a package price. Retainer / maintenance agreement: a recurring flat amount, optionally with included hours.",
    projectBudgetStartHint: "The budget can cover work from this date onward.",
    projectBudgetEndHint: "Optional. Leave empty for a budget or agreement without a fixed end date.",
    projectBudgetPlannedHoursHint: "Planning and calculation value only. Planned hours do not cap a time & material or fixed-price budget.",
    projectBudgetIncludedHoursHint: "Contractually included hour allowance. For a capped model it can act as an hour cap; for hour packages and retainers it represents included service.",
    projectBudgetDefaultHourlyRateHint: "Regular net hourly rate used for time-based billing.",
    projectBudgetFixedPriceHint: "Flat net amount for the fixed price, hour package or retainer.",
    projectBudgetAmountLimitHint: "A capped model requires at least an hour cap or a cost cap. If both are set, the first limit reached applies.",
    projectBudgetRecurrenceTypeHint: "For recurring hour packages or maintenance agreements. No recurrence means a one-time budget; a maintenance agreement / retainer requires recurrence.",
    projectBudgetRecurrenceIntervalHint: "Only for custom recurrence. Defines the number of periods between provisions.",
    projectBudgetCarryOverTypeHint: "Only for recurring budgets. Defines whether unused budget is carried into the next period.",
    projectBudgetCarryOverLimitHoursHint: "Maximum number of unused hours that may be carried into the next period.",
    projectBudgetCarryOverLimitAmountHint: "Maximum unused amount that may be carried into the next period.",
    projectBudgetCarryOverPercentageHint: "Percentage of unused budget that is carried into the next period.",
    projectBudgetCarryOverExpirationPeriodsHint: "Number of periods after which carried values expire.",
    projectBudgetOveragePolicyHint: "Only for budgets with an actual cap. Defines how work above the available allowance is handled.",
    projectBudgetOverageHourlyRateHint: "Optional alternative net hourly rate for explicitly billable overage.",
    projectBudgetContract: "Contract",
    projectBudgetSectionCapacity: "Capacity",
    projectBudgetCapacityUnit: "Capacity unit",
    projectBudgetCapacityInterval: "Capacity interval",
    projectBudgetCapacityIntervalHint: "Defines when the base capacity is made available again. This is independent from the billing recurrence.",
    projectBudgetHoursPerDay: "Hours per day",
    projectBudgetHoursPerDayHint: "Conversion factor for day-based capacities.",
    projectBudgetConsumptionFactor: "Consumption factor",
    projectBudgetConsumptionFactorHint: "Multiplier applied to consumed capacity, for example 1.5 for on-site work.",
    projectBudgetManualOnly: "Manual allocation only",
    projectBudgetManualOnlyHint: "If enabled, the budget is skipped by automatic allocation and must be selected explicitly.",
    projectBudgetCapacityUnitEnum: { Hours: 'Hours', Days: 'Days' },
    projectBudgetCapacityIntervalEnum: { None: 'No recurring capacity', Weekly: 'Weekly', Monthly: 'Monthly', Quarterly: 'Quarterly', Yearly: 'Yearly' },
    projectContractEntity: "Contracts",
    projectContractFormTitle: "Contract",
    projectContractTitle: "Contract",
    projectContractsTitle: "Contracts",
    projectContractsDescription: "Contracts define the legal and temporal frame of the project. Billing rules and capacities are configured below as budgets and billing components.",
    projectContractNumberDescription: "Internal or contractual number used to identify the contract.",
    projectContractNameDescription: "Short descriptive name, for example Maintenance and Support Contract.",
    projectContractStartDescription: "Date from which the contract applies to the project.",
    projectContractEndDescription: "Optional contract end date. Leave empty for an open-ended contract.",
    projectContractDocumentDescription: "Attach the signed contract or the currently valid contract version.",
    projectBudgetCapacityAmount: "Capacity per period",
    projectBudgetCapacityAmountHint: "Capacity in the selected unit. Example: 2 days with weekly capacity interval means 2 days per week. Hours per day is only used to convert time bookings for day-based capacities.",
    calendar_consumptionFactor: "Consumption factor",
    calendar_consumptionFactorHint: "Optional factor for this time booking only. Example: 1.5 for on-site work. Empty means the budget factor is used.",
    projectContractFormDescription: "Manage the contract frame for a customer or project. Commercial conditions remain on the assigned project budgets.",
    projectContractNumber: "Contract number",
    projectContractStart: "Start",
    projectContractEnd: "End",
    projectContractDocument: "Contract document",
    projectContractBudgetCount: "Assigned budgets",
    projectContractSectionGeneral: "General",
    projectContractSectionAssignment: "Assignment",
    projectContractSectionTerm: "Term",
    projectContractSectionDocument: "Document",
    projectContractSectionAdditional: "Additional details",
    projectContractStatusEnum: { Draft: 'Draft', Active: 'Active', Suspended: 'Suspended', Terminated: 'Terminated', Expired: 'Expired' },
    navButtonProjectContracts: "Contracts",
    projectBudgetPricingModelEnum: {
        TimeAndMaterial: 'Time & material',
        FixedPrice: 'Fixed price',
        CappedTimeAndMaterial: 'Capped time & material',
        PrepaidHours: 'Hour allowance / hour package',
        Retainer: 'Maintenance agreement / retainer',
    },
    projectBudgetPricingModelDescriptionEnum: {
        TimeAndMaterial: 'Each worked hour is billed at the configured hourly rate. Suitable for services billed by effort without a fixed price cap.',
        FixedPrice: 'The agreed service is billed at a fixed total price. Planned hours are used only for internal capacity planning.',
        CappedTimeAndMaterial: 'Work is billed by effort, but only up to the configured hour or amount cap.',
        PrepaidHours: 'A fixed allowance is provided for a package price. The allowance can renew periodically and carry over according to the configured carry-over rules.',
        Retainer: 'Recurring flat fee, optionally including an allowance. Suitable for maintenance and support agreements with a recurring base fee.',
    },
    projectBudgetRecurrenceTypeEnum: {
        None: 'One-time / no recurrence', Monthly: 'Monthly', Quarterly: 'Quarterly', Yearly: 'Yearly', Custom: 'Custom',
    },
    projectBudgetCarryOverTypeEnum: {
        None: 'No carry over', Full: 'Full', Limited: 'Limited', Percentage: 'Percentage',
    },
    projectBudgetOveragePolicyEnum: {
        Billable: 'Additionally billable', NonBillable: 'Not billable', RequiresApproval: 'Approval required', NotAllowed: 'Not allowed',
    },
    projectTabTodoTitle: "Project todos",
    projectTabTodoName: "Todos",
    projectTabTaskTitle: "Project tasks",
    projectTabTaskName: "Tasks",
    projectTabInvoicesTitle: "Invoices",
    projectTabInvoicesName: "Invoices",
    projectTableStart: 'Project start',
    projectTableEnd: 'Project end',
    projectRequireProjectBudget: 'Project budget required for time tracking',
    projectBudgetBookingLabel: 'Project budget',
    projectBudgetBookingRequired: 'Select a project budget for this booking.',
    projectRequireTasks: 'Tasks required',
    general_internalName: 'Internal name',
    invoiceNumber: 'Invoice number',
    invoicePaymentTarget: 'Payment target',
    invoicePaidOn: 'Paid on',
    projectCreatedInvoices: "Created Invoices",
    StartDate:'Start Date',
    EndDate:'End Date',
    StartTime:'Start Time',
    EndTime:'End Time',
    inRange:'Overlaps with other entry',
    endBefore:'End is before Start',
    descriptionOrTask:'Choose a task or add a Description',
    appointmentColor:'Appointment Color',
    timeManagerImportExcel:'Import work-time Excel',
    calendarWeekView: 'Calendar week view',
    calendarWorkingWeek: 'Work week',
    calendarFullWeek: 'Full week',
    statusHeaderCurrent: 'Status of the company',
    statusHeaderNoTrackerFound: 'No trackers found',
    toDoNoGroupsFound: 'No ToDo groups found',
    toDoCreateNewGroup: 'Create new group',
    toDoNoTodosFoundInGroup: 'No ToDos found in the group',
    toDoAddNew: 'Create new todo',
    noTrackerFound: 'No trackers found',
    noContractsFound: 'No contracts found',
    navResources: "Resources",
    navInventory: 'Inventory',
    navGlobalVariables: "Variables",
    navDiagnosticLogs: "Server Logs",
    navButtonHumanResources: "Resource planning",
    navButtonProjectBudgets: "Project budgets",
    navButtonTimeManagement: "Time Management",
    navCp: "Customer Portal",
    navCrm: "CRM",
    navFibu: "Bookkeeping",
    navFin: "Finances",
    navButtonDashboard: 'Home',
    navButtonTracker: 'Tracker',
    navButtonDiagram: 'Diagrams',
    navButtonWorkflow: 'Workflow',
    navButtonToDo: 'Tasks',
    navButtonProject: 'projects',
    navButtonCompany: 'Companies',
    navFibUnpostedVouchers: 'Unbooked Vouchers',
    navFibTransactions: 'Transactions',
    navFibBatchBooking: 'Batch Booking',
    navFibUnbookedVouchers: "Unbooked vouchers",
    navFibBankAccounts: 'Bank connections',
    navFibJournal: 'Journal',
    navFibOffers: 'Offers',
    navFibInvoices: 'Invoices',
    navGlobalPermissions: "Global permissions",
    navGlobalRoles: "Global roles",
    navFibRecurring: 'Recurring',
    navFibTemplates: 'Templates',
    navFibBankSettings: "Banks",
    navFibAccountPlan: "Accounts plan",
    navFibRecurringTitle: 'Recurring Bookings',
    navFibExport: 'Export',
    navFibAccountCreate: "Create Account",
    navEmailClients: "Email-Clients",
    finTransactions: "Bank transactions",
    finBank: "Bank",
    finCashBox: "Cash-Box",
    finSelectBankAccount: "Please select the related bank account",
    none: 'No accounting',
    evenDistro: 'Even distribution',
    custom: 'Self-created',
    asTheyCome: 'Ad Hoc',
    fibuForms: "Active WebForms",
    fibuBookingDate: 'Booking date',
    fibuBookingPrefix: 'Prefix',
    fibuBookingNumber: 'Booking number',
    fibuBookingText: 'Booking text',
    fibuBookingTotal: 'Amount',
    fibuBookingTotalBrutto: "Total brutto",
    fibuBookingTotalNetto: "Total netto",
    fibuBookingAmountType: 'Amount type',
    fibuBookingDebit: 'Debit',
    fibuBookingCredit: 'Credit',
    fibuAddDebit: 'Split Debit',
    fibuAddCredit: 'Split Credit',
    fibuBookingAccount: 'Booking account',
    fibuBookingAccountAddPattern: "Add a regular expression to improve the automated assignment of invoice numbers",
    fibuBookingVatAccount: 'Vat account',
    fibuBookItems: 'Book Items',
    fibuBookItemsDialog: 'Do you want to book all entries into the journal?',
    fibuBookItemsNum: 'Do you really want to book {{amount}} entries into the journal?',
    fibuBookItemsSingle: 'Do you really want to book a single entry into the journal?',
    fibuBookItemsDialogSingle: 'Do you want to book this entry into the journal?',
    fibuOnlyNewBookings: "New bookings only",
    fibuDatevDistributionChannels: "Distribution channels",
    fibuVoucherType: "Voucher type",
    fibuAddVouchers: "Add Voucher(s)",
    fibuBookingType: "Booking type",
    fibuExportOptions: "Export",
    fibuImportDialogMappingTitle: "Assignment of import data",
    fibuImportDialogMappingSubText: "Please provide information about the assignment of your source data. This dialog imports sales data from various systems with the help of already created schemas. These are used to transfer the data in the file to the target system. You can define or change a schema at any time under Accounting / Templates.",
    fibuTemplateName: "Name of template",
    fibuBookingImportTemplates: "Import Templates",
    fibuSelectedUploadTemplate: "Selected upload template",
    fibuBookedBy: "Booked by",
    fibuAmount: "Amount",
    fibuAccountNumber: "Nr",
    fibuAccountName: "Account Name",
    fibuAccountType: "Account Type",
    fibuAccountCategory: "Account Category",
    fibuAccountTaxAccount: "Default Tax Account",
    fibuCredit: "Creditor",
    fibuDebit: "Debitor",
    fibuGlAccount: "GL-Account",
    fibuCreateImportTemplateTitle: "Create import template",
    fibuImportTemplateHelpTextPre: "Upload a CSV file from which you would like to create a template",
    fibuImportTemplateHelpTextAfter: "You can then select the source columns for the required booking information",
    fibuCreateAccountPlan: "Create an account category for your accounting. The customer/vendor or G/L account category is crucial for the calculation and correct allocation of postings for tax purposes",
    fibuCreateBooking: "Create batch booking",
    fibuCreateBookingHelpTextPre: "Create a new posting for the posting batch here. Fill in at least all mandatory fields and, if possible, attach your receipts.",
    fibuCreateBookingHelpTextAfter: "After saving, the booking is immediately available in the batch.",
    fibuCreateTxAlias: "Create creditor alias",
    fibuCreateTxAliasHelpTextPre: "Create a new alias for a creditor here. This will be used for automatic transaction assignment, among other things. Often a creditor such as 'Amazon' has several identities when it comes to bank transactions. For example, names such as 'AMAZON EU S.A R.L.' or 'AMAZON PAYMENTS EUROPE S.C.A.' are used in banking transactions",
    fibuCreateTxAliasTextAfter: "Specify one or more aliases for your creditor below to improve the automatic assignment.",
    fibuCurrentAliasNames: "Current aliases",
    fibuNoAliasNamesPresent: "No aliases present",
    fibuFinancialYear: "Financial year",
    fibuFinancialMonth: "Booking month",
    fibuBalanceSheet: "Balance sheet",
    fibuIncomeSurplusCalculation: "Income-surplus calculation",
    fibuGeneralAccountType: "Account type",
    fibuHasSplits: "Splitted",
    fibuBookingMaskDefault: "Standard booking mask",
    fibuBookingMaskAccount: "Bank account booking mask",
    fibuBookingError: "Remarks",
    fibuConCreate: "Establish bank connection",
    fibuConMakeConnection: "Connect",
    fibuConRemoveConnection: "Disconnect",
    fibuConForwardFinapi: "Continue to login",
    finApiBankId: "FinApi BankId",
    fibuConCreateHelpText: "Enter your access data for your selected connection. Your entries will be transmitted to the bank in encrypted form.",
    fibuConCreateHelpText2: "The connection data is used exclusively to display sales and allocate bookings.",
    fibuTransactionsBooked: "Booked",
    fibuTransactionsAccountNumber: "Account Number",
    fibuTransactionsBankBookingDate: "Booking date",
    fibuTransactionsCounterpart: "Counterpart",
    fibuTransactionsPurpose: "Purpose",
    fibuTransactionsTotal: "Sum",
    fibuFinApiStatusPENDING: "Created",
    fibuFinApiStatusINPROGRESS: "In Progress",
    fibuFinApiStatusREADY: "Connected",
    fibuLocalBookingAccount: "Local booking account",
    fibuExportLexwareXml: "Lexware XML Export",
    fibuExportLexwareCsv: "Lexware CSV Export",
    fibuExportTotal: "Bookings total",
    fibuExportNewBookings: "New Bookings",
    fibuExportSelected: "Bookings selected",
    fibuExportNotSelected: "Bookings not selected",
    fibuRecurrence: "Day of execution",
    fibuBookedRecurring: "{{booking}} successfully transferred to batch bookings",
    fibuSplitCredit: "Credit",
    fibuSplitDebit: "Debit",
    fibuBookingSource: "Source",
    fibuImportReceipts: "Import Receipts",
    bookingSourceManual: "Manual",
    bookingSourceRecurring: "Template",
    bookingSourceFinApi: "FinApi",
    bookingSourceEmail: "Email",
    bookingSourceLexware: "Lexware",
    bookingSourceOcrImport: "OcrImport",
    finApiCreated: "Created",
    finApiPending: "Pending",
    finApiConnected: "Connected",
    finApiFailure: "Failure",
    finApiPaused: "Paused",
    generalExecutionDay: "Day of execution",
    generalInterval: "Interval",
    generalFormat: "Format",
    generalExport: "Export",
    generalDateFrom: "Date from",
    generalDateUntil: "Date until",
    generalCreatedBy: "Created by",
    generalStatus: "State",
    generalRegexPattern: "Regular expression",
    generalRegexCaptureGroup: "Regex capture group",
    generalAccountInfos: "Account information",
    generalGroupName: "Group",
    generalGroupAdd: "Add Group",
    generalBuyer: "Buyer",
    generalPieces: "Pieces",
    generalHours: "Hours",
    generalOrderIdShort: "Order no.",
    generalOrderId: "Order no.",
    generalReceiptNoShort: "Receipt no.",
    generalReceiptNo: "Receipt number",
    generalPosition: "Position",
    generalPositions: "Positions",
    generalReceiver: "Receiver",
    generalSent: "Sent",
    generalType: "Type",
    generalReadAll: "Read all",
    generalClearAll: "Clear all",
    generalExecute: "Execute",
    daily: "Daily",
    weekly: "Weekly",
    monthly: "Monthly",
    semiAnnual: "Semi-Annual",
    annual: "Annual",
    datevFormatJournalBased: "DATEV journal based",
    datevBookingBased: "DATEV booking based",
    datevStammdaten: "DATEV master data based",
    standardNetto: "Gross",
    standardBrutto: "Net",
    verkaufsrechnung: "Sales invoice",
    einkaufsrechnung: "Purchase invoice",
    verkaufsGutschrift: "Sales credit note",
    einkaufsGutschrift: "Purchase credit",
    verkaufsSchlussrechnung: "Final sales invoice",
    einkaufsSchlussrechnung: "Final purchase invoice",
    gutschriftsanzeige: "Credit advice",
    ausgangsrechnung: "Outgoing invoice",
    ausgehendeGutschrift: "Outgoing credit note",
    gutschriftanzeige: "Credit note",
    eingangsrechnung: "Incoming invoice",
    eingehendeGutschrift: "Incoming credit note",
    eingehendeZahlung: "Incoming payment",
    ausgehendeZahlung: "Outgoing payment",
    sachbuchung: "G/L posting",
    vortragsbuchung: "Lecture booking",
    eingehendeManuelleErfassung: "Incoming Manual Recording",
    ausgehendeManuelleErfassung: "Outgoing Manual Recording",
    skr03: "Skr-03",
    skr04: "Skr-04",

    emailIntegrationFormularCreate: "Create Email-Client",
    emailIntegrationFormularUpdate: "Update Email-Client",
    emailIntegrationFormularHelpTextPre: "Create a new global email client here. Fill in at least all mandatory fields.",
    emailIntegrationFormularHelpTextAfter: "This can be used for numerous features within the application.",
    emailIntegrationClientType: "Client Typ",
    emailIntegrationHost: "Host",
    emailIntegrationPort: "Port",
    emailIntegrationUserName: "Username",
    emailIntegrationPassword: "Password",
    emailIntegrationUseSsl: "UseSsl",
    emailIntegrationDescription: "Description",
    emailIntegrationLastUsed: "Last Used",
    emailConnectionStatus: "Connection Status",
    emailIntegrationTestReceiver: "Test mail receiver",
    emailTestConnection: "Test connection",
    connectionSuccessText: "Connection success",
    connectionFailedText: "Connection failed",


    ///CRM WORKFLOW
    workflowUsedIn: 'Used in {{count}} {{type}}',
    workflowAdd: 'Add new Workflow',
    workflowUpdate: 'Save Changes',
    workflowDiscard: 'Discard Changes',
    workflowAddStatus: 'Add Status',
    workflowAddTransition: 'Add Link',
    toDo: 'To-Do',
    product: 'Product',
    project: 'Project',
    noProject: 'No Projects Found',
    recruitment: 'Recruitment',
    name: 'Name',
    color: 'Farbe',
    description: 'Description',
    label: 'Link Label',
    from: 'From',
    to: 'To',
    save: 'Save',
    cancel: 'Cancel',
    workflowLinksToStates: 'Links to other Status',
    fromStatus: 'from Status',
    toStatus: 'to Status',
    transition: 'Transition',

    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly',
    Yearly: 'Yearly',
    recExpandAll: 'Expand All',
    recCollapseAll: 'Collapse All',
    recDateRangeSetting: 'Date Range',

    plannedHour: 'Planned Hours',
    estimatedHour: 'Estimated Hours',
    usedTime: 'Used up Time',
    user: 'User',

    addInvoice: 'Add Invoice',
    sendInvoice: "Send Invoice",
    paymentTarget: 'Payment planned on',
    paidOn: 'Paid on',
    paid: 'Paid',
    date: 'Date',
    amount: 'Amount',
    price: 'Cost',
    add: 'Add',
    remaining: 'Remaining',

    recDateOffset: '',
    recOpenDialog: 'Open Recurrence Dialoge',
    directiveStart: '',
    task: 'Task',
    recStart: 'Start',
    recDuration: 'Duration',
    recFrequency: 'Frequency',
    recInterval: 'Interval',
    recEnd: 'End',
    recEndOption: 'End Option',
    recCount: 'Count',
    recProjectView: 'Project view',
    recUserView: 'User view',
    addNewProject: 'Add new Project',
    addWorkflow: 'Add Workflow',
    workflowEditorShowEdgeLabel: 'Toggle Edge Labels',
    workflowEditorStatusSettings: 'Status Settings',
    workflowEditorEdgeSettings: 'Transition Settings',
    center: 'Center View',
    humanResourcesInvalidTimeInput: 'Invalid Input',

    //TimeManager
    timeManagerTaskListFav: 'Marked',
    timeManagerTaskListProj: 'Projects',
    timeManagerTaskListRecent: 'Recent',
    timeManagerTaskListAssigned: 'Assignment',
    timeManagerTaskListAll: 'All',
    timeManagerFavourite: 'Marked Tasks',
    timeManagerNotFavourite: 'Unmarked Tasks',
    timeManagerLow: '',
    timeManagerModerate: '',
    timeManagerHigh: '',
    timeManagerNone: '',
    timeManagerAssignedToMe: 'Assigned to Me',
    timeManagerNotAssignedToMe: 'Not Assigned to Me',
    timeManagerAll: 'All',
    timeManagerDisplayedCw: 'Displayed Calender Week:',
    timeManagerResetDate: 'Reset Date',
    timeManagerDndTable: 'Weekly Table',
    timeManagerWeeklyTables: '',
    timeManagerWorkTime: '',

    calendar_noEntries: "No entries for this day",
    calendar_event_type: "Event type",

    calendarTypeWorkTime: "Work time",
    calendarTypeVacation: "Vacation",
    calendarTypeTimeOff: "Time off in lieu",
    calendarTypeSick: "Sick",
    calendarTypeAppointment: "Appointment",
    calendarTypeUnknown: "Entry",

    calendar_allDay: "All day",
    yearCalendar_month_missingEntry_tooltip: 'Time entry is missing. Click to open the affected day.',
    calendar_dayPart: "Day part",
    calendar_carryOver: "Carry over",

    calendar_dayPartNone: "None",
    calendar_dayPartMorning: "Morning",
    calendar_dayPartAfternoon: "Afternoon",
    calendar_dayPartFullDay: "Full day",

    calendar_halfDay_disabled_tooltip: "Half-day entries are only available for a single day.",

    calendar_action_edit: "Edit",
    calendar_action_edit_tooltip: "Edit this entry",
    calendar_action_withdraw: "Withdraw",
    calendar_action_withdraw_tooltip: "Withdraw this pending request",
    calendar_action_cancel: "Cancel",
    calendar_action_cancel_tooltip: "Cancel this approved entry (keeps audit trail)",
    calendar_action_delete: "Delete",
    calendar_action_delete_tooltip: "Permanently remove this entry",
    calendar_action_approve: "Approve",
    calendar_action_approve_tooltip: "Approve this request",
    calendar_action_reject: "Reject",
    calendar_action_reject_tooltip: "Reject this request",
    calendar_action_showHistory: "Show history",
    calendar_action_showHistory_tooltip: "Show decision and change history",
    calendar_action_acceptInvitation: "Accept invitation",
    calendar_action_acceptInvitation_tooltip: "Accept this invitation",
    calendar_action_declineInvitation: "Decline invitation",
    calendar_action_declineInvitation_tooltip: "Decline this invitation",

    calendar_recurrence: "Recurrence",
    calendar_recurrencePreset: "Recurrence preset",

    calendar_recurrenceNone: "No recurrence",
    calendar_recurrenceDaily: "Daily",
    calendar_recurrenceWeekly: "Weekly",
    calendar_recurrenceWeekdays: "Weekdays Mon to Fri",
    calendar_recurrenceMonthly: "Monthly",

    calendar_recurrenceHintExample: "Example FREQ=WEEKLY;BYDAY=MO,WE,FR",
    calendar_currentWeek: "Calendar week",
    validation_rRuleMissing: "RRULE is missing",
    validation_invalidRRule: "Invalid recurrence rule",
    validation_invalidTimeZoneId: "Invalid time zone",

    calendar_help_allDay: "Automatically sets the time to a full day. Reporting treats this as a day based entry.",
    calendar_help_dayPart: "Defines whether this is counted as half day or full day. Mainly used for absences.",
    calendar_help_carryOver: "Flag for reporting and quotas. Used for vacation and time off in lieu.",
    calendar_help_recurrence: "Creates recurring entries. Available for work time and appointments.",

    calendar_summary_title: "Summary",
    calendar_summary_range: "Range",
    calendar_summary_duration: "Time span",
    calendar_summary_counting: "Counting",
    calendar_summary_recurrence: "Recurrence",
    calendar_summary_carryOverFlag: "Carry over enabled",

    calendar_summary_counting_timeSpan: "Counted based on the time span.",
    calendar_summary_counting_allDay: "Counted as all day.",
    calendar_summary_counting_dayPart: "Counted based on the day part.",

    calendar_section_required: "Required fields",
    calendar_recentTitles_label: "Recently used:",
    calendar_section_optional: "Optional fields",
    calendar_section_advanced: "Advanced",
    calendarEntryLabelShort_workTime: "WT",
    calendarEntryLabelShort_vacation: "V",
    calendarEntryLabelShort_timeOff: "TO",
    calendarEntryLabelShort_publicHoliday: "PH",
    calendarEntryLabelShort_sick: "S",
    calendarEntryLabelShort_appointment: "A",
    calendarEntryLabelShort_unknown: "E",
    calendarEntryLabel_workTime: "Work time",
    calendarEntryLabel_vacation: "Vacation",
    calendarEntryLabel_timeOff: "Time off",
    calendarEntryLabel_sick: "Sick leave",
    calendarEntryLabel_appointment: "Appointment",
    calendarEntryLabel_unknown: "Entry",

    validation_requiredTitle: "Title is required",
    validation_requiredProject: "Project is required",
    validation_requiredDescription: "Description is required",

    resetPermissionTooltip: "Resets all permissions to default values",
    notifyResetDone: "Standard permissions have been restored",
    roleProjectManager: "PJM",
    roleProjectManagerTip: "Project Manager",
    roleUser: "User",
    roleUserTip: "Standard User",
    roleHr: "HR",
    roleHrTip: "Human Resource Manager",
    roleBookkeeper: "Bk",
    roleBookkeeperTip: "Bookkeeper",
    roleFinancier: "FZ",
    roleFinancierTip: "Financier",
    roleOrderAndLicensing: "OL",
    roleOrderAndLicensingTip: "Ordering & Licensing",
    roleInventoryManager: "Inv",
    roleInventoryManagerTip: "Inventory Manager",
    roleProductManager: "PDM",
    roleAcquisitionManager: 'Acquisition Manager',
    roleBillingManager: 'Billing Manager',
    roleProductManagerTip: "Product Manager",
    userDetailsView: "User: {{username}}",
    userDetailsInfo: "Here you can view and edit all user information. It is also possible to assign rights. Be aware of the possible consequences of changes for the respective user.",
    userDetailsInfoTextAfter: "After saving, the user is immediately updated in Overview.",
    userSecurityInfo: "Here you can view and execute all security-relevant functions. Be aware of the possible consequences of changes for the respective user.",
    userSecurityInfoTextAfter: "After saving, the user is immediately updated in Overview.",
    userSecurityResetPw: "Reset password",
    userSecurityLastLogin: "Last Login",
    userSecurityLastPasswordChange: "Last password change",
    userSecurityLockoutEnd: "Locked until",
    userSecurityRegisteredSince: "Registered since",
    userSecurityIsActive: "Is Aktive",
    general: "General",
    generalActive: "Active",
    userSecurityPwSetSuccess: "Password successfully set.",
    userSecurityRequirePasswordChange: "User must change password after login",
    userSecurityGenerateTempPw: "Generate temporary password",
    userSecurityGenerateTempPwText: "Creates a new temporary password, unlocks the user and forces a password change after the next login.",
    userSecurityGenerateAndSendPw: "Generate and send",
    userSecurityTemporaryPwGeneratedSuccess: "Temporary password was generated and sent.",
    userSecurityLockUser: "Lockout user",
    userSecurityLockAndUnlock: "Lock & Unlock",
    userSecurityUnlockUser: "Unlock user",
    userSecurityLockoutUserSuccess: "User successfully locked out",
    userSecurityUnlockUserSuccess: "User successfully unlocked",
    userRolesInfo: "You can view and change all rights here. Be aware of the possible consequences of changes for the respective user.",
    userRolesInfoTextAfter: "After saving, the user is immediately updated in Overview.",
    userUpdatedSuccess: "User successfully updated",
    paymentEditTitle: "Edit Bankconnection",
    paymentEditHelpTextPre: "You can view and change your bank details here. Not all information is shown for security reasons. You can still update your bank details.",
    paymentEditHelpTextAfter: "After saving, the bank details are immediately updated in the overview.",
    projectHelpTextPre: "You can view and change your project details here.",
    projectHelpTextAfter: "After saving, the bank details are immediately updated in the overview.",
    projectTeamHelpTextPre: "Here you can view and change your project team. Be aware that users may be granted access to sensitive data if they are misassigned.",
    projectTeamHelpTextAfter: "After saving, the team is immediately updated in the overview.",
    sendInvoiceHelpTextPre: "Here you can send the selected invoice <strong>{{InvoiceNum}}</strong> and add optional recipients in addition to the contact <strong>{{ContactMail}}</strong>.",
    sendInvoiceHelpTextAfter: "Also make sure that the recipients entered are also authorized to view invoice information",
    sendInvoiceSuccess: "The invoice '{{InvoiceNum}}' was sent successfully.",
    helpTextBugTitle: "Enter a descriptive title for the bug",
    helpTextFrontendRoute: "On which page did the error occur, e.g., (/cp/home)",
    helpTextTicketType: "What exactly is noted?",
    helpTextDescription: "Describe the specific error and its impact if possible",
    helpTextStepToReproduce: "Step to reproduce (e.g. Click A, See B)",
    stepsToReproduce: "Steps to reproduce",
    stepToReproduceNr: "Step {{stepNo}}",
    bugTicketCreationSucceeded: "Your ticket has been successfully created",
    bugTicketCreationFailed: "Error while creating your bug ticket. Please try again later",
    userChangeRoleHint: "Users cannot change their roles themselves. Contact someone with a higher role",
    ticketTypeBug: "Bug",
    ticketTypeImprovement: "Improvement",
    ticketTypeFeatureRequest: "Feature-Request",
    changeNewsPreviewImage: "Upload Image",
    variableContextEnum: {
        Theme: 'Theme',
        Database: 'Database',
        Core: 'Core',
        Bookkeeping: 'Bookkeeping',
    },
    variableMutabilityEnum: {
        ReadOnly: 'Read only',
        WriteOnly: 'Write only',
        ReadAndWrite: 'Read and write',
    },
    variableTypeEnum: {
        String: 'Text',
        Integer: 'Integer',
        Color: 'Color',
        File: 'File',
        ComputedRuntimeInteger: 'Computed (integer)',
        ComputedRuntimeString: 'Computed (text)',
    },
    variableComposerHint: 'Type { to insert a variable or an available building block.',
    variableComposerDocumentToken: 'Document value',
    variableComposerGroupDocumentValues: 'Document values',
    variableComposerGroupVariables: 'Variables',
    variableComposerDocumentHelpTitle: 'Compose document number',
    variableComposerDocumentHint: 'Use {number} for the next free document number, {revision} for the revision and {yy} for the two-digit document year. invoice_last_receipt_no is informational only and must not replace the new document number. Type { for more building blocks or variables.',
    variableComposerRecommendedFormat: 'Recommended format',
    variableTokenNumber: 'Next document number',
    variableTokenNumberDescription: 'The next free document number allocated when the document is finalized',
    variableTokenNumberPadded: 'Four digit document number',
    variableTokenNumberPaddedDescription: 'Next document number padded with leading zeroes',
    variableTokenRevision: 'Revision',
    variableTokenRevisionDescription: 'Revision of the concrete document',
    variableTokenRevisionPadded: 'Two digit revision',
    variableTokenRevisionPaddedDescription: 'Revision padded with leading zeroes',
    variableTokenYearLong: 'Four digit year',
    variableTokenYearLongDescription: 'Year of the document date, e.g. 2026',
    variableTokenYearShort: 'Two digit year',
    variableTokenYearShortDescription: 'Year of the document date, e.g. 26',
    variableTokenMonth: 'Month',
    variableTokenMonthDescription: 'Month of the document date, e.g. 09',
    variableTokenDay: 'Day',
    variableTokenDayDescription: 'Day of the document date, e.g. 12',
    variableName: {
        core_current_year: 'Current year',
        core_current_month: 'Current month',
        core_current_day: 'Current day',
        customer_start_index: 'Customer start number',
        invoice_start_index: 'Invoice start number',
        offer_start_index: 'Offer start number',
        billing_invoice_number_format: 'Invoice number format',
        billing_offer_number_format: 'Offer number format',
        invoice_last_receipt_no: 'Last invoice number',
    },
    variableDescription: {
        billing_invoice_number_format: 'Defines how new invoice numbers are composed. The next free number is inserted transaction-safely with {number}; normal variables can additionally be referenced with {var:name}.',
        billing_offer_number_format: 'Defines how new offer numbers are composed. The next free number is inserted with {number}; normal variables can additionally be referenced with {var:name}.',
    },
    variableContext: "Context",
    variableValue: "Value",
    variableResolveFailed: 'Could not be resolved',
    variableResolvedValue: 'Resolved value',
    variableNameLabel: "Variable Name",
    variableNameToolTip: "Name of the variable",
    variableNamePlaceholder: "Name of the variable",
    variableContextLabel: "Variable Context",
    variableContextToolTip: "Context (group) of the variable",
    variableContextPlaceholder: "Context (group) of the variable",
    variableValueLabel: "Variable Value",
    variableValueToolTip: "Value of the variable",
    variableValuePlaceholder: "Value of the variable",
    variableHelpTextPre: "In the following form, you can update the value of a single variable.",
    variableHelpTextAfter: "Variables are predefined by the system and can only be viewed and updated. Creating a variable is only done by the developers.",

    ///After this point adhere to the described standard!!!!!
    /// Translation keys shall conform to the specified format:
    /// {{module Name}}_{{component Name}}_{{meaning}}_{{usage}}
    /// module Name: name of the module in which the key will be used
    /// component Name: name of the component in which the key will be used
    /// meaning: what the key is intended to represent(e.g. login)
    /// usage: what the key will be used as (e.g. label, header, button)
    /// example: auth_login_resetPassword_link
    /// Exception:
    /// general use translation keys (e.g. save, cancel, continue, password,.....) shall fall under the module general and
    /// do not require a component
    /// example: general_save_button

    general_title:'Title',
    general_name:'Name',
    general_user: 'User',
    general_employee:'Employee',
    general_firstName:'First Name',
    general_lastName:'Last Name',
    general_email:'E-Mail',
    general_phone:'Phone',
    general_mobile:'Mobile',
    general_address:'Address',
    general_country:'Country',
    general_federalState:'Federal State',
    general_city:'City',
    general_zipCodeShort:'ZipCode',
    general_zipCode:'Zip-Code',
    general_streetName:'Street Name',
    general_streetNumber:'Street Number',
    general_company:'Company',
    general_salutation:'Salutation',
    general_description:'Description',
    general_website:'Website',
    general_department:'Department',
    general_save:'Save',
    general_delete: 'Delete',
    general_edit: 'Edit',
    general_chooseState:'Select a state',
    general_create:'Create',
    general_empty:'-- empty --',
    general_role:'Role',
    general_currentStatus:'Current Status',
    general_contact:'Contacts',
    general_project:'Project',
    general_excelImport:'Import Excel',
    general_index:'Index',
    general_startDate:'Start date',
    general_startTime:'Start time',
    general_endDate:'End date',
    general_endTime:'End time',
    general_hrsShort: "hrs",
    general_clockSuffix: "",
    general_duration: "Duration",
    general_none:'',
    general_pending:'Pending',
    general_accepted:'Accepted',
    general_rejected:'Rejected',
    general_canceled:'Canceled',
    general_vacation:'Holiday',
    general_sick:'Sick',
    general_timeOff:'Time off',
    general_publicHolidays: 'Public holidays',
    general_publicHoliday: 'Public holiday',
    general_days: "Days",
    general_day: "Day",
    general_currentWorkflow: "Current Workflow",
    general_backendId:'Backend Id',
    general_customerNumber: 'Customer number',
    general_phone_hint: 'International format: +49 123 456789',

    ///Controller
    //General
    controller_general_delete_success:'{{number}} {{entity}} successfully deleted.',

    //Task
    controller_task_deleteSingleText_Label:'are you sure you want to delete one Task?',
    controller_task_deleteMultiText_Label:'are you sure you want to delete {{number}} Tasks?',

    ///App
    //Navigation
    app_navigation_timeManagement_label:'Time Tracking',
    app_navigation_task_label:'Tasks',
    app_navigation_vacationManagement_label:'Vacation management',
    app_navigation_vacationApproval_label:'Vacation Application',

    ///crm
    //Company
    crm_company_basicInfo_tabLabel:'Basic Info',
    crm_company_basicInfo_description:'Manage company master data, contact information and tax details.',
    crm_company_addressInfo_description:'Manage company addresses and default addresses.',
    crm_company_bankAccounts_description:'Manage the company bank accounts.',

    crm_company_departments_tabLabel:'Departments',
    crm_company_departments_description:'Manage company departments and make them available for assignments.',
    crm_company_resource_description:'View assigned contacts. Contacts are edited on the contacts page.',
    crm_contact_basicInfo_tabLabel:'Contact',
    crm_contact_basicInfo_description:'Manage contact details and the assigned company.',
    crm_company_addressInfo_tabLabel:'Addresses',
    crm_company_bankAccounts_tabLabel:'Bank Accounts',
    crm_company_resource_tabLabel:'Resources',
    crm_company_toResources_button:'Navigate to Contacts page',

    //Task
    crm_task_taskName_label:'Task',
    crm_contract_customerFacingId_label:'set ID',
    crm_contract_taskRisks_label:'Risks',
    crm_contract_taskClarifications_label:'Clarifications',
    crm_contract_taskBudget_label:'Budget',
    crm_contract_taskCurrentEstimated_label:'Est.',
    crm_contract_connectedContacts_label:'Contacts',
    crm_contract_taskCurrentStart_label:'Start',
    crm_contract_taskCurrentEnd_label:'End',
    crm_contract_taskEstimatedEffortSum_label:'Est. Task Duration',
    crm_contract_taskActualEffortSum_label:'Task Duration',
    crm_contract_category_label:'Category',
    crm_task_currentStart_label:'Current Start',
    crm_task_currentEnd_label:'Current End',
    crm_task_currentEst_label:'Current Estimated',
    crm_task_currentPlanned_label:'Current Planned',
    crm_task_effortTypes_label:'Effort Types',
    crm_task_duration_label:'Est Duration',
    crm_task_actualDuration_label:'Actual Duration',
    crm_task_entityName:'Tasks',
    crm_task_details_sectionTitle:'Task Details',
    crm_task_id_label:'ID',
    crm_task_taskId_label:'Task ID',
    crm_task_taskType_label:'Task Type',
    crm_task_mockup_label:'Mockups',
    crm_task_contact_label:'Contact',
    crm_task_references_label:'References',
    crm_task_originalStart_label:'Original Start',
    crm_task_originalEnd_label:'Original End',
    crm_task_originalEstimated_label:'Original Estimate',
    crm_task_recentAppointments_label:'Recent Appointments',
    crm_contract_referencedTasks_label:'Referenced Tasks',
    crm_contract_referencedByTasks_label:'Referenced By',
    crm_contract_taskEffort_label:'Efforts',

    //TaskEffort
    crm_taskEffort_effortName_label:'Effort',

    //Address Info
    crm_addressInfo_table_header:'Saved Addresses',
    crm_addressInfo_multiDelete_text:'are you sure you want to delete {{number}} Addresses?',

    //Projects
    crm_projects_addTeamMember_header:'Add Team Member',
    crm_projects_nextBill_tableHeader:'Next Bill',

    //Contacts
    crm_contacts_multiDelete_text:'are you sure you want to delete {{number}} contacts?',
    crm_basicContactInfo_header_header:'Contact Information',
    crm_basicContactInfo_description_label:'Here you can view the information of a chosen contact edit it or create a new one.',

    //Company
    crm_company_multiDelete_text:'are you sure you want to delete {{number}} Companies?',

    ///Resource Manager
    //Human Resources
    resourceManager_humanResources_noTaskOnProject_label:'No task assigned to this Project',
    resourceManager_humanResources_addTask_label:'Create new Task for this Project',

    partialViews_dialog_calendarExport_header: "Export timesheets",
    resourceManager_calendarExport_users_label:'Select users',
    resourceManager_calendarExport_summary_title:'Export summary',
    resourceManager_calendarExport_currentUserFallback_label:'Current user',
    resourceManager_calendarExport_usersSelected_label:'users selected',
    resourceManager_calendarExport_invalidRange_label:'The end date must be after the start date.',
    resourceManager_calendarExport_missingCustomerAddress_label:'No address configured for the customer.',
    resourceManager_calendarExport_project_label:'Project',
    resourceManager_calendarExport_separateFiles_label:'Create separate PDF files per user',
    resourceManager_calendarExport_invoiceSplitByMember_label:'Split invoice positions by employee',
    resourceManager_calendarExport_invoiceSplitByMember_hint:'Creates one time based invoice line per selected employee. Without this option, the selected time is summarized into one line.',
    resourceManager_calendarExport_createInvoice_label:'Create invoice draft',
    resourceManager_calendarExport_createInvoice_hint:'Select at least one employee. Project, period and selection are passed directly to the invoice. Timesheets can also be exported from the invoice workflow.',
    resourceManager_calendarExport_separateFiles_hint:'When multiple users are selected, one separate timesheet is created for each user.',
    resourceManager_calendarExport_outputMode_label:'Output',
    resourceManager_calendarExport_outputMode_singleFile_label:'One combined PDF file',
    resourceManager_calendarExport_outputMode_separateFiles_label:'Multiple PDF files',
    users:'Users',

    //TimeTracker
    resourceManager_timeTracker_onPageLeave_label:'Unsaved Entries',
    resourceManager_timeTracker_dismiss_label:'Dismiss entries',
    resourceManager_timeTracker_saveUnused_label:'Save unsaved entries',
    resourceManager_timeTracker_returnToCurrentWeek_button:'Return to Current Week',
    resourceManager_timeTracker_currentWeek_label:'Calender Week',
    resourceManager_timeTracker_currentViewed_label:'Currently Viewing',
    resourceManager_timeTracker_taskListAll_label:'All',
    resourceManager_timeTracker_openOvertime_label:'Overtime',

    //CalendarStatistics
    resourceManager_calendarStatistic_yearStats_tabHeader: 'Yearly statistics',
    resourceManager_calendarStatistic_weekStats_tabHeader: 'Weekly statistics',
    resourceManager_calendarStatistic_monthStats_tabHeader: 'Monthly statistics',
    resourceManager_calendarStatistic_monthSection_label: 'Month',
    resourceManager_calendarStatistic_monthForecastHours_label: 'Forecast monthly hours',
    resourceManager_calendarStatistic_monthAverageHours_label: 'Average per workday',
    resourceManager_calendarStatistic_monthPreviousAverageHours_label: 'Previous month average',
    resourceManager_calendarStatistic_monthAverageDelta_label: 'Compared with previous month',
    resourceManager_calendarStatistic_yearAverageHours_label: 'Average per available workday',
    resourceManager_calendarStatistic_yearAverageWeekHours_label: 'Average per available Week',
    resourceManager_calendarStatistic_workTimeSection_label: 'Working time',
    resourceManager_calendarStatistic_overtimeSection_label: 'Overtime',
    resourceManager_calendarStatistic_absencesCreditsSection_label: 'Absences & credits',
    resourceManager_calendarStatistic_vacationSection_label: 'Vacation',

    resourceManager_calendarStatistic_weeklyTargetHours_label: 'Weekly hours',

    resourceManager_calendarStatistic_vacationDaysEntitled_label: 'Vacation days per year',
    resourceManager_calendarStatistic_vacationDaysTaken_label: 'Vacation days taken so far',
    resourceManager_calendarStatistic_vacationDaysPlanned_label: 'Planned vacation days',
    resourceManager_calendarStatistic_vacationDaysAvailableNow_label: 'Vacation currently available',
    resourceManager_calendarStatistic_vacationCarryOver_label: 'Vacation carryover currently available',
    resourceManager_calendarStatistic_vacationCarryOverDeadlineNext_label: 'Next vacation carryover expiry date',
    resourceManager_calendarStatistic_vacationCurrentYearUsed_label: 'Used from the selected year entitlement',
    resourceManager_calendarStatistic_vacationCurrentYearPlanned_label: 'Planned from the selected year entitlement',
    resourceManager_calendarStatistic_vacationCurrentYearRemaining_label: 'Remaining entitlement from the selected year',
    resourceManager_calendarStatistic_vacationCarryOverFromPreviousYear_label: 'Carryover from the previous year at year start',
    resourceManager_calendarStatistic_vacationCarryOverUsed_label: 'Already taken from carryover',
    resourceManager_calendarStatistic_vacationCarryOverPlanned_label: 'Already planned from carryover',
    resourceManager_calendarStatistic_vacationCarryOverExpired_label: 'Expired carryover',
    resourceManager_calendarStatistic_vacationBalanceExplanation_text: 'Total available vacation is the sum of the remaining entitlement from the selected year and the unused, unexpired carryover from the previous year. Carryover is consumed first.',

    resourceManager_calendarStatistic_sickDaysTaken_label: 'Sick days so far',

    resourceManager_calendarStatistic_overtimeAvailableNow_label: 'Current overtime balance',
    resourceManager_calendarStatistic_overtimeRawCurrentYear_label: 'Overtime this year',
    resourceManager_calendarStatistic_overtimeCarryOver_label: 'Overtime carryover currently available',
    resourceManager_calendarStatistic_overtimeCarryOverDeadlineNext_label: 'Next overtime carryover expiry date',

    resourceManager_calendarStatistic_expectedHours_label: 'Target hours',
    resourceManager_calendarStatistic_availableWorkingHours_label: 'Available working time',
    resourceManager_calendarStatistic_adjustedExpectedHours_label:'Target hours with overtime balance',
    resourceManager_calendarStatistic_overtimeBalanceBeforeWeek_label:'Overtime balance before week start',
    resourceManager_calendarStatistic_overtimeBalanceAfterWeek_label:'Overtime balance at week end',
    resourceManager_calendarStatistic_overtimeBalanceBeforeMonth_label:'Overtime balance at month start',
    resourceManager_calendarStatistic_overtimeBalanceAfterMonth_label:'Overtime balance at month end',
    resourceManager_calendarStatistic_workedHours_label: 'Worked hours',
    resourceManager_calendarStatistic_creditablePerformanceHours_label: 'Creditable actual hours',
    resourceManager_calendarStatistic_sickDays_label: 'Sick days',
    resourceManager_calendarStatistic_absenceCreditHours_label: 'Absence credit hours',
    resourceManager_calendarStatistic_publicHolidayCreditHours_label: 'Public holiday credit hours',
    resourceManager_calendarStatistic_overtimeHours_label: 'Overtime',
    resourceManager_calendarStatistic_remainingHours_label: 'Remaining hours',
    resourceManager_calendarStatistic_publicHolidayDays_label: 'Public holidays',
    resourceManager_calendarStatistic_possibleWorkingDays_label: 'Possible working days',

    resourceManager_projectStatistics_budget_tabTitle: "Budget",
    resourceManager_projectStatistics_budget_tabName: "Budget",
    resourceManager_projectStatistics_years_tabTitle: "Timeline",
    resourceManager_projectStatistics_years_tabName: "Timeline",
    resourceManager_projectStatistics_users_tabTitle: "Employees",
    resourceManager_projectStatistics_users_tabName: "Employees",
    resourceManager_projectStatistics_filter_label: "Display",
    resourceManager_projectStatistics_refresh_button: "Refresh",
    resourceManager_projectStatistics_projects_statLabel: "Projects",
    resourceManager_projectStatistics_totalBudget_statLabel: "Total budget",
    resourceManager_projectStatistics_openBudget_statLabel: "Open budget",
    resourceManager_projectStatistics_plannedHours_statLabel: "Planned hours",
    resourceManager_projectStatistics_actualHours_statLabel: "Actual hours",
    resourceManager_projectStatistics_deltaHours_statLabel: "Delta",
    resourceManager_projectStatistics_filter_all_option: "All projects",
    resourceManager_projectStatistics_filter_open_option: "Open budget only",
    resourceManager_projectStatistics_filter_worked_option: "With actual hours only",
    resourceManager_projectStatistics_totalBudget_label: "Total budget",
    resourceManager_projectStatistics_openBudget_label: "Open budget",
    resourceManager_projectStatistics_usedBudget_label: "Used",
    resourceManager_projectStatistics_plannedHours_label: "Planned hours",
    resourceManager_projectStatistics_actualHours_label: "Actual hours",
    resourceManager_projectStatistics_deltaHours_label: "Delta",
    resourceManager_projectStatistics_budgetUsage_label: "Budget usage",
    resourceManager_projectStatistics_userName_header: "Name",
    resourceManager_projectStatistics_userPlannedHours_header: "Planned hours",
    resourceManager_projectStatistics_userActualHours_header: "Actual hours",
    resourceManager_projectStatistics_year_header: "Year",
    resourceManager_projectStatistics_appointments_header: "Appointments",
    resourceManager_projectStatistics_worklogs_header: "Worklogs",
    resourceManager_projectStatistics_yearPlannedHours_header: "Planned",
    resourceManager_projectStatistics_yearActualHours_header: "Actual",
    resourceManager_projectStatistics_yearDeltaHours_header: "Delta",
    resourceManager_projectStatistics_customer_columnLabel: "Customer",
    resourceManager_projectStatistics_project_columnLabel: "Project",
    resourceManager_projectStatistics_totalBudget_columnLabel: "Total budget",
    resourceManager_projectStatistics_openBudget_columnLabel: "Open budget",
    resourceManager_projectStatistics_plannedHours_columnLabel: "Planned hours",
    resourceManager_projectStatistics_actualHours_columnLabel: "Actual hours",
    resourceManager_projectStatistics_workedInPeriod_columnLabel: "Worked in period",
    resourceManager_projectStatistics_workedOverall_columnLabel: "Worked overall",
    resourceManager_projectStatistics_budgetConsumedTotal_columnLabel: "Total budget usage",
    resourceManager_projectStatistics_deltaHours_columnLabel: "Delta",
    resourceManager_projectStatistics_teamMembers_columnLabel: "Team members",
    resourceManager_projectStatistics_tasks_columnLabel: "Tasks",
    resourceManager_projectStatistics_coverageFrom_columnLabel: "Coverage from",
    resourceManager_projectStatistics_coverageTo_columnLabel: "Coverage to",
    resourceManager_projectStatistics_table_label: "Project statistics",
    resourceManager_projectStatistics_noYears_label: "No yearly statistics available",
    resourceManager_projectStatistics_noUsers_label: "No employee statistics available",
    resourceManager_projectStatistics_period_label: "Period",
    resourceManager_projectStatistics_period_all_option: "Overall",
    resourceManager_projectStatistics_period_year_option: "Year",
    resourceManager_projectStatistics_projectsOverview_tabLabel: "Projects",
    resourceManager_projectStatistics_projectsOverview_title: "Project overview",
    resourceManager_projectStatistics_projectsOverview_description: "All project budgets across the complete lifetime. Open a project to inspect the total budget or analyse usage by year, month or a custom date range.",
    resourceManager_projectStatistics_personProjectYear_tabLabel: "Employees",
    resourceManager_projectStatistics_personProjectYear_title: "Budget usage by employee",
    resourceManager_projectStatistics_personProjectYear_description: "Shows budget usage by employee for the selected period.",
    resourceManager_projectStatistics_personProjectYear_tableLabel: "Budget usage by employee",
    resourceManager_projectStatistics_personProjectYear_empty: "No recorded project work time is available for the selected period.",
    resourceManager_projectStatistics_employees_statLabel: "Employees",
    resourceManager_projectStatistics_worklogs_statLabel: "Worklogs",
    resourceManager_projectStatistics_totalWorkedHours_statLabel: "Total hours",
    resourceManager_projectStatistics_employee_columnLabel: "Employee",
    resourceManager_projectStatistics_firstBooking_columnLabel: "First booking",
    resourceManager_projectStatistics_lastBooking_columnLabel: "Last booking",
    resourceManager_projectStatistics_orderedBudgetHours_statLabel: "Contracted hours",
    resourceManager_projectStatistics_budgetConsumedHours_statLabel: "Hours worked",
    resourceManager_projectStatistics_budgetRemainingHours_statLabel: "Remaining budget",
    resourceManager_projectStatistics_invoicedHours_statLabel: "Invoiced",
    resourceManager_projectStatistics_unassignedHours_statLabel: "Without budget",
    resourceManager_projectStatistics_coveredHours_statLabel: "Budget covered",
    resourceManager_projectStatistics_uncoveredHours_statLabel: "Without budget",
    resourceManager_projectStatistics_orderedBudgetHours_columnLabel: "Contracted h",
    resourceManager_projectStatistics_budgetConsumedHours_columnLabel: "Worked h",
    resourceManager_projectStatistics_budgetRemainingHours_columnLabel: "Remaining h",
    resourceManager_projectStatistics_invoicedHours_columnLabel: "Invoiced h",
    resourceManager_projectStatistics_unassignedHours_columnLabel: "No budget h",
    resourceManager_projectStatistics_legacyProjectVolume_columnLabel: "Project volume €",
    resourceManager_projectStatistics_coveredHours_header: "Budget covered",
    resourceManager_projectStatistics_uncoveredHours_header: "Without budget",
    resourceManager_projectStatistics_assignedBudgetHours_header: "Contracted h",
    resourceManager_projectStatistics_remainingAssignedBudgetHours_header: "Remaining h",
    resourceManager_projectStatistics_orderedBudgetHours_label: "Contracted hours",
    resourceManager_projectStatistics_budgetConsumedHours_label: "Hours worked against budget",
    resourceManager_projectStatistics_budgetRemainingHours_label: "Theoretical remaining budget",
    resourceManager_projectStatistics_invoicedHours_label: "Invoiced",
    resourceManager_projectStatistics_unbilledWorkedHours_label: "Not yet invoiced",
    resourceManager_projectStatistics_unassignedHours_label: "Work time without budget assignment",
    resourceManager_projectStatistics_contractValue_label: "net contract value",
    resourceManager_projectStatistics_consumedValue_label: "value of incurred hours",
    resourceManager_projectStatistics_employeeBudgetSummary_title: "Budget by employee",
    resourceManager_projectStatistics_employeeBudgetSummary_description: "Cumulative view across all personal budget pools. Open follow-up budgets are treated as one continuous budget chain.",
    resourceManager_projectStatistics_employeeBudgetCurrent_title: "Current employee budgets",
    resourceManager_projectStatistics_employeeBudgetCurrent_description: "Current balance of personal budgets for this project.",
    resourceManager_projectStatistics_employeeBudgetMonthEnd_title: "Employee budgets at the last month end",
    resourceManager_projectStatistics_employeeBudgetMonthEnd_description: "Personal budget balance for this project as of {{date}}.",
    resourceManager_projectStatistics_budgetLines_title: "Budget lines",
    resourceManager_projectStatistics_budgetLines_description: "Contracts and budget pools with period, employee, consumption and invoicing status.",
    resourceManager_projectStatistics_sharedBudget_label: "Shared project pool",
    resourceManager_projectStatistics_openEnded_label: "open",
    resourceManager_projectStatistics_sourceOffer_label: "Offer",
    resourceManager_projectStatistics_orderedShort_label: "Contracted",
    resourceManager_projectStatistics_actualShort_label: "Worked",
    resourceManager_projectStatistics_budgetConsumedShort_label: "Consumed",
    resourceManager_projectStatistics_employeeShort_label: "Employee",
    resourceManager_projectStatistics_startShort_label: "Start",
    resourceManager_projectStatistics_endShort_label: "End",
    resourceManager_projectStatistics_remainingShort_label: "Remaining",
    resourceManager_projectStatistics_invoicedShort_label: "Invoiced",
    resourceManager_projectStatistics_unbilledShort_label: "Not yet invoiced",
    resourceManager_projectStatistics_hourlyRateShort_label: "Hourly rate",
    resourceManager_projectStatistics_preStartAssigned_suffix: "assigned before budget start",
    resourceManager_projectStatistics_noContractBudget_label: "No hourly budget has been configured for this project yet. Recorded time is therefore shown as work time without budget assignment.",
    resourceManager_projectStatistics_overview_tabTitle: "Overview",
    resourceManager_projectStatistics_overview_tabName: "Overview",
    resourceManager_projectStatistics_employees_tabTitle: "Employees",
    resourceManager_projectStatistics_employees_tabName: "Employees",
    resourceManager_projectStatistics_timeline_tabTitle: "Timeline",
    resourceManager_projectStatistics_timeline_tabName: "Timeline",
    resourceManager_projectStatistics_statistics_tabTitle: "Statistics",
    resourceManager_projectStatistics_statistics_tabName: "Statistics",
    resourceManager_projectStatistics_statistics_title: "Project analysis",
    resourceManager_projectStatistics_statistics_description: "Analyses only the selected project. The complete project lifetime is shown by default; year, month and custom ranges filter usage only, never the contracted total budget.",
    resourceManager_projectStatistics_analysisLoading_label: "Loading project statistics …",
    resourceManager_projectStatistics_period_month_option: "One month",
    resourceManager_projectStatistics_period_range_option: "Custom range",
    resourceManager_projectStatistics_customRange_label: "Date range",
    resourceManager_projectStatistics_rangeFrom_placeholder: "From",
    resourceManager_projectStatistics_rangeTo_placeholder: "To",
    resourceManager_projectStatistics_applyRange_button: "Apply",
    resourceManager_projectStatistics_workedInPeriod_statLabel: "Worked in period",
    resourceManager_projectStatistics_workedOverall_statLabel: "Worked overall",
    resourceManager_projectStatistics_employees_tabLabel: "Employees",
    resourceManager_projectStatistics_employees_title: "Budget and work time by employee",
    resourceManager_projectStatistics_employees_description: "Shows ordered, worked, budget-covered and invoiced hours per employee. Remaining hours show the current balance of employee-specific budgets.",
    resourceManager_projectStatistics_employees_empty: "No employees with project work time or budget were found for the selected period.",
    resourceManager_projectStatistics_timeline_tabLabel: "Timeline",
    resourceManager_projectStatistics_timeline_title: "Work time and budget usage over time",
    resourceManager_projectStatistics_timeline_description: "Monthly view of worked, budget-covered and invoiced hours. Budget is not distributed artificially across months; only actual usage is shown.",
    resourceManager_projectStatistics_timeline_empty: "No project work time was found for the selected period.",
    resourceManager_projectStatistics_month_columnLabel: "Month",
    resourceManager_projectStatistics_utilization_columnLabel: "Utilization",
    resourceManager_projectStatistics_projectEmployees_title: "Employees in this project",
    resourceManager_projectStatistics_projectEmployees_description: "Work time and budget status per employee for the currently selected period.",
    resourceManager_projectStatistics_projectTimeline_title: "Project timeline",
    resourceManager_projectStatistics_projectTimeline_description: "Monthly project work time split by employee and budget coverage.",
    resourceManager_projectStatistics_manageBudget_button: "Manage budget",
    resourceManager_projectStatistics_projectNotFound_error: "Project could not be loaded.",

    resourceManager_projectStatistics_snapshotAsOf_label: "As of {{date}}",
    resourceManager_projectStatistics_budgetExport_button: "Export budget",
    resourceManager_projectStatistics_budgetExport_title: "Budget export",
    resourceManager_projectStatistics_budgetExport_description: "Exports the budget timeline through today. Accumulation is chronological by month or week; hidden budgets do not change how work time is allocated.",
    resourceManager_projectStatistics_budgetExport_accumulation_label: "Accumulation",
    resourceManager_projectStatistics_budgetExport_monthly_option: "Monthly",
    resourceManager_projectStatistics_budgetExport_weekly_option: "Weekly",
    resourceManager_projectStatistics_budgetExport_includeRates_label: "Include hourly rates and budget values",
    resourceManager_projectStatistics_budgetExport_budgets_label: "Budgets",
    resourceManager_projectStatistics_budgetExport_budgets_hint: "Only selected budgets are included in the file.",
    resourceManager_projectStatistics_budgetExport_selectAll_label: "Select all",
    resourceManager_calendarStatistic_importantValues_label: "Important at a glance",
    resourceManager_calendarStatistic_advancedDetails_label: "More details",
    resourceManager_projectStatistics_personalBudgetHours_columnLabel: "Personal budget h",
    resourceManager_projectStatistics_personalRemainingHours_columnLabel: "Personal remaining h",
    resourceManager_projectStatistics_sharedPoolUsed_columnLabel: "From project pool h",

    //bannerItem
    resourceManager_bannerItem_halfDay_label: '1/2 {{type}} day',

    //VacationManagement
    resourceManager_vacationManager_vacationStats_header:'Vacations in given year',
    resourceManager_vacationManager_addNewEntry_label:'Add new Vacation',
    resourceManager_vacationManager_addNewEntry_header: 'Add new absence',
    resourceManager_vacationManager_filterView_label: 'Type',
    resourceManager_vacationManager_save_tooltip: 'Save absence',
    resourceManager_vacationManager_save_disabled_tooltip: 'Check start, end and type before saving.',
    resourceManager_vacationManager_save_success: 'The absence was saved.',
    resourceManager_vacationManager_save_error: 'The absence could not be saved. Please try again.',
    resourceManager_absenceOverview_resetYear_label: 'Current year',
    resourceManager_absenceOverview_currentYear_label: 'Current year',

    //AbsenceManager
    resourceManager_absenceManager_personalView_lable:'Single view',
    resourceManager_absenceManager_generalView_lable:'Company view',

    //VacationApproved
    resourceManager_vacationApproved_application_header:'Vacation Application',
    resourceManager_vacationApproved_application_description: 'Manage pending and previous vacation requests. Pending requests are shown by default.',
    resourceManager_vacationApproved_revert_button: 'Revert decision',
    resourceManager_vacationApproved_revert_text: 'Do you really want to revert the decision and set the request back to pending?',
    resourceManager_vacationApproved_pending_label:'Pending',
    resourceManager_vacationApproved_history_label:'History',
    resourceManager_vacationApproved_viewSelect_label:'Select View',
    resourceManager_vacationApproved_rejectAll_button:'Reject all selected Applications',
    resourceManager_vacationApproved_approveAll_button:'Approve all selected Applications',
    resourceManager_vacationApproved_durationInDay_label:'Vacation duration in days',
    resourceManager_vacationApproved_decisionStatus_label:'Decision status',
    resourceManagerVacationApprovalDecisionStatus: {
        None: 'No status',
        Pending: 'Pending',
        Accepted: 'Accepted',
        Rejected: 'Rejected',
        Cancelled: 'Cancelled',
    },
    resourceManager_vacationApproved_reason_label:'Reason',
    resourceManager_vacationApproved_withdraw_text:'Do you really want to withdraw this pending request?',
    resourceManager_vacationApproved_cancel_text:'Do you really want to cancel this approved entry? The audit history will be kept.',
    resourceManager_vacationApproved_multiDelete_text:'are you sure you want to decline {{number}} vacation applications?',
    resourceManager_vacationApproved_delete_text: "Are you sure you want to delete the request?",

    ///Partial Views
    //Dialog
    //Confirmation
    partialViews_dialog_confirmationDefaultText_label:'Are you sure?',
    partialViews_dialog_confirmationDefaultNo_button:'No',
    partialViews_dialog_confirmationDefaultYes_button:'Yes',

    //TimeManagerEntry
    partialViews_dialog_addTimeEntry_header:'Log working time',

    ///Formulars
    //Project Team Formular
    formular_projectTeam_helpText_text:'Here you can view and edit your project team. Be aware that incorrectly assigned users may be granted access to sensitive data.\nAfter saving, the project will be immediately updated in the overview.',

    //Bank Account Formular
    formular_bankAccount_table_title:'Saved Bank Accounts',
    formular_bankAccount_accountOwner_label:'Account Owner',
    formular_bankAccount_bankName_label:'Bank Name',
    formular_bankAccount_iban_label:'IBan',
    formular_bankAccount_bic_label:'BIC',
    formular_bankAccount_billingAccountOnly_label:'Billing Account only',
    formular_bankAccount_default_label:'Default Account',
    formular_bankAccount_multiDelete_text:'are you sure you want to delete {{number}} Bank accounts?',
    formular_bankAccount_iban_hint: 'e.g. DE89 3704 0044 0532 0130 00',
    formular_bankAccount_bic_hint: 'e.g. COBADEFFXXX',


    general_save_button: 'Save',
    general_cancel_button: 'Cancel',
    general_comingSoon_label: 'Coming soon',

    account_account_eyebrow_label: 'Account',
    account_account_title_header: 'My account',
    account_account_description_text: 'Personal settings, security, integrations, and individual workspace options.',

    account_account_profileStat_label: 'Profile',
    account_account_profileStat_complete_value: 'Complete',
    account_account_profileStat_incomplete_value: 'Incomplete',
    account_account_profileStat_complete_hint: 'Your profile is fully completed.',
    account_account_profileStat_incomplete_hint: 'Your profile is not fully completed yet.',
    account_account_profileStat_hint: 'Master data maintained',

    account_account_integrationsStat_label: 'Integrations',
    account_account_integrationsStat_value: '{{count}} active',
    account_account_integrationsStat_hint: 'Active connections',

    account_account_securityStat_label: 'Security',
    account_account_securityStat_value: '{{count}} notice',
    account_account_securityStat_hint: 'Recommended reviews',

    account_account_accountSection_header: 'Account',
    account_account_accountSection_text: 'Personal data and basic account information',

    account_account_personalData_header: 'Personal data',
    account_account_personalData_text: 'Edit name, contact details, and master data',
    account_account_personalData_status_badge: 'Current',
    account_accountPersonalData_recommendations_header: 'Profile notes',
    account_accountPersonalData_recommendations_text: '{{count}} items should be completed.',

    account_accountSecurity_recommendations_header: 'Security notes',
    account_accountSecurity_recommendations_text: '{{count}} recommendations are open.',

    account_account_companyRole_header: 'Company and role',
    account_account_companyRole_text: 'View assigned company and role overview',

    account_account_securitySection_header: 'Security',
    account_account_securitySection_text: 'Access, authentication, and personal tokens',

    account_account_passwordLogin_header: 'Password and sign in',
    account_account_passwordLogin_text: 'Change password and review active sessions',
    account_account_passwordLogin_status_badge: 'Recommendation',

    account_account_apiTokens_header: 'API tokens',
    account_account_apiTokens_text: 'Manage personal API access',
    account_account_apiTokens_status_badge: 'Disabled',

    account_account_integrationsSection_header: 'Integrations',
    account_account_integrationsSection_text: 'Personal connections to external services',

    account_account_calendar_header: 'Calendar',
    account_account_calendar_text: 'Connect Google, Outlook, or ICS',
    account_account_calendar_status_badge: 'Connected',
    account_account_calendar_meta: '{{count}} active',

    account_account_mail_header: 'Email',
    account_account_mail_text: 'Manage personal mail integrations',

    account_accountPersonalData_eyebrow_label: 'Account',
    account_accountPersonalData_title_header: 'Personal data',
    account_accountPersonalData_description_text: 'Maintain your personal master data and contact details.',
    account_accountPersonalData_back_button: 'Back to My account',
    account_accountPersonalData_masterData_header: 'Master data',
    account_accountPersonalData_masterData_text: 'Name, contact details, and additional personal information',

    // account security
    account_accountSecurity_eyebrow_label: 'Account',
    account_accountSecurity_title_header: 'Password and security',
    account_accountSecurity_description_text: 'Manage your password and review security-related settings for your account.',
    account_accountSecurity_back_button: 'Back to My account',

    account_accountSecurity_changePassword_button: 'Change password',

    account_accountSecurity_passwordPanel_header: 'Change password',
    account_accountSecurity_passwordPanel_text: 'Change the current password for this account.',

    account_accountSecurity_email_label: 'Email',
    account_accountSecurity_currentPassword_label: 'Current password',
    account_accountSecurity_newPassword_label: 'New password',
    account_accountSecurity_newPasswordConfirm_label: 'Confirm new password',

    account_accountSecurity_currentPasswordRequired_error: 'Please enter your current password.',
    account_accountSecurity_newPasswordRequired_error: 'Please enter a new password.',
    account_accountSecurity_newPasswordLength_error: 'The new password must be at least 8 characters long.',
    account_accountSecurity_newPasswordConfirmRequired_error: 'Please confirm the new password.',
    account_accountSecurity_passwordMismatch_error: 'The new passwords do not match.',

    account_accountSecurity_success_text: 'Your password has been changed successfully.',
    account_accountSecurity_error_text: 'The password could not be changed. Please review your input.',

    account_accountSecurity_notesPanel_header: 'Notes',
    account_accountSecurity_notesPanel_text: 'Important information about changing your password.',
    account_accountSecurity_noteOne_text: 'After a successful change, you will receive a confirmation email.',
    account_accountSecurity_noteTwo_text: 'If you no longer know your current password, use the forgot-password flow on the sign-in page.',

    // account calendar integrations
    general_refresh_button: 'Refresh',
    general_test_button: 'Test',
    general_disconnect_button: 'Disconnect',
    general_connect_button: 'Connect',

    account_accountCalendar_eyebrow_label: 'Integrations',
    account_accountCalendar_title_header: 'Calendar',
    account_accountCalendar_description_text: 'Connect external calendars and manage synchronization.',
    account_accountCalendar_back_button: 'Back to My account',

    account_accountCalendar_overview_header: 'Overview',
    account_accountCalendar_overview_text: 'Calendar integration status at a glance.',
    account_accountCalendar_overviewIntegrations_label: 'Integrations',
    account_accountCalendar_overviewSources_label: 'Selected sources',
    account_accountCalendar_overviewProviders_label: 'Providers',

    account_accountCalendar_existing_header: 'Connected calendars',
    account_accountCalendar_existing_text: 'Test, sync, or manage existing integrations.',
    account_accountCalendar_noIntegrations_text: 'There are currently no connected calendar integrations.',
    account_accountCalendar_connectedSources_text: '{{count}} connected sources',
    account_accountCalendar_lastSync_text: 'Last sync',

    account_accountCalendar_newIntegration_button: 'New integration',
    account_accountCalendar_sync_button: 'Sync',
    account_accountCalendar_manageSources_button: 'Manage sources',

    account_accountCalendar_providerSelection_header: 'Choose provider',
    account_accountCalendar_providerSelection_text: 'First choose a calendar provider, then complete the matching setup.',
    account_accountCalendar_supported_badge: 'Supported',

    account_accountCalendar_providerIcs_header: 'ICS',
    account_accountCalendar_providerIcs_text: 'Connect calendars via an ICS URL.',
    account_accountCalendar_providerIcsSetup_text: 'Enter the ICS URL and optionally provide credentials.',
    account_accountCalendar_providerIcsAbo: 'Subscribe to ICS',
    account_accountCalendar_providerIcsUpload: 'Upload ICS file',

    account_accountCalendar_providerMicrosoft_header: 'Microsoft',
    account_accountCalendar_providerMicrosoft_text: 'Connect Microsoft calendars via OAuth.',
    account_accountCalendar_providerMicrosoftSetup_text: 'Configure the Microsoft connection, then start the OAuth flow.',

    account_accountCalendar_providerGoogle_header: 'Google',
    account_accountCalendar_providerGoogle_text: 'Connect Google calendars via OAuth.',
    account_accountCalendar_providerGoogleSetup_text: 'Configure the Google connection, then start the OAuth flow.',

    account_accountCalendar_providerUnknown_label: 'Calendar provider',

    account_accountCalendar_displayName_label: 'Display name',
    account_accountCalendar_icsUrl_label: 'ICS URL',
    account_accountCalendar_icsUsername_label: 'Username',
    account_accountCalendar_icsPassword_label: 'Password',
    account_accountCalendar_tenantHint_label: 'Tenant hint',
    account_accountCalendar_oAuthClientId_label: 'OAuth client id',
    account_accountCalendar_oAuthClientSecret_label: 'OAuth client secret',

    account_accountCalendar_importAppointments_label: 'Import appointments',
    account_accountCalendar_importAbsences_label: 'Import absences',
    account_accountCalendar_exportAbsences_label: 'Export absences',

    account_accountCalendar_createIntegration_button: 'Create integration',

    account_accountCalendar_sources_header: 'Calendar sources',
    account_accountCalendar_sources_text: 'Choose which calendars should be used for this integration.',
    account_accountCalendar_noSources_text: 'No calendar sources were found.',
    account_accountCalendar_refreshSources_button: 'Refresh sources',
    account_accountCalendar_saveSources_button: 'Save selection',
    account_accountCalendar_sourcesSaved_text: 'The source selection has been saved.',
    account_accountCalendar_readOnly_label: 'Read only',
    account_accountCalendar_primary_label: 'Primary',
    account_accountCalendar_unsubscribeSource_button: 'Unsubscribe source',
    account_accountCalendar_removeSource_button: 'Remove source',

    account_accountCalendar_oAuthSuccess_text: 'The OAuth connection was completed successfully.',
    account_accountCalendar_oAuthStateMismatch_text: 'The OAuth sign in could not be verified.',
    account_accountCalendar_oAuthProviderMissing_text: 'The provider for the OAuth return could not be determined.',
    account_accountCalendar_icsCreateSuccess_text: 'The ICS integration has been created.',
    account_accountCalendar_genericError_text: 'The calendar integration could not be processed.',

    account_accountCalendar_providerIcsUploadInfo_text: 'One time ICS file import. This flow does not create a permanent calendar integration.',
    account_accountCalendar_providerIcsUploadFile_label: 'Select ICS file',
    account_accountCalendar_providerIcsUploadNoFile_text: 'No file selected yet',
    account_accountCalendar_skipDuplicates_label: 'Skip duplicates',
    account_accountCalendar_splitOverlappingEntries_label: 'Split overlapping entries',
    account_accountCalendar_dryRun_label: 'Simulate only, do not save',
    account_accountCalendar_resetSelection_button: 'Reset selection',
    account_accountCalendar_previewLoad_button: 'Load preview',
    account_accountCalendar_importExecute_button: 'Run import',
    account_accountCalendar_importFile_label: 'File',
    account_accountCalendar_importEntries_label: 'Entries',
    account_accountCalendar_importWarnings_label: 'Warnings',
    account_accountCalendar_importPreview_header: 'ICS Preview',
    account_accountCalendar_importPreview_text: 'Summary from the preview endpoint',
    account_accountCalendar_importPeriod_label: 'Period',
    account_accountCalendar_importFrom_label: 'From',
    account_accountCalendar_importTo_label: 'To',
    account_accountCalendar_importCreated_label: 'Created',
    account_accountCalendar_importUpdated_label: 'Updated',
    account_accountCalendar_importSkipped_label: 'Skipped',
    account_accountCalendar_importConflicts_label: 'Conflicts',
    account_accountCalendar_importHints_header: 'Import notes',
    account_accountCalendar_importHints_text: 'Messages returned by the commit endpoint',
    account_accountCalendar_importFileMissing_text: 'Please select an ICS file first.',
    account_accountCalendar_importPreviewSuccess_text: 'ICS preview loaded successfully.',
    account_accountCalendar_importCommitSuccess_text: 'ICS file imported successfully.',
    account_accountCalendar_importDryRunSuccess_text: 'ICS import dry run completed successfully.',

    rmCalendarNoTasksInProject: "This project requires tasks, but none have been created yet. Please create tasks for the project first.",
    rmCalendarNoTasksSelect: "A task is required for this project. Please select a task.",

    // administration page
    administration_eyebrow_label: 'Administration',
    administration_title_header: 'Administration',
    administration_description_text: 'Central overview for account data, access control, server settings, variables and integrations.',
    administration_back_button: 'Back to dashboard',

    administration_sectionsStat_label: 'Sections',
    administration_sectionsStat_hint: 'Available administration areas',
    administration_routesStat_label: 'Destinations',
    administration_routesStat_value: '{{count}} entries',
    administration_routesStat_hint: 'Directly available administration pages',
    administration_comingSoonStat_label: 'Planned',
    administration_comingSoonStat_value: '{{count}} open',
    administration_comingSoonStat_hint: 'Areas prepared for future rollout',

    administration_sectionAccount_text: 'Manage master data, addresses and payment information.',
    administration_sectionDiagnostics_text: 'System health, logs and future monitoring areas.',
    administration_sectionAccess_text: 'Control roles, permissions and user assignments.',
    administration_sectionServer_text: 'Environment and database related server settings.',
    administration_sectionVariables_text: 'Manage system wide variables and configuration.',
    administration_sectionIntegrations_text: 'Connect external systems and communication channels.',

    administration_company_text: 'Company master data and account information.',
    administration_addresses_text: 'Manage office, billing and contact addresses.',
    administration_payment_text: 'Edit payment methods and billing information.',

    administration_logs_label: 'Logs',
    administration_logs_text: 'Protocol output, events and technical error details.',
    administration_health_label: 'Health',
    administration_health_text: 'Overview of system health and availability.',
    administration_stats_label: 'Statistics',
    administration_stats_text: 'Server metrics, usage and diagnostic values.',

    administration_roles_text: 'Define and manage roles.',
    administration_permissions_text: 'Manage permissions and role assignments.',
    administration_userRoles_text: 'Coordinate users, roles and responsibilities.',
    adminUserOnboardButton: 'Create user',
    adminUserOnboardTitle: 'Create user',
    adminUserOnboardSuccess: 'User was created',
    userDeletedSuccess: 'User was deleted',
    adminUserOnboardStepProfile: 'Profile',
    adminUserOnboardStepAccess: 'Access and roles',
    adminUserOnboardStepEmployment: 'Contract and time tracking',
    adminUserEmploymentInfo: 'Employment periods and contract data are managed here.',
    adminUserEmploymentInfoTextAfter: 'New contract data is stored as a contract version so time tracking and vacation calculations stay historically traceable.',
    adminUserEmploymentLoading: 'Loading employment data',
    calendarNoEmploymentPeriodWeek: 'There is no employment contract for the selected period. Time bookings are therefore disabled.',
    calendarTimeTrackingYearClosed: 'The fiscal year is closed for time tracking. Entries in this year can no longer be created, changed or deleted.',
    adminFiscalYears: 'Fiscal years',
    administration_fiscalYears_text: 'Manage fiscal years and close individual areas such as time tracking or financial accounting after year end.',
    adminFiscalYearPolicies: 'Year closing and locks',
    adminFiscalYear: 'Fiscal year',
    adminFiscalYearTimeTrackingClosed: 'Time tracking closed',
    adminFiscalYearAccountingClosed: 'Financial accounting closed',
    adminUserSpecialPayments: 'Special payments',
    adminUserSpecialPaymentDate: 'Payment date',
    adminUserSpecialPaymentAmount: 'Amount',
    adminUserSpecialPaymentType: 'Special payment type',
    adminUserSpecialPaymentOvertimeHours: 'Paid overtime hours',
    adminUserSpecialPaymentReason: 'Reason / event',
    adminUserSpecialPaymentNote: 'Note',
    specialPaymentType: {
        Bonus: 'Bonus payment',
        YearEndParticipation: 'Year-end participation',
        ManagingDirectorParticipation: 'Managing director participation',
        ShareholderParticipation: 'Shareholder participation',
        OvertimePayout: 'Overtime payout',
        Other: 'Other special payment',
    },
    calendarNoEmploymentPeriodYear: 'There is no employment contract for this year. Absences and time bookings are disabled for this period.',
    adminUserNoticeDate: 'Notice date',
    adminUserContractVersions: 'Contract versions',
    adminUserContractEditor: 'Contract data',
    adminUserContractValidFrom: 'Contract valid from',
    adminUserContractValidTo: 'Contract valid to',
    adminUserContractCurrent: 'current',
    adminUserContractOpenEnded: 'open',
    adminUserNoContractVersions: 'No contract version has been stored yet.',
    adminUserAddContractVersion: 'Create new contract version',
    adminUserAddContractVersionInfo: 'When saving, the previously current contract version is automatically ended on the day before the new valid-from date.',
    adminUserCreateInitialContractVersionInfo: 'Enter the first contract data for this employment. The valid-from date is used as the employment start date.',
    adminUserCorrectCurrentContractVersion: 'Correct current contract version',
    adminUserCorrectCurrentContractVersionInfo: 'This change corrects the current contract version directly and affects the existing period retroactively.',
    adminUserIsTemporary: 'Fixed-term contract',
    adminUserTemporaryUntil: 'Fixed term until',
    adminUserProbePeriodUntil: 'Probe period until',
    adminUserContractNote: 'Contract version note',
    adminUserEmploymentType: 'Employment type',
    adminUserEmploymentTypeHint: 'The employment type automatically determines which contract details are relevant in this form.',
    adminUserContractSectionEmployment: 'Employment relationship',
    adminUserContractSectionValidity: 'Term and contract status',
    adminUserContractSectionWorkingTime: 'Working time and vacation',
    adminUserContractSectionCompensation: 'Compensation',
    adminUserContractSectionAdditional: 'Additional details',
    adminUserWeeklyHours: 'Weekly hours',
    adminUserWeeklyWorkingDays: 'Working days per week',
    adminUserWorkScheduleType: 'Work schedule',
    adminUserWorkScheduleCycleWeeks: 'Cycle length in weeks',
    adminUserWorkScheduleAnchorDate: 'Cycle start date',
    adminUserWorkScheduleRules: 'Working days and time windows',
    adminUserWorkScheduleRulesHint: 'Define target hours and an optional allowed local time window per working day. Multiple entries on one day support split shifts. An end before the start is treated as the following day.',
    adminUserWorkScheduleRulesEmpty: 'No working days have been defined yet.',
    adminUserWorkScheduleDay: 'Weekday',
    adminUserWorkScheduleWeekIndex: 'Week',
    adminUserWorkScheduleTargetHours: 'Target hours',
    adminUserWorkScheduleAllowedStart: 'Allowed from',
    adminUserWorkScheduleAllowedEnd: 'Allowed until',
    adminUserAllowWorkTimeOutsideSchedule: 'Allow bookings outside the work schedule',
    adminUserNotifyMissingTimeEntries: 'Notify about missing time entries',
    adminUserVacationDaysPerYear: 'Vacation days per year',
    adminUserCompensationType: 'Compensation type',
    adminUserCompensationAmount: 'Compensation',
    adminUserMonthlySalary: 'Monthly salary',
    adminUserHourlyRate: 'Hourly rate',
    adminUserCurrency: 'Currency',
    permanent: 'Permanent',
    temporary: 'Temporary',
    workingStudent: 'Working student',
    intern: 'Intern',
    freelancer: 'Freelancer',
    miniJob: 'Mini job',
    ausbildung: 'Apprenticeship',
    dualStudent: 'Dual study',
    midiJob: 'Midi job',
    shortTermEmployment: 'Short term employment',
    seasonalEmployment: 'Seasonal employment',
    temporaryAgencyEmployment: 'Temporary agency employment',
    managingDirectorEmployment: 'Managing director',
    voluntaryService: 'Voluntary service',
    workScheduleType: {
        StandardWeek: 'Standard week',
        FixedWeekly: 'Fixed weekly schedule',
        RotatingWeeks: 'Rotating multi week schedule',
    },
    monthlySalary: 'Monthly salary',
    hourlyRate: 'Hourly rate',
    compensationType: {
        MonthlySalary: 'Monthly salary',
        HourlyRate: 'Hourly rate',
    },
    administration_api_label: 'API',
    administration_api_text: 'Technical interfaces and access tokens.',

    administration_environment_text: 'Review environment values and technical configuration.',
    administration_backup_text: 'Backup, restore and database operations.',
    administration_variables_text: 'Manage global system variables.',
    administration_mailClients_label: 'Email clients',
    administration_mailClients_text: 'Configure mail integrations and delivery channels.',

    "company_oauthSettings_title_header": "OAuth settings",
    "company_oauthSettings_description_text": "Manage company level OAuth settings for Google and Microsoft",

    "company_oauthSettings_providerGoogle_header": "Google Calendar",
    "company_oauthSettings_providerGoogle_text": "OAuth settings for Google Calendar connections",
    "company_oauthSettings_providerGoogle_hint": "These values are used as company defaults for Google Calendar integrations.",

    "company_oauthSettings_providerMicrosoft_header": "Microsoft 365 Calendar",
    "company_oauthSettings_providerMicrosoft_text": "OAuth settings for Microsoft 365 Calendar connections",
    "company_oauthSettings_providerMicrosoft_hint": "These values are used as company defaults for Microsoft calendar integrations.",

    "company_oauthSettings_enabled_label": "Provider enabled",
    "company_oauthSettings_allowOverride_label": "Allow user override",

    "company_oauthSettings_tenant_label": "Tenant or tenant hint",
    "company_oauthSettings_tenant_placeholder": "for example common or tenant id",

    "company_oauthSettings_clientId_label": "Client ID",
    "company_oauthSettings_clientId_placeholder": "OAuth client ID",

    "company_oauthSettings_clientSecret_label": "Client secret",
    "company_oauthSettings_clientSecret_placeholder": "OAuth client secret",
    "company_oauthSettings_clientSecretKeep_placeholder": "Leave empty to keep the existing secret",

    "company_oauthSettings_redirectUri_label": "Redirect URI",
    "company_oauthSettings_redirectUri_placeholder": "https://app.example.com/oauth/callback",
    "company_oauthSettings_microsoftRedirectUri_hint": "The Microsoft redirect URI can remain empty. The backend uses account/integrations/calendar and combines the path with the current frontend URL.",

    "administration_oauthSettings_label": "OAuth settings",
    "administration_oauthSettings_text": "Manage Google and Microsoft OAuth configuration for integrations",

    // Homologation platform
    general_guid: 'ID',
    general_status: 'Status',
    general_currentVersion: 'Current version',
    general_updatedAt: 'Updated at',
    general_createdAt: 'Created at',
    general_revision: 'Revision',
    navHomologationPlatform: 'Homologation Platform',
    navVehicle: 'Vehicles',
    general_vehicle: 'Vehicle',
    general_vehicle_base_data: 'Vehicle data',
    homologationPlatformVehicleManufacturerLabel: 'Manufacturer',
    homologationPlatformVehicleModelLabel: 'Model',
    homologationPlatformVehicleVersionLabel: 'Version',
    homologationPlatformVehicleStatusLabel: 'Status',

    general_id: 'ID',
    general_comment: 'Comment',
    general_required: 'Required',
    homologationPlatformVehicleVinLabel: 'VIN',
    homologationPlatformVehicleTypeLabel: 'Vehicle type',
    homologationPlatformVehicleFuelTypeLabel: 'Fuel type',
    homologationPlatformVehicleApprovalNumberLabel: 'Approval number',
    homologationPlatformVehicleResponsibleCompanyLabel: 'Responsible company',
    homologationPlatformVehicleNextInspectionDueAtLabel: 'Next inspection due at',
    homologationPlatformVehicleTechnicalDataSection: 'Technical data',
    homologationPlatformVehicleHomologationSection: 'Homologation',
    homologationPlatformVehicleResponsiblePartySection: 'Responsible party',
    homologationPlatformVehicleInspectionChecklistSection: 'Inspection checklist',
    homologationPlatformVehicleDocumentsSection: 'Documents',
    homologationPlatformVehicleProductionYearLabel: 'Production year',
    homologationPlatformVehicleAxleCountLabel: 'Axle count',
    homologationPlatformVehicleGrossWeightLabel: 'Gross vehicle weight kg',
    homologationPlatformVehicleEnginePowerLabel: 'Engine power kW',
    homologationPlatformVehicleCo2Label: 'CO₂ g/km',
    homologationPlatformVehicleElectricRangeLabel: 'Electric range km',
    homologationPlatformVehicleEmissionClassLabel: 'Emission class',
    homologationPlatformVehicleTrailerCouplingLabel: 'Trailer coupling',
    homologationPlatformVehicleAuthorityLabel: 'Authority',
    homologationPlatformVehicleCountryCodeLabel: 'Country code',
    homologationPlatformVehicleValidFromLabel: 'Valid from',
    homologationPlatformVehicleValidUntilLabel: 'Valid until',
    homologationPlatformVehicleLastInspectionAtLabel: 'Last inspection at',
    homologationPlatformVehicleContactNameLabel: 'Contact person',
    homologationPlatformVehicleRequirementLabel: 'Requirement',
    homologationPlatformVehicleDueDateLabel: 'Due date',
    homologationPlatformVehicleCheckedLabel: 'Checked',
    homologationPlatformVehicleDocumentTypeLabel: 'Document type',
    homologationPlatformVehicleFileNameLabel: 'File name',
    homologationPlatformVehicleNotesLabel: 'Notes',

    homologationPlatformVehicleStatus: {
        Draft: 'Draft',
        InReview: 'In review',
        Published: 'Published',
        Archived: 'Archived',
    },
    homologationPlatformVehicleType: {
        Tractor: 'Tractor',
        RigidTruck: 'Rigid truck',
        Trailer: 'Trailer',
        Van: 'Van',
        Bus: 'Bus',
    },
    homologationPlatformVehicleFuel: {
        Diesel: 'Diesel',
        Electric: 'Electric',
        Hydrogen: 'Hydrogen',
        Hybrid: 'Hybrid',
        Cng: 'CNG',
        Lng: 'LNG',
    },
    homologationPlatformVehicleInspection: {
        Open: 'Open',
        InProgress: 'In progress',
        Passed: 'Passed',
        Failed: 'Failed',
        NotRequired: 'Not required',
    },
    homologationPlatformVehicleDocument: {
        Missing: 'Missing',
        Uploaded: 'Uploaded',
        Approved: 'Approved',
        Expired: 'Expired',
    },
    homologationPlatformVehicleDocumentType: {
        TypeApproval: 'Type approval',
        CertificateOfConformity: 'Certificate of conformity',
        InspectionReport: 'Inspection report',
        EmissionCertificate: 'Emission certificate',
        Insurance: 'Insurance',
    },
    auditChangeType: {
        Created: 'Created',
        Updated: 'Updated',
        Deleted: 'Deleted',
        Restored: 'Restored',
        Imported: 'Imported',
        SystemUpdated: 'System updated',
    },
    entityStatus: {
        Draft: 'Draft',
        Active: 'Active',
        Inactive: 'Inactive',
        Archived: 'Archived',
        Deleted: 'Deleted',
    },
    documentCategory: {
        Personnel: 'Personnel',
        Application: 'Application',
        CustomerContract: 'Customer contract',
        SupplierContract: 'Supplier contract',
        Accounting: 'Accounting',
        Tax: 'Tax',
        Project: 'Project',
        Marketing: 'Marketing',
        Support: 'Support',
        Technical: 'Technical',
        Other: 'Other',
    },
    gdprLawfulBasis: {
        Consent: 'Consent',
        Contract: 'Contract',
        LegalObligation: 'Legal obligation',
        VitalInterests: 'Vital interests',
        PublicTask: 'Public task',
        LegitimateInterest: 'Legitimate interest',
    },
    deletionTrigger: {
        PurposeFulfilled: 'Purpose fulfilled',
        RetentionPeriodExpired: 'Retention period expired',
        ApplicationProcessFinished: 'Application process finished',
        ContractEnded: 'Contract ended',
        ConsentWithdrawn: 'Consent withdrawn',
        ManualReviewRequired: 'Manual review required',
        LegalHoldReleased: 'Legal hold released',
    },
    storageLocation: {
        HrSystem: 'HR system',
        Email: 'Email',
        ApplicationPortal: 'Application portal',
        Crm: 'CRM',
        Erp: 'ERP',
        ProjectDrive: 'Project drive',
        FinanceSystem: 'Finance system',
        Dms: 'DMS',
        Archive: 'Archive',
        Database: 'Database',
        Other: 'Other',
    },

    Core: {
        AuditChangeType: {
            Created: 'Created',
            Updated: 'Updated',
            Deleted: 'Deleted',
            Restored: 'Restored',
            Imported: 'Imported',
            SystemUpdated: 'System updated',
        },
        EntityStatus: {
            Draft: 'Draft',
            Active: 'Active',
            Inactive: 'Inactive',
            Archived: 'Archived',
            Deleted: 'Deleted',
        },
    },
    'enum': {
        auditChangeType: {
            Created: 'Created',
            Updated: 'Updated',
            Deleted: 'Deleted',
            Restored: 'Restored',
            Imported: 'Imported',
            SystemUpdated: 'System updated',
        },
        entityStatus: {
            Draft: 'Draft',
            Active: 'Active',
            Inactive: 'Inactive',
            Archived: 'Archived',
            Deleted: 'Deleted',
        },
        documentCategory: {
            Personnel: 'Personnel',
            Application: 'Application',
            CustomerContract: 'Customer contract',
            SupplierContract: 'Supplier contract',
            Accounting: 'Accounting',
            Tax: 'Tax',
            Project: 'Project',
            Marketing: 'Marketing',
            Support: 'Support',
            Technical: 'Technical',
            Other: 'Other',
        },
        gdprLawfulBasis: {
            Consent: 'Consent',
            Contract: 'Contract',
            LegalObligation: 'Legal obligation',
            VitalInterests: 'Vital interests',
            PublicTask: 'Public task',
            LegitimateInterest: 'Legitimate interest',
        },
        deletionTrigger: {
            PurposeFulfilled: 'Purpose fulfilled',
            RetentionPeriodExpired: 'Retention period expired',
            ApplicationProcessFinished: 'Application process finished',
            ContractEnded: 'Contract ended',
            ConsentWithdrawn: 'Consent withdrawn',
            ManualReviewRequired: 'Manual review required',
            LegalHoldReleased: 'Legal hold released',
        },
        storageLocation: {
            HrSystem: 'HR system',
            Email: 'Email',
            ApplicationPortal: 'Application portal',
            Crm: 'CRM',
            Erp: 'ERP',
            ProjectDrive: 'Project drive',
            FinanceSystem: 'Finance system',
            Dms: 'DMS',
            Archive: 'Archive',
            Database: 'Database',
            Other: 'Other',
        },
    },

    general_displayName: 'Display name',
    general_entityMetadata: 'Metadata',
    general_lifecycle: 'Lifecycle',
    general_lifecycleStatus: 'Lifecycle status',
    general_versionMetadata: 'Versioning',
    general_semanticVersion: 'Semantic version',
    general_versionChange: 'Version change',
    general_auditTrail: 'Audit overview',
    general_auditEntries: 'Audit entries',
    general_auditEntry: 'Audit entry',
    general_auditFieldChange: 'Field change',
    general_complianceMetadata: 'Compliance',
    general_gdprMetadata: 'GDPR',
    general_retentionPolicy: 'Retention policy',
    general_legalHold: 'Legal hold',
    general_customProperties: 'Custom properties',
    general_customProperty: 'Custom property',
    general_systemSections: 'System information',
    entitySystemInfoSection: 'System and audit',
    entityMetadataSection: 'Metadata',
    entityLifecycleSection: 'Status history',
    entityLifecycleChangedAt: 'Status changed at',
    entityLifecycleChangedBy: 'Status changed by',
    entityVersionSection: 'Version',
    entityVersionReleasedAt: 'Version released at',
    entityVersionReleasedBy: 'Version released by',
    entityVersionReleaseNotes: 'Version notes',
    entityComplianceSection: 'Compliance and GDPR',
    entityComplianceClassification: 'Classification',
    entityComplianceClassificationCode: 'Classification code',
    entityComplianceLawfulBasis: 'Lawful basis',
    entityComplianceProcessingPurpose: 'Processing purpose',
    entityComplianceContainsPersonalData: 'Contains personal data',
    entityComplianceDataOwner: 'Data owner',
    entityComplianceDeletionTrigger: 'Deletion trigger',
    entityComplianceRetentionUntil: 'Retention until',
    entityCompliancePrimaryStorageLocation: 'Primary storage location',
    entityComplianceAuditRequired: 'Audit required',
    entityComplianceLegalHoldActive: 'Legal hold active',
    entityAuditTrailSection: 'Audit entries',
    entityAuditChangeType: 'Change type',
    entityAuditChangedAt: 'Changed at',
    entityAuditChangedBy: 'Changed by',
    general_createdBy: 'Created by',
    general_updatedBy: 'Updated by',
    general_changedAt: 'Changed at',
    general_changedBy: 'Changed by',
    general_reason: 'Reason',
    general_major: 'Major',
    general_minor: 'Minor',
    general_patch: 'Patch',
    general_label: 'Label',
    general_version: 'Version',
    general_releasedAt: 'Released at',
    general_releasedBy: 'Released by',
    general_releaseNotes: 'Release notes',
    general_field: 'Field',
    general_oldValue: 'Old value',
    general_newValue: 'New value',
    general_changeType: 'Change type',
    general_lastChangeType: 'Last change type',
    general_lastChangedAt: 'Last changed at',
    general_lastChangedBy: 'Last changed by',
    general_active: 'Active',
    general_activatedAt: 'Activated at',
    general_activatedBy: 'Activated by',
    general_category: 'Category',
    general_retentionPeriodMonths: 'Retention period months',
    general_retentionUntil: 'Retention until',
    general_deletionTrigger: 'Deletion trigger',
    general_lawfulBasis: 'Lawful basis',
    general_processingPurpose: 'Processing purpose',
    general_containsPersonalData: 'Contains personal data',
    general_dataOwner: 'Data owner',
    general_lastPrivacyReviewAt: 'Last privacy review',
    general_nextPrivacyReviewAt: 'Next privacy review',
    general_classification: 'Classification',
    general_classificationCode: 'Classification code',
    general_auditRequired: 'Audit required',
    general_key: 'Key',
    general_type: 'Type',
    general_value: 'Value',
    general_editable: 'Editable',
    homologationPlatformVehicleCustomPropertyMarketSegment: 'Market segment',
    homologationPlatformVehicleCustomPropertyRiskScore: 'Internal risk score',
    homologationPlatformVehicleCustomPropertyWorkflowCode: 'Backend workflow code',
    homologationPlatformVehicleCustomPropertyValueLongHaul: 'Long haul',
    homologationPlatformVehicleCustomPropertyValueUrbanDelivery: 'Urban delivery',
    homologationPlatformVehicleCustomPropertyValueBackendReviewRequired: 'Backend review required',
    homologationPlatformVehicleCustomPropertyValueFastTrack: 'Fast track',
    customPropertyValueType: {
        Text: 'Text',
        Number: 'Number',
        Decimal: 'Decimal',
        Boolean: 'Boolean',
        Date: 'Date',
        DateTime: 'Date and time',
        EnumKey: 'Enum key',
    },
    validation: {
        dateNotBeforeToday: '{{field}} must not be in the past',
        dateNotAfterToday: '{{field}} must not be in the future',
    },

    calendar_history_title: 'History',
    calendar_history_start: 'Start',
    calendar_history_end: 'End',
    calendar_history_status: 'Status',
    calendar_history_createdAt: 'Created at',
    calendar_history_updatedAt: 'Last changed at',
    calendar_history_decidedBy: 'Decided by',
    calendar_history_decidedAt: 'Decided at',
    calendar_history_decisionComment: 'Decision comment',
    calendar_history_reason: 'Reason or description',
    calendar_history_noValue: 'Not specified',
    calendar_entry_edit_title: 'Edit calendar entry',
    calendar_entry_edit_save: 'Save changes',
    calendar_entry_dialog_close: 'Close',
    navButtonEmployeeTimeOverview: 'Employee time overview',
    resourceManager_employeeTimeOverview_title: 'Employee time overview',
    resourceManager_employeeTimeOverview_heading: 'Time tracking overview',
    resourceManager_employeeTimeOverview_description: 'Review one employee\'s work time across all projects by week, month, year or custom date range and export it as a timesheet.',
    resourceManager_employeeTimeOverview_week: 'Week',
    resourceManager_employeeTimeOverview_month: 'Month',
    resourceManager_employeeTimeOverview_year: 'Year',
    resourceManager_employeeTimeOverview_employees: 'Employees',
    resourceManager_employeeTimeOverview_employeeSelect: 'Select employee',
    resourceManager_employeeTimeOverview_selectedEmployees: 'Selected employees',
    resourceManager_employeeTimeOverview_selectedEmployee: 'Selected employee',
    resourceManager_employeeTimeOverview_employee: 'Employee',
    resourceManager_employeeTimeOverview_calendarYear: 'Year',
    resourceManager_employeeTimeOverview_calendarWeek: 'CW',
    resourceManager_employeeTimeOverview_openWeek: 'Open week in calendar',
    resourceManager_employeeTimeOverview_entries: 'Entries',
    resourceManager_employeeTimeOverview_bookedDays: 'Days with entries',
    resourceManager_employeeTimeOverview_hours: 'Booked hours',
    resourceManager_employeeTimeOverview_averagePerBookedDay: 'Avg. per booked day',
    resourceManager_employeeTimeOverview_refresh: 'Refresh',
    resourceManager_employeeTimeOverview_export: 'Export Excel',
    resourceManager_employeeTimeOverview_exportExcel: 'Timesheet Excel',
    resourceManager_employeeTimeOverview_exportPdf: 'Timesheet PDF',
    resourceManager_employeeTimeOverview_customRange: 'Date range',
    resourceManager_employeeTimeOverview_invalidRange: 'The end date must be after the start date.',
    resourceManager_employeeTimeOverview_includeEntryText: 'Show title or project name in PDF',
    resourceManager_employeeTimeOverview_includeEntryTextHint: 'When disabled, the PDF table contains only day and hours.',
    resourceManager_employeeTimeOverview_noData: 'No employees are selected for this period.',
    resourceManager_employeeTimeOverview_noEmployeeSelected: 'Please select an employee first.',
    resourceManager_employeeTimeOverview_noEntries: 'No work time entries were found for the selected employee and period.',
    resourceManager_employeeTimeOverview_loadFailed: 'Employee time data could not be loaded.',
    resourceManager_employeeTimeOverview_overtimeHeading: 'Overtime report',
    resourceManager_employeeTimeOverview_overtimeDescription: 'Weekly overview showing the cumulative overtime balance at the end of each calendar week and the change within that week.',
    resourceManager_employeeTimeOverview_overtimeDay: 'Days',
    resourceManager_employeeTimeOverview_overtimeWeek: 'Weeks',
    resourceManager_employeeTimeOverview_overtimePositiveOnly: 'Only periods with overtime',
    resourceManager_employeeTimeOverview_overtimePeriod: 'Period',
    resourceManager_employeeTimeOverview_overtimeStart: 'Start',
    resourceManager_employeeTimeOverview_overtimeEnd: 'End',
    resourceManager_employeeTimeOverview_overtimeExpected: 'Expected hours',
    resourceManager_employeeTimeOverview_overtimeWorked: 'Worked hours',
    resourceManager_employeeTimeOverview_overtimeCreditable: 'Creditable performance',
    resourceManager_employeeTimeOverview_overtime: 'Overtime',
    resourceManager_employeeTimeOverview_overtimeBalance: 'Overtime balance',
    resourceManager_employeeTimeOverview_overtimeExportCsv: 'Export CSV',
    resourceManager_employeeTimeOverview_overtimeExportExcel: 'Export Excel',
    resourceManager_employeeTimeOverview_overtimeNoPositiveRows: 'No positive overtime was found in the selected period.',
    resourceManager_employeeTimeOverview_overtimeNoRows: 'No relevant employment weeks were found for the selected period.',
    resourceManager_employeeTimeOverview_overtimeLoadFailed: 'The overtime report could not be loaded.',
    resourceManager_absenceOverview_day_label: 'Day',
    resourceManager_absenceOverview_month_label: 'Month',
    billingOfferSendTitle: 'Send offer',
    billingInvoiceSendTitle: 'Send invoice',
    billingSendDescription: '{{number}} will be attached as a PDF. The delivery address is independent of the contact shown in the document.',
    billingSendRecipientLabel: 'Recipient',
    billingSendRecipientPlaceholder: 'billing@customer.com',
    billingSendRecipientHint: 'Select a contact or enter any email address.',
    billingSendAdditionalRecipientsLabel: 'Additional recipients',
    billingSendAdditionalRecipientsPlaceholder: 'accounting@customer.com; project@customer.com',
    billingSendAdditionalRecipientsHint: 'Optional. Separate multiple addresses with commas or semicolons.',
    billingSendInvalidAdditionalRecipient: 'At least one additional email address is invalid.',
    billingInvoiceSendAttachmentsHint: 'The PDF invoice and e-invoice are attached automatically.',
    billingOfferSendAttachmentsHint: 'The finalized offer is attached automatically as a PDF.',
    billingOfferSendAction: 'Send offer',
    billingInvoiceSendAction: 'Send invoice',
    resourceManager_projectStatistics_filter_budget_option: 'With configured budget only',
    billingDefaultPaymentTermsDays: 'Default payment target in days',
    billingDefaultDiscountPercent: 'Default cash discount in %',
    billingDefaultDiscountDays: 'Default cash discount period in days',
    billingDefaultPaymentTermsCustomerHint: 'Optional. Empty uses the global system default. Once a payment target is set, target and discount become the customer default for new invoices.',
    billingProjectPaymentTermsDays: 'Project payment target in days',
    billingProjectPaymentTermsHint: 'Optional. Empty inherits the customer payment terms. Once a target is set, the complete project rule including discount applies.',
    projectTimesheetCustomer: 'Timesheet customer / end customer',
    projectTimesheetCustomerHint: 'Optional. Invoices and offers remain assigned to the project customer; timesheets are generated for this end customer.',
    resourceManager_calendarExport_timesheetRecipient_label: 'Timesheet for',
    fibu_unsavedChangesConfirm_title: 'Unsaved changes',
    fibu_unsavedChangesConfirm_message: 'The current changes have not been saved yet. Discard them and close?',
    fibu_unsavedChangesDiscard_button: 'Discard',
    fibu_invoiceFinalizeConfirm_title: 'Finalize invoice',
    fibu_invoiceFinalizeConfirm_message: 'The invoice will be finalized and receive its binding invoice number. Afterwards it can only be corrected through cancellation and revision.',
    fibu_invoiceFinalizeConfirm_button: 'Finalize',
    fibu_invoiceRevisionConfirm_title: 'New invoice revision',
    fibu_invoiceRevisionConfirm_message: 'A new editable revision will be created. The previous invoice remains valid until the new revision is finalized and is then cancelled automatically.',
    fibu_invoiceRevisionConfirm_button: 'Create revision',
    fibu_invoiceCancelConfirm_title: 'Cancel invoice',
    fibu_invoiceCancelConfirm_message: 'The invoice will be cancelled. This changes its accounting status.',
    fibu_invoiceCancelConfirm_button: 'Cancel invoice',
    fibu_invoiceDeleteConfirm_title: 'Delete invoice permanently',
    fibu_invoiceDeleteConfirm_message: 'The draft or already cancelled invoice will be permanently deleted. This cannot be undone.',
    fibu_offerCancelConfirm_title: 'Cancel offer',
    fibu_offerCancelConfirm_message: 'The offer will be cancelled. Continue?',
    fibu_offerCancelConfirm_button: 'Cancel offer',
    fibu_offerDeleteConfirm_title: 'Delete offer permanently',
    fibu_offerDeleteConfirm_message: 'The draft or cancelled offer will be permanently deleted. This cannot be undone.',
    // Added to keep the English resource set in parity with the German source.
    notification: 'Benachrichtigungen',
    start: 'Start',
    pause: 'Pause',
    stop: 'Stop',
    generalImportCsv: 'Import CSV',
    generalImportExcel: 'Import Excel',
    generalExportCsv: 'Export CSV',
    generalExportExcel: 'Export Excel',
    confirmationResetText: 'Are you sure you want to reset all entries?',
    projectTableTitle: 'Project overview',
    tracker: 'Tracker',
    noTrackers: 'Keine Tracker vorhanden. ',
    convertToTask: 'Convert to task',
    navButtonApproveOffDay: 'Approve vacation',
    navButtonContacts: 'Kontakte',
    emailIntegrationEmail: 'Email',
    workflowNotUsed: 'none',
    statusAdvanceTo: 'Set the current project status to {{status}}',
    currentStatus: 'Current status',
    nextPossibleStatus: 'Next possible status',
    toDoPlu: 'To-dos',
    productPlu: 'products',
    projectPlu: 'projects',
    statusFilterNone: 'No status selected',
    statusFilterAll: 'All statuses selected',
    unit: 'Unit',
    timeManagerHalfDay: 'Halben Tag',
    timeManagerFullDay: 'Ganzen Tag',
    timeManagerSubmit: 'Submit vacation',
    timeManagerVacation: 'Book vacation',
    timeManagerBookedVacation: 'Booked vacation',
    timeManagerApproved: 'Genemigt',
    timeManagerApprovalPending: 'Genemigung Austehend',
    Vacation: 'Vacation',
    SickDay: 'Sick',
    Holiday: 'Holiday',
    TimeCompensation: 'Time off',
    timeManagerUsedHoursForYear: 'Booked hours for {{year}}',
    timeManagerOverTimeTargetHours: 'Target hours',
    timeManagerCalendarWeek: 'KW',
    timeManagerOverTimeActualHours: 'Actual hours',
    timeManagerMonthBreakdown: 'Monats Ansicht',
    timeManagerOverTime: 'Overtime',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday',
    navContracting: 'Contracts and licenses',
    navContractAssignment: 'Contract overview',
    navLicenseAssignment: 'License overview',
    tableLicenseAssignment: 'License overview table',
    emptyPageTextLicenseAssignment: 'No license entries have been created yet. Choose from the following options:',
    contractingLicenseAssignmentGuid: 'Guid',
    contractingLicenseAssignmentCreatedAt: 'Created at',
    contractingLicenseAssignmentCreatedBy: 'Created by',
    contractingLicenseAssignmentUpdatedAt: 'Updated at',
    contractingLicenseAssignmentUpdatedBy: 'Updated by',
    contractingLicenseAssignmentDeviceCount: 'Number of devices',
    contractingLicenseAssignmentName: 'License name',
    contractingLicenseAssignmentTitle: 'License title',
    contractingLicenseAssignmentDescription: 'License description',
    contractingLicenseAssignmentGuidTooltip: 'GUID tooltip',
    contractingLicenseAssignmentCreatedAtTooltip: 'Created at tooltip',
    contractingLicenseAssignmentCreatedByTooltip: 'Created by tooltip',
    contractingLicenseAssignmentUpdatedAtTooltip: 'Updated at tooltip',
    contractingLicenseAssignmentUpdatedByTooltip: 'Updated by tooltip',
    contractingLicenseAssignmentDeviceCountTooltip: 'Number of devices tooltip',
    contractingLicenseAssignmentNameTooltip: 'License name tooltip',
    contractingLicenseAssignmentTitleTooltip: 'License title tooltip',
    contractingLicenseAssignmentDescriptionTooltip: 'License description tooltip',
    contractingCreateLicenseAssignment: 'Create a new license entry',
    contractingCreateLicenseAssignmentHelpTextPre: 'Create a new license entry for the license overview here. Fill in at least all required fields and attach the relevant license documents whenever possible.',
    contractingCreateLicenseAssignmentHelpTextAfter: 'After saving, the created license is immediately available in the license overview.',
    contractingUpdateLicenseAssignment: 'Update an existing license entry',
    contractingUpdateLicenseAssignmentHelpTextPre: 'Update an existing license entry for the license overview here. Fill in at least all required fields and attach the relevant license documents whenever possible.',
    contractingUpdateLicenseAssignmentHelpTextAfter: 'After saving, the license is immediately updated in the license overview.',
    contractingUpdateLicenseAssignmentCreateConfirmation: 'Are you sure you want to cancel creating a new license?',
    contractingUpdateLicenseAssignmentUpdateConfirmation: 'Are you sure you want to cancel updating the existing license ({{guid}})?',
    contractingUpdateLicenseAssignmentDeleteConfirmation: 'Are you sure you want to delete the existing license ({{guid}})?',
    contractingUpdateLicenseAssignmentNotificationCreateCancel: 'Creating the new license was cancelled.',
    contractingUpdateLicenseAssignmentNotificationCreateSuccess: 'The new license was created successfully.',
    contractingUpdateLicenseAssignmentNotificationUpdateCancel: 'Updating the existing license ({{guid}}) was cancelled.',
    contractingUpdateLicenseAssignmentNotificationUpdateSuccess: 'The existing license ({{guid}}) was updated successfully.',
    contractingUpdateLicenseAssignmentNotificationDeleteSuccess: 'The existing license ({{guid}}) was deleted successfully.',
    navDeviceData: 'Device overview',
    tableDeviceData: 'Device overview table',
    emptyPageTextDeviceData: 'No device entries have been created yet. Choose from the following options:',
    contractingDeviceDataGuidLabel: 'Guid',
    contractingDeviceDataCreatedAtLabel: 'CreatedAt',
    contractingDeviceDataUpdatedAtLabel: 'UpdatedAt',
    contractingDeviceDataCreatedByLabel: 'CreatedBy',
    contractingDeviceDataUpdatedByLabel: 'UpdatedBy',
    contractingDeviceDataMachineUniqueIdLabel: 'MachineUniqueId',
    contractingDeviceDataMachineHostNameLabel: 'MachineHostName',
    contractingDeviceDataCpuArchitectureLabel: 'CpuArchitecture',
    contractingDeviceDataKernelTypeLabel: 'KernelType',
    contractingDeviceDataKernelVersionLabel: 'KernelVersion',
    contractingDeviceDataPrettyProductNameLabel: 'PrettyProductName',
    contractingDeviceDataProductTypeLabel: 'ProductType',
    contractingDeviceDataProductVersionLabel: 'ProductVersion',
    contractingDeviceDataInstallationDateLabel: 'InstallationDate',
    contractingDeviceDataActiveLabel: 'Active',
    contractingDeviceDataMachineUserLabel: 'MachineUser',
    contractingDeviceDataIpV6Label: 'IpV6',
    contractingDeviceDataIpV4Label: 'IpV4',
    contractingDeviceDataNoteLabel: 'Note',
    contractingDeviceDataGuidToolTip: 'Guid',
    contractingDeviceDataCreatedAtToolTip: 'Created At',
    contractingDeviceDataUpdatedAtToolTip: 'Updated At',
    contractingDeviceDataCreatedByToolTip: 'Created By',
    contractingDeviceDataUpdatedByToolTip: 'Updated By',
    contractingDeviceDataMachineUniqueIdToolTip: 'Machine Unique Id',
    contractingDeviceDataMachineHostNameToolTip: 'Machine Host Name',
    contractingDeviceDataCpuArchitectureToolTip: 'Cpu Architecture',
    contractingDeviceDataKernelTypeToolTip: 'Kernel Type',
    contractingDeviceDataKernelVersionToolTip: 'Kernel Version',
    contractingDeviceDataPrettyProductNameToolTip: 'Pretty Product Name',
    contractingDeviceDataProductTypeToolTip: 'Product Type',
    contractingDeviceDataProductVersionToolTip: 'Product Version',
    contractingDeviceDataInstallationDateToolTip: 'Installation Date',
    contractingDeviceDataActiveToolTip: 'Active',
    contractingDeviceDataMachineUserToolTip: 'Machine User',
    contractingDeviceDataIpV6ToolTip: 'Ip V6',
    contractingDeviceDataIpV4ToolTip: 'Ip V4',
    contractingDeviceDataNoteToolTip: 'Note',
    contractingDeviceDataGuidPlaceholder: 'Guid',
    contractingDeviceDataCreatedAtPlaceholder: 'Created At',
    contractingDeviceDataUpdatedAtPlaceholder: 'Updated At',
    contractingDeviceDataCreatedByPlaceholder: 'Created By',
    contractingDeviceDataUpdatedByPlaceholder: 'Updated By',
    contractingDeviceDataMachineUniqueIdPlaceholder: 'Machine Unique Id',
    contractingDeviceDataMachineHostNamePlaceholder: 'Machine Host Name',
    contractingDeviceDataCpuArchitecturePlaceholder: 'Cpu Architecture',
    contractingDeviceDataKernelTypePlaceholder: 'Kernel Type',
    contractingDeviceDataKernelVersionPlaceholder: 'Kernel Version',
    contractingDeviceDataPrettyProductNamePlaceholder: 'Pretty Product Name',
    contractingDeviceDataProductTypePlaceholder: 'Product Type',
    contractingDeviceDataProductVersionPlaceholder: 'Product Version',
    contractingDeviceDataInstallationDatePlaceholder: 'Installation Date',
    contractingDeviceDataActivePlaceholder: 'Active',
    contractingDeviceDataMachineUserPlaceholder: 'Machine User',
    contractingDeviceDataIpV6Placeholder: 'Ip V6',
    contractingDeviceDataIpV4Placeholder: 'Ip V4',
    contractingDeviceDataNotePlaceholder: 'Note',
    contractingCreateDeviceData: 'Create a new device entry',
    contractingCreateDeviceDataHelpTextPre: 'Create a new device entry for the device overview here. Fill in at least all required fields and attach the relevant device documents whenever possible.',
    contractingCreateDeviceDataHelpTextAfter: 'After saving, the created device is immediately available in the device overview.',
    contractingUpdateDeviceData: 'Update an existing device data entry',
    contractingUpdateDeviceDataHelpTextPre: 'Update an existing device entry for the device overview here. Fill in at least all required fields and attach the relevant device documents whenever possible.',
    contractingUpdateDeviceDataHelpTextAfter: 'After saving, the device is immediately updated in the device overview.',
    contractingUpdateDeviceDataCreateConfirmation: 'Are you sure you want to cancel creating a new device?',
    contractingUpdateDeviceDataUpdateConfirmation: 'Are you sure you want to cancel updating the existing device ({{guid}})?',
    contractingUpdateDeviceDataDeleteConfirmation: 'Are you sure you want to delete the existing device ({{guid}})?',
    contractingUpdateDeviceDataNotificationCreateCancel: 'Creating the new device was cancelled.',
    contractingUpdateDeviceDataNotificationCreateSuccess: 'The new device was created successfully.',
    contractingUpdateDeviceDataNotificationUpdateCancel: 'Updating the existing device ({{guid}}) was cancelled.',
    contractingUpdateDeviceDataNotificationUpdateSuccess: 'The existing device ({{guid}}) was updated successfully.',
    contractingUpdateDeviceDataNotificationDeleteSuccess: 'The existing device ({{guid}}) was deleted successfully.',
    navLicenseData: 'License overview',
    tableLicenseData: 'License overview table',
    emptyPageTextLicenseData: 'No license entries have been created yet. Choose from the following options:',
    contractingLicenseDataGuidLabel: 'Guid',
    contractingLicenseDataCreatedAtLabel: 'CreatedAt',
    contractingLicenseDataUpdatedAtLabel: 'UpdatedAt',
    contractingLicenseDataCreatedByLabel: 'CreatedBy',
    contractingLicenseDataUpdatedByLabel: 'UpdatedBy',
    contractingLicenseDataLicenseIdLabel: 'LicenseId',
    contractingLicenseDataLicenceValidLabel: 'LicenceValid',
    contractingLicenseDataLicenseTypeLabel: 'LicenseType',
    contractingLicenseDataLicensePeriodLabel: 'LicensePeriod',
    contractingLicenseDataProductNameLabel: 'ProductName',
    contractingLicenseDataProductVersionLabel: 'ProductVersion',
    contractingLicenseDataProductDescriptionLabel: 'ProductDescription',
    contractingLicenseDataLicenceStartLabel: 'LicenceStart',
    contractingLicenseDataLicenceExpiresLabel: 'LicenceExpires',
    contractingLicenseDataAutoRenewEnabledLabel: 'AutoRenewEnabled',
    contractingLicenseDataUserAllowedLabel: 'UserAllowed',
    contractingLicenseDataUserAssignedLabel: 'UserAssigned',
    contractingLicenseDataUserLeftLabel: 'UserLeft',
    contractingLicenseDataDevicesAllowedLabel: 'DevicesAllowed',
    contractingLicenseDataDevicesAssignedLabel: 'DevicesAssigned',
    contractingLicenseDataDevicesLeftLabel: 'DevicesLeft',
    contractingLicenseDataLicenseKeyLabel: 'LicenseKey',
    contractingLicenseDataFallbackProductVersionLabel: 'FallbackProductVersion',
    contractingLicenseDataTerminationPeriodLabel: 'TerminationPeriod',
    contractingLicenseDataTerminationDateLabel: 'TerminationDate',
    contractingLicenseDataLicenseCostLabel: 'LicenseCost',
    contractingLicenseDataLicenseCostPerUserYearLabel: 'LicenseCostPerUserYear',
    contractingLicenseDataAttachmentListLabel: 'AttachmentList',
    contractingLicenseDataGuidToolTip: 'Guid',
    contractingLicenseDataCreatedAtToolTip: 'Created At',
    contractingLicenseDataUpdatedAtToolTip: 'Updated At',
    contractingLicenseDataCreatedByToolTip: 'Created By',
    contractingLicenseDataUpdatedByToolTip: 'Updated By',
    contractingLicenseDataLicenseIdToolTip: 'License Id',
    contractingLicenseDataLicenceValidToolTip: 'Licence Valid',
    contractingLicenseDataLicenseTypeToolTip: 'License Type',
    contractingLicenseDataLicensePeriodToolTip: 'License Period',
    contractingLicenseDataProductNameToolTip: 'Product Name',
    contractingLicenseDataProductVersionToolTip: 'Product Version',
    contractingLicenseDataProductDescriptionToolTip: 'Product Description',
    contractingLicenseDataLicenceStartToolTip: 'Licence Start',
    contractingLicenseDataLicenceExpiresToolTip: 'Licence Expires',
    contractingLicenseDataAutoRenewEnabledToolTip: 'Auto Renew Enabled',
    contractingLicenseDataUserAllowedToolTip: 'User Allowed',
    contractingLicenseDataUserAssignedToolTip: 'User Assigned',
    contractingLicenseDataUserLeftToolTip: 'User Left',
    contractingLicenseDataDevicesAllowedToolTip: 'Devices Allowed',
    contractingLicenseDataDevicesAssignedToolTip: 'Devices Assigned',
    contractingLicenseDataDevicesLeftToolTip: 'Devices Left',
    contractingLicenseDataLicenseKeyToolTip: 'License Key',
    contractingLicenseDataFallbackProductVersionToolTip: 'Fallback Product Version',
    contractingLicenseDataTerminationPeriodToolTip: 'Termination Period',
    contractingLicenseDataTerminationDateToolTip: 'Termination Date',
    contractingLicenseDataLicenseCostToolTip: 'License Cost',
    contractingLicenseDataLicenseCostPerUserYearToolTip: 'License Cost Per User Year',
    contractingLicenseDataAttachmentListToolTip: 'Attachment List',
    contractingLicenseDataGuidPlaceholder: 'Guid',
    contractingLicenseDataCreatedAtPlaceholder: 'Created At',
    contractingLicenseDataUpdatedAtPlaceholder: 'Updated At',
    contractingLicenseDataCreatedByPlaceholder: 'Created By',
    contractingLicenseDataUpdatedByPlaceholder: 'Updated By',
    contractingLicenseDataLicenseIdPlaceholder: 'License Id',
    contractingLicenseDataLicenceValidPlaceholder: 'Licence Valid',
    contractingLicenseDataLicenseTypePlaceholder: 'License Type',
    contractingLicenseDataLicensePeriodPlaceholder: 'License Period',
    contractingLicenseDataProductNamePlaceholder: 'Product Name',
    contractingLicenseDataProductVersionPlaceholder: 'Product Version',
    contractingLicenseDataProductDescriptionPlaceholder: 'Product Description',
    contractingLicenseDataLicenceStartPlaceholder: 'Licence Start',
    contractingLicenseDataLicenceExpiresPlaceholder: 'Licence Expires',
    contractingLicenseDataAutoRenewEnabledPlaceholder: 'Auto Renew Enabled',
    contractingLicenseDataUserAllowedPlaceholder: 'User Allowed',
    contractingLicenseDataUserAssignedPlaceholder: 'User Assigned',
    contractingLicenseDataUserLeftPlaceholder: 'User Left',
    contractingLicenseDataDevicesAllowedPlaceholder: 'Devices Allowed',
    contractingLicenseDataDevicesAssignedPlaceholder: 'Devices Assigned',
    contractingLicenseDataDevicesLeftPlaceholder: 'Devices Left',
    contractingLicenseDataLicenseKeyPlaceholder: 'License Key',
    contractingLicenseDataFallbackProductVersionPlaceholder: 'Fallback Product Version',
    contractingLicenseDataTerminationPeriodPlaceholder: 'Termination Period',
    contractingLicenseDataTerminationDatePlaceholder: 'Termination Date',
    contractingLicenseDataLicenseCostPlaceholder: 'License Cost',
    contractingLicenseDataLicenseCostPerUserYearPlaceholder: 'License Cost Per User Year',
    contractingLicenseDataAttachmentListPlaceholder: 'Attachment List',
    contractingCreateLicenseData: 'Create a new license entry',
    contractingCreateLicenseDataHelpTextPre: 'Create a new license entry for the license overview here. Fill in at least all required fields and attach the relevant license documents whenever possible.',
    contractingCreateLicenseDataHelpTextAfter: 'After saving, the created license is immediately available in the license overview.',
    contractingUpdateLicenseData: 'Update an existing license entry',
    contractingUpdateLicenseDataHelpTextPre: 'Update an existing license entry for the license overview here. Fill in at least all required fields and attach the relevant license documents whenever possible.',
    contractingUpdateLicenseDataHelpTextAfter: 'After saving, the license is immediately updated in the license overview.',
    contractingUpdateLicenseDataCreateConfirmation: 'Are you sure you want to cancel creating a new license?',
    contractingUpdateLicenseDataUpdateConfirmation: 'Are you sure you want to cancel updating the existing license ({{guid}})?',
    contractingUpdateLicenseDataDeleteConfirmation: 'Are you sure you want to delete the existing license ({{guid}})?',
    contractingUpdateLicenseDataNotificationCreateCancel: 'Creating the new license was cancelled.',
    contractingUpdateLicenseDataNotificationCreateSuccess: 'The new license was created successfully.',
    contractingUpdateLicenseDataNotificationUpdateCancel: 'Updating the existing license ({{guid}}) was cancelled.',
    contractingUpdateLicenseDataNotificationUpdateSuccess: 'The existing license ({{guid}}) was updated successfully.',
    contractingUpdateLicenseDataNotificationDeleteSuccess: 'The existing license ({{guid}}) was deleted successfully.',
    navArticle: 'Article overview',
    tableArticle: 'Article overview table',
    emptyPageTextArticle: 'No article entries have been created yet. Choose from the following options:',
    inventoryArticleGuidLabel: 'Universally unique identifier',
    inventoryArticleCreatedAtLabel: 'Created at',
    inventoryArticleUpdatedAtLabel: 'Updated at',
    inventoryArticleCreatedByLabel: 'Created by',
    inventoryArticleUpdatedByLabel: 'Updated by',
    inventoryArticleBrandLabel: 'Brand',
    inventoryArticleProductImageLabel: 'Product image',
    inventoryArticleModelLabel: 'Model',
    inventoryArticleModelNumberLabel: 'Model number',
    inventoryArticleModelCategoryLabel: 'Category',
    inventoryArticleWeightLabel: 'Weight',
    inventoryArticleDimensionsLabel: 'Dimensions',
    inventoryArticleManufactureDateLabel: 'Manufacture date',
    inventoryArticleModelDescriptionLabel: 'Description',
    inventoryArticleLinkLabel: 'Link',
    inventoryArticleWarrantyLabel: 'Warranty',
    inventoryArticleGuidToolTip: 'Tooltip Universally unique identifier',
    inventoryArticleCreatedAtToolTip: 'Tooltip Created at',
    inventoryArticleUpdatedAtToolTip: 'Tooltip Updated at',
    inventoryArticleCreatedByToolTip: 'Tooltip Created by',
    inventoryArticleUpdatedByToolTip: 'Tooltip Updated by',
    inventoryArticleBrandToolTip: 'Tooltip Brand',
    inventoryArticleProductImageToolTip: 'Tooltip Product image',
    inventoryArticleModelToolTip: 'Tooltip Model',
    inventoryArticleModelNumberToolTip: 'Tooltip Model number',
    inventoryArticleModelCategoryToolTip: 'Tooltip Category',
    inventoryArticleWeightToolTip: 'Tooltip Weight',
    inventoryArticleDimensionsToolTip: 'Tooltip Dimensions',
    inventoryArticleManufactureDateToolTip: 'Tooltip Manufacture date',
    inventoryArticleModelDescriptionToolTip: 'Tooltip Description',
    inventoryArticleLinkToolTip: 'Tooltip Link',
    inventoryArticleWarrantyToolTip: 'Tooltip Warranty',
    inventoryArticleGuidPlaceholder: 'Universally unique identifier',
    inventoryArticleCreatedAtPlaceholder: 'Created at',
    inventoryArticleUpdatedAtPlaceholder: 'Updated at',
    inventoryArticleCreatedByPlaceholder: 'Created by',
    inventoryArticleUpdatedByPlaceholder: 'Updated by',
    inventoryArticleBrandPlaceholder: 'Brand',
    inventoryArticleProductImagePlaceholder: 'Product image',
    inventoryArticleModelPlaceholder: 'Model',
    inventoryArticleModelNumberPlaceholder: 'Model number',
    inventoryArticleModelCategoryPlaceholder: 'Category',
    inventoryArticleWeightPlaceholder: 'Weight',
    inventoryArticleDimensionsPlaceholder: 'Dimensions',
    inventoryArticleManufactureDatePlaceholder: 'Manufacture date',
    inventoryArticleModelDescriptionPlaceholder: 'Description',
    inventoryArticleLinkPlaceholder: 'Link',
    inventoryArticleWarrantyPlaceholder: 'Warranty',
    inventoryCreateArticle: 'Create a new article entry',
    inventoryCreateArticleHelpTextPre: 'Create a new article entry for the article overview here. Fill in at least all required fields and attach the relevant inventory documents whenever possible.',
    inventoryCreateArticleHelpTextAfter: 'After saving, the created article is immediately available in the article overview.',
    inventoryUpdateArticle: 'Update an existing article entry',
    inventoryUpdateArticleHelpTextPre: 'Update an existing article entry for the article overview here. Fill in at least all required fields and attach the relevant article documents whenever possible.',
    inventoryUpdateArticleHelpTextAfter: 'After saving, the article is immediately updated in the article overview.',
    inventoryUpdateArticleCreateConfirmation: 'Are you sure you want to cancel creating a new article?',
    inventoryUpdateArticleUpdateConfirmation: 'Are you sure you want to cancel updating the existing article ({{title}} - {{guid}})?',
    inventoryUpdateArticleDeleteConfirmation: 'Are you sure you want to delete the existing article ({{title}} - {{guid}})?',
    inventoryImportCsvArticleListDialogText: 'Import articles',
    inventoryImportCsvArticleListDialogSubText: 'Please select the CSV file to import new articles.',
    inventoryImportExcelArticleListDialogText: 'Import articles',
    inventoryImportExcelArticleListDialogSubText: 'Please select the Excel file to import new articles.',
    inventoryUpdateArticleNotificationCreateCancel: 'Creating the new article was cancelled.',
    inventoryUpdateArticleNotificationCreateSuccess: 'The new article ({{title}} - {{guid}}) was created successfully.',
    inventoryUpdateArticleNotificationCreateError: 'The new article could not be created.',
    inventoryUpdateArticleNotificationCreateUndefinedError: 'The new article could not be created because it is not specified.',
    inventoryUpdateArticleNotificationUpdateCancel: 'Updating the existing article ({{title}} - {{guid}}) was cancelled.',
    inventoryUpdateArticleNotificationUpdateSuccess: 'The existing article ({{title}} - {{guid}}) was updated successfully.',
    inventoryUpdateArticleNotificationUpdateError: 'The existing article ({{title}} - {{guid}}) could not be updated.',
    inventoryUpdateArticleNotificationUpdateUndefinedError: 'The existing article could not be updated because it is not specified.',
    inventoryUpdateArticleNotificationDeleteSuccess: 'The existing article ({{title}} - {{guid}}) was deleted successfully.',
    inventoryUpdateArticleNotificationDeleteError: 'The existing article ({{title}} - {{guid}}) could not be deleted.',
    inventoryUpdateArticleNotificationDeleteUndefinedError: 'The existing article could not be deleted because it is not specified.',
    inventoryUpdateArticleNotificationCreateListCancel: 'Creating the new articles was cancelled.',
    inventoryUpdateArticleNotificationCreateListSuccess: 'The new articles were created successfully.',
    inventoryUpdateArticleNotificationCreateListError: 'The new articles could not be created.',
    inventoryUpdateArticleNotificationCreateListUndefinedError: 'The new articles could not be created because none were specified.',
    inventoryUpdateArticleNotificationUpdateListCancel: 'Updating the existing articles ({{guidList}}) was cancelled.',
    inventoryUpdateArticleNotificationUpdateListSuccess: 'The existing articles ({{guidList}}) were updated successfully.',
    inventoryUpdateArticleNotificationUpdateListError: 'The existing articles ({{guidList}}) could not be updated.',
    inventoryUpdateArticleNotificationUpdateListUndefinedError: 'The existing article could not be deleted because it is not defined.',
    inventoryUpdateArticleNotificationDeleteListSuccess: 'The existing articles ({{guidList}}) were deleted successfully.',
    inventoryUpdateArticleNotificationDeleteListError: 'The existing articles ({{guidList}}) could not be deleted.',
    inventoryUpdateArticleNotificationDeleteListUndefinedError: 'The existing article could not be deleted because it is not defined.',
    navComputer: 'Computer overview',
    tableComputer: 'Computer overview table',
    emptyPageTextComputer: 'No computer entries have been created yet. Choose from the following options:',
    inventoryComputerTypeLabel: 'Type',
    inventoryComputerWLANLabel: 'Wi-Fi',
    inventoryComputerBluetoothLabel: 'Bluetooth',
    inventoryComputerCellularLabel: 'Cellular',
    inventoryComputerDisplayLabel: 'Display',
    inventoryComputerPowerConsumptionIdleLabel: 'Power consumption while idle',
    inventoryComputerPowerConsumptionFullLabel: 'Power consumption under full load',
    inventoryComputerConnectionListLabel: 'Connections',
    inventoryComputerTypeToolTip: 'Tooltip Type',
    inventoryComputerWLANToolTip: 'Tooltip Wi-Fi',
    inventoryComputerBluetoothToolTip: 'Tooltip Bluetooth',
    inventoryComputerCellularToolTip: 'Tooltip Cellular',
    inventoryComputerDisplayToolTip: 'Tooltip Display',
    inventoryComputerPowerConsumptionIdleToolTip: 'Tooltip Power consumption while idle',
    inventoryComputerPowerConsumptionFullToolTip: 'Tooltip Power consumption under full load',
    inventoryComputerConnectionListToolTip: 'Tooltip Connections',
    inventoryComputerTypePlaceholder: 'Type',
    inventoryComputerWLANPlaceholder: 'Wi-Fi',
    inventoryComputerBluetoothPlaceholder: 'Bluetooth',
    inventoryComputerCellularPlaceholder: 'Cellular',
    inventoryComputerDisplayPlaceholder: 'Display',
    inventoryComputerPowerConsumptionIdlePlaceholder: 'Power consumption while idle',
    inventoryComputerPowerConsumptionFullPlaceholder: 'Power consumption under full load',
    inventoryComputerConnectionListPlaceholder: 'Connections',
    inventoryCreateComputer: 'Create a new computer entry',
    inventoryCreateComputerHelpTextPre: 'Create a new computer entry for the computer overview here. Fill in at least all required fields and attach the relevant inventory documents whenever possible.',
    inventoryCreateComputerHelpTextAfter: 'After saving, the created computer is immediately available in the computer overview.',
    inventoryUpdateComputer: 'Update an existing computer entry',
    inventoryUpdateComputerHelpTextPre: 'Update an existing computer entry for the computer overview here. Fill in at least all required fields and attach the relevant computer documents whenever possible.',
    inventoryUpdateComputerHelpTextAfter: 'After saving, the computer is immediately updated in the computer overview.',
    inventoryUpdateComputerCreateConfirmation: 'Are you sure you want to cancel creating a new computer?',
    inventoryUpdateComputerUpdateConfirmation: 'Are you sure you want to cancel updating the existing computer ({{guid}})?',
    inventoryUpdateComputerDeleteConfirmation: 'Are you sure you want to delete the existing computer ({{guid}})?',
    inventoryUpdateComputerNotificationCreateCancel: 'Creating the new computer was cancelled.',
    inventoryUpdateComputerNotificationCreateSuccess: 'The new computer was created successfully.',
    inventoryUpdateComputerNotificationUpdateCancel: 'Updating the existing computer ({{guid}}) was cancelled.',
    inventoryUpdateComputerNotificationUpdateSuccess: 'The existing computer ({{guid}}) was updated successfully.',
    inventoryUpdateComputerNotificationDeleteSuccess: 'The existing computer ({{guid}}) was deleted successfully.',
    navDisplay: 'Display overview',
    tableDisplay: 'Display overview table',
    emptyPageTextDisplay: 'No display entries have been created yet. Choose from the following options:',
    inventoryDisplayColorLabel: 'Color',
    inventoryDisplayDiagonalLabel: 'Diagonal',
    inventoryDisplayImageFormatLabel: 'Image format',
    inventoryDisplayResolutionLabel: 'Resolution',
    inventoryDisplayRefreshRateLabel: 'Refresh rate',
    inventoryDisplayResponseTimeLabel: 'Response time',
    inventoryDisplayContrastLabel: 'Contrast',
    inventoryDisplayBrightnessLabel: 'Brightness',
    inventoryDisplayShapeLabel: 'Shape',
    inventoryDisplayPanelLabel: 'Panel',
    inventoryDisplayViewingAngleLabel: 'Viewing angle',
    inventoryDisplayPowerConsumptionLabel: 'Power consumption',
    inventoryDisplayConnectionListLabel: 'Connections',
    inventoryDisplayColorToolTip: 'Tooltip Color',
    inventoryDisplayDiagonalToolTip: 'Tooltip Diagonal',
    inventoryDisplayImageFormatToolTip: 'Tooltip Image format',
    inventoryDisplayResolutionToolTip: 'Tooltip Resolution',
    inventoryDisplayRefreshRateToolTip: 'Tooltip Refresh rate',
    inventoryDisplayResponseTimeToolTip: 'Tooltip Response time',
    inventoryDisplayContrastToolTip: 'Tooltip Contrast',
    inventoryDisplayBrightnessToolTip: 'Tooltip Brightness',
    inventoryDisplayShapeToolTip: 'Tooltip Shape',
    inventoryDisplayPanelToolTip: 'Tooltip Panel',
    inventoryDisplayViewingAngleToolTip: 'Tooltip Viewing angle',
    inventoryDisplayPowerConsumptionToolTip: 'Tooltip Power consumption',
    inventoryDisplayConnectionListToolTip: 'Tooltip Connections',
    inventoryDisplayColorPlaceholder: 'Color',
    inventoryDisplayDiagonalPlaceholder: 'Diagonal',
    inventoryDisplayImageFormatPlaceholder: 'Image format',
    inventoryDisplayResolutionPlaceholder: 'Resolution',
    inventoryDisplayRefreshRatePlaceholder: 'Refresh rate',
    inventoryDisplayResponseTimePlaceholder: 'Response time',
    inventoryDisplayContrastPlaceholder: 'Contrast',
    inventoryDisplayBrightnessPlaceholder: 'Brightness',
    inventoryDisplayShapePlaceholder: 'Shape',
    inventoryDisplayPanelPlaceholder: 'Panel',
    inventoryDisplayViewingAnglePlaceholder: 'Viewing angle',
    inventoryDisplayPowerConsumptionPlaceholder: 'Power consumption',
    inventoryDisplayConnectionListPlaceholder: 'Connections',
    inventoryCreateDisplay: 'Create a new display entry',
    inventoryCreateDisplayHelpTextPre: 'Create a new display entry for the display overview here. Fill in at least all required fields and attach the relevant inventory documents whenever possible.',
    inventoryCreateDisplayHelpTextAfter: 'After saving, the created display is immediately available in the display overview.',
    inventoryUpdateDisplay: 'Update an existing display entry',
    inventoryUpdateDisplayHelpTextPre: 'Update an existing display entry for the display overview here. Fill in at least all required fields and attach the relevant display documents whenever possible.',
    inventoryUpdateDisplayHelpTextAfter: 'After saving, the display is immediately updated in the display overview.',
    inventoryUpdateDisplayCreateConfirmation: 'Are you sure you want to cancel creating a new display?',
    inventoryUpdateDisplayUpdateConfirmation: 'Are you sure you want to cancel updating the existing display ({{guid}})?',
    inventoryUpdateDisplayDeleteConfirmation: 'Are you sure you want to delete the existing display ({{guid}})?',
    inventoryUpdateDisplayNotificationCreateCancel: 'Creating the new display was cancelled.',
    inventoryUpdateDisplayNotificationCreateSuccess: 'The new display was created successfully.',
    inventoryUpdateDisplayNotificationUpdateCancel: 'Updating the existing display ({{guid}}) was cancelled.',
    inventoryUpdateDisplayNotificationUpdateSuccess: 'The existing display ({{guid}}) was updated successfully.',
    inventoryUpdateDisplayNotificationDeleteSuccess: 'The existing display ({{guid}}) was deleted successfully.',
    variableTypeLabel: 'Variable type',
    variableTypeToolTip: 'Variable data type',
    variableTypePlaceholder: 'Variable data type',
    general_workTime: 'Work time',
    general_appointment: 'Appointment',
    general_specialLeave: 'Special Leave',
    resourceManager_vacationApproved_decidedBy_label: 'Decided by',
    resourceManager_vacationApproved_decidedAt_label: 'Decided at',
    resourceManager_vacationApproved_decisionComment_label: 'Decision comment',

    account_accountPersonalData_language_header: 'Language',
    account_accountPersonalData_language_text: 'The selected language is used for the interface, API messages, notifications, and emails.',
    account_accountPersonalData_language_label: 'Language',
    validation_endAfterStart: 'The end must be after the start.',
    validation_singleCalendarDay: 'This entry type may only cover a single calendar day.',
    validation_workTimeMaxHours: 'Work time may not exceed {{maxHours}} hours.',
    validation_absenceMaxHours: 'Absence may not exceed {{maxHours}} hours.',

    // Translation audit: keys referenced by frontend UI/metadata.
    ContactDetailHeader: 'Contact details',
    NoStatus: 'No status',
    acquise: 'Acquisition',
    alignmentHorizontal: 'Align horizontally',
    alignmentVertical: 'Align vertically',
    account_accountCalendar_advancedOAuthSettings_label: 'Advanced OAuth settings',
    account_accountCalendar_advancedOAuthSettings_text: 'Optional advanced OAuth settings for this calendar integration.',
    calendar_contextMenu_untilThisPoint_title: 'Status up to this day',
    calendar_contextMenu_overtimeUntil: 'Overtime up to this day',
    calendar_contextMenu_sickDaysUntil: 'Sick days up to this day',
    calendar_contextMenu_vacationUntil: 'Vacation days up to this day',
    calendar_action_openDay: 'Open day',
    calendar_action_cancelVacation: 'Cancel vacation',
    calendar_action_cancelSick: 'Cancel sick leave',
    calendar_noContractInPeriod: 'No employment contract is defined for this period.',
    crm_effortTypes_formHeader_header: 'Effort types',
    crm_task_taskEfforts_label: 'Efforts',
    generalWarning: 'Warning',
    generalInfo: 'Information',
    generalFilter: 'Filter',
    generalDownload: 'Download',
    adminUserVisibleInApplication: 'Visible in application',
    generalUpdated: 'Updated',
    general_customer: 'Customer',
    general_nr: 'No.',
    crm_project_createOffer_tooltip: 'Create an offer for this project',
    crm_project_createInvoice_tooltip: 'Create an invoice for this project',
    crm_project_merge_tooltip: 'Merge this project',
    crm_project_merge_title: 'Merge projects',
    crm_project_merge_description: 'Select the duplicate project and the project that should remain.',
    crm_project_merge_source_label: 'Project to replace',
    crm_project_merge_target_label: 'Target project',
    crm_project_merge_confirm_button: 'Merge projects',
    crm_project_merge_warning: 'The source project is removed after every reference has been moved successfully. This action cannot be undone.',
    crm_project_merge_success_title: 'Projects merged',
    crm_project_merge_success_text: '{{movedReferences}} references moved. {{removedDuplicateReferences}} duplicate references removed.',
    general_inactive: 'Inactive',
    general_logout_button: 'Log out',
    notFound_description: 'Sorry, we could not find the page you are looking for.',
    notFound_back_button: 'Go back',
    billing_action_preview: 'Preview',
    billing_action_previewFullscreen_tooltip: 'Open preview in full screen',
    general_print_button: 'Print',
    fibu_offer_downloadFinalPdf_tooltip: 'Download final offer PDF',
    fibu_offer_deleteDraft_tooltip: 'Delete offer draft',
    fibu_offer_cancel_tooltip: 'Cancel offer',
    billing_action_finalize: 'Finalize',
    fibu_offer_invoiceDraft_action: 'Invoice draft',
    fibu_offer_invoiceDraft_tooltip: 'Create a complete one-time invoice draft from the offer',
    billing_position_manual_label: 'Manual position',
    general_downloadPdf_tooltip: 'Download PDF',
    general_moreActions_tooltip: 'More actions',
    general_edit_button: 'Edit',
    fibu_offer_send_action: 'Send offer',
    fibu_offer_markAccepted_action: 'Mark as accepted',
    fibu_offer_markRejected_action: 'Mark as rejected',
    billing_position_projectCalculation_label: 'Project calculation',
    fibu_invoice_exportPdf_action: 'Export as PDF',
    fibu_invoice_exportXRechnung_action: 'Export as XRechnung XML',
    fibu_invoice_exportZugferd_action: 'Export as ZUGFeRD XML',
    fibu_invoice_exportEdifact_action: 'Export as EDIFACT INVOIC D.07A',
    fibu_invoice_exportVda_action: 'Export as Volkswagen VDA 4938 T2',
    fibu_invoice_downloadOriginal_action: 'Download original document',
    general_duplicate_button: 'Duplicate',
    fibu_invoice_newRevision_action: 'Correct / new revision',
    fibu_invoice_send_action: 'Send invoice',
    fibu_invoice_markPaid_action: 'Mark as paid',
    general_close_button: 'Close',
    fibu_invoice_exportInvoiceAndTimesheet_action: 'Invoice + timesheet',
    fibu_invoice_exportInvoiceAndTimesheet_tooltip: 'Download current invoice and associated timesheet',
    fibu_invoice_downloadCurrent_tooltip: 'Download current invoice',
    fibu_invoice_timesheet_label: 'Timesheet',
    fibu_invoice_downloadTimesheet_tooltip: 'Download the timesheet for the current invoice',
    fibu_invoice_exportAllInvoicesAndTimesheets_action: 'All invoices + timesheets',
    fibu_invoice_exportAllInvoicesAndTimesheets_tooltip: 'Download all open invoices and associated timesheets',
    general_export_button: 'Export',
    fibu_invoice_export_tooltip: 'Export invoice and timesheets',
    fibu_invoice_deleteDraft_tooltip: 'Delete invoice draft',
    fibu_invoice_newRevision_shortAction: 'New revision',
    fibu_invoice_newRevision_tooltip: 'Create a new invoice revision',
    fibu_invoice_cancel_tooltip: 'Cancel invoice',
    fibu_invoice_deleteCancelled_tooltip: 'Permanently delete cancelled invoice',
    fibu_invoice_projectRemainingBudget_label: 'Remaining project budget',
    fibu_invoice_assignmentSection_description: 'Clearly assign customer, contact person, billing address and project.',
    fibu_invoice_createContact_action: 'Create contact person',
    fibu_invoice_createContact_tooltip: 'Create a new contact person directly for this customer',
    fibu_invoice_createAddress_action: 'Create address',
    fibu_invoice_createAddress_tooltip: 'Create a new billing address directly for this customer',
    fibu_invoice_detailsSection_description: 'Invoice date, service period, due date and subject.',
    fibu_invoice_scopeSection_description: 'Use project services, budgets or an offer as the basis for invoice positions.',
    fibu_invoice_positionsSection_description: 'Enter and sort positions and review prices and VAT.',
    fibu_invoice_textsSection_description: 'Text blocks, payment terms, bank account, closing text and internal note.',
    billing_position_duplicated_label: 'Duplicated position',
    fibu_offer_projectLoading_text: 'Project and customer data are being loaded for the new offer …',
    billing_drafts_label: 'Drafts',
    fibu_offer_finalOrSent_label: 'Final / sent',
    fibu_offer_accepted_label: 'Accepted',
    billing_selectedVolume_label: 'Selected volume',
    general_search_label: 'Search',
    general_allStatuses: 'All statuses',
    fibu_offer_loading_text: 'Offers are loading …',
    billing_net_label: 'Net',
    billing_gross_label: 'Gross',
    fibu_offer_validUntil_label: 'Valid until',
    billing_assignment_label: 'Assignment',
    fibu_offer_details_label: 'Offer details',
    billing_calculation_label: 'Calculation',
    billing_positions_label: 'Positions',
    billing_texts_label: 'Texts',
    billing_beforeFinalizeCheck_label: 'Check before finalizing',
    billing_recipientAssignment_header: 'Recipient and assignment',
    billing_recipientAssignment_description: 'Clearly assign customer, contact person and project.',
    fibu_offer_address_label: 'Offer address',
    billing_noAddress_hint: 'No address has been stored yet.',
    fibu_offer_details_description: 'Date, validity and subject of the offer.',
    fibu_offer_projectSource_header: 'Position source from project',
    fibu_offer_projectSource_description: 'Optionally copy budget or planned hours once as editable positions. Afterwards continue only in the Positions section.',
    billing_basis_label: 'Basis',
    billing_projectBudget_label: 'Project budget',
    billing_totalHours_label: 'Total hours',
    billing_hoursPerTask_label: 'Hours per task',
    billing_hoursPerMember_label: 'Hours per employee',
    billing_projectFlatRate_label: 'Project flat rate (manual price)',
    billing_allTasksIfNone_hint: 'No selection means all tasks are used.',
    billing_allMembersIfNone_hint: 'No selection means all employees are used.',
    fibu_offer_generatePositions_button: 'Generate positions from project',
    billing_positionsPrices_header: 'Positions and prices',
    billing_positionsPrices_description: 'Edit description, quantity, unit, price and VAT directly. Totals are calculated automatically.',
    billing_textPayment_header: 'Text blocks and payment terms',
    billing_templatePriority_description: 'Project default before customer default, last document and company default. Texts remain freely editable afterwards.',
    billing_intro_label: 'Introduction',
    fibu_offer_intro_description: 'Displayed before the positions in the offer.',
    billing_paymentTerms_header: 'Payment terms',
    fibu_offer_paymentTerms_description: 'The payment target controls the due date; the text appears on the offer.',
    billing_discount_enable_label: 'Grant discount',
    billing_bankAccount_label: 'Bank account for incoming payments',
    billing_noBankAccount_hint: 'No bank account is stored in company data.',
    billing_closingInternal_header: 'Closing text and internal note',
    fibu_offer_closingInternal_description: 'The closing text appears on the offer. The internal note remains in the system and is never printed on the document.',
    billing_closingText_label: 'Closing text',
    billing_closingText_description: 'Optional text after payment terms and positions.',
    billing_internalNote_label: 'Internal note',
    fibu_offer_internalNote_description: 'For internal notes only. This content is never printed on the offer.',
    fibu_offer_pageSubtitle: 'Create offers, calculate them from projects, finalize them and continue through invoicing.',
    fibu_offer_new_button: 'New offer',
    fibu_offer_search_placeholder: 'Number, customer, project or subject',
    fibu_offer_sections_ariaLabel: 'Offer sections',
    billing_customerSearch_placeholder: 'Search customer',
    billing_projectOptionalSearch_placeholder: 'Search project or leave empty',
    billing_buyerContact_label: 'Customer contact person',
    billing_contactSearch_placeholder: 'Search contact person',
    billing_createCustomerContact_tooltip: 'Create a contact person directly for this customer',
    billing_createCustomerAddress_tooltip: 'Create an address directly for this customer',
    billing_sellerContact_label: 'Internal contact person',
    billing_employeeSearch_placeholder: 'Search employee',
    billing_customerReference_label: 'Customer reference',
    billing_customerReference_placeholder: 'e.g. order number or contact person',
    fibu_offer_date_label: 'Offer date',
    billing_subject_label: 'Subject',
    fibu_offer_subject_placeholder: 'What is this offer about?',
    billing_hourlyRateNet_label: 'Net hourly rate',
    billing_plannedHours_label: 'Planned hours',
    billing_paymentTargetDays_label: 'Payment target in days',
    billing_discountPercent_label: 'Discount in %',
    billing_discountDays_label: 'Discount period in days',
    billing_paymentTerms_label: 'Payment terms',
    fibu_offer_draftFallback: 'Offer draft',
    billing_customerNotAssigned: 'Customer not assigned',
    fibu_offer_freeOffer: 'Free offer',
    fibu_offer_edit_title: 'Edit offer',
    fibu_offer_create_title: 'Create offer',
    billing_draft_label: 'Draft',
    fibu_invoice_projectLoading_text: 'Project, customer and invoice positions are being prepared …',
    fibu_invoice_openInvoices_label: 'Open invoices',
    fibu_invoice_overdue_label: 'Overdue',
    fibu_invoice_openAmount_label: 'Open amount',
    fibu_invoice_paymentStatus_label: 'Payment status',
    general_all: 'All',
    general_open: 'Open',
    fibu_invoice_paid_label: 'Paid',
    fibu_invoice_imported_label: 'Imported ·',
    fibu_invoice_delivery_label: 'Delivery',
    fibu_invoice_pageSubtitle: 'Create, review, finalize and transparently manage outgoing invoices.',
    fibu_invoice_new_button: 'New invoice',
    general_import_button: 'Import',
    fibu_invoice_search_placeholder: 'Number, customer, project or order',
    fibu_invoice_customerFilter_placeholder: 'All customers or search',
    fibu_invoice_projectFilter_placeholder: 'All projects or search',
    fibu_invoice_draftFallback: 'Invoice draft',
    fibu_invoice_freeInvoice: 'Free invoice',
    fibu_offer_status_draft: 'Draft',
    fibu_offer_status_finalized: 'Finalized',
    fibu_offer_status_sent: 'Sent',
    fibu_offer_status_accepted: 'Accepted',
    fibu_offer_status_rejected: 'Rejected',
    fibu_offer_status_expired: 'Expired',
    fibu_offer_status_cancelled: 'Cancelled',
    fibu_invoice_status_draft: 'Draft',
    fibu_invoice_status_finalized: 'Finalized',
    fibu_invoice_status_readyToSend: 'Ready to send',
    fibu_invoice_status_sent: 'Sent',
    fibu_invoice_status_partiallyPaid: 'Partially paid',
    fibu_invoice_status_paid: 'Paid',
    fibu_invoice_status_overdue: 'Overdue',
    fibu_invoice_status_cancelled: 'Cancelled',

    fibu_invoice_batchDrafts_ariaLabel: 'Invoice drafts in batch',
    general_previous_button: 'Previous',
    general_next_button: 'Next',
    fibu_invoice_batchPosition_label: 'Invoice {{current}} of {{total}}',
    fibu_invoice_freeInvoice_hint: 'Line items can be entered directly in the next section.',
    fibu_invoice_offerPositionsImported_hint: 'The line items were imported from {{offerNumber}}. They can still be adjusted in the draft.',
    fibu_invoice_sourceOfferFallback: 'the source offer',
    fibu_invoice_positionsFromOffer_label: 'Line items from {{offerNumber}}',
    fibu_invoice_serviceDataPeriod_label: 'Service data from {{from}} to {{to}}',
    fibu_invoice_billingBasis_label: 'Billing basis',
    fibu_invoice_billingBasis_projectTime: 'Summarize project time',
    fibu_invoice_billingBasis_entries: 'Individual time entries',
    fibu_invoice_billingBasis_tasks: 'Group time by tasks',
    fibu_invoice_billingBasis_members: 'Group time by employees',
    fibu_invoice_billingBasis_projectBudget: 'Bill project budget / contract',
    fibu_invoice_billingBasis_remainingBudget: 'Fixed price / outstanding project amount',
    fibu_invoice_fromOfferNumber_label: 'From offer {{offerNumber}}',
    fibu_invoice_fromOffer_label: 'Imported from offer',
    fibu_invoice_allTasksIfNone_hint: 'No selection means: bill all tasks.',
    general_useAll_button: 'Use all',
    fibu_invoice_noProjectTasks_hint: 'No tasks were found for this project.',
    fibu_invoice_splitByMembers_header: 'Split by employees',
    fibu_invoice_limitMembers_header: 'Limit employees',
    fibu_invoice_splitByMembers_hint: 'The invoice receives one line item per employee. No selection means all project employees.',
    fibu_invoice_limitMembers_hint: 'The selected employees are combined into one invoice line item. No selection means all project employees.',
    fibu_invoice_noProjectMembers_hint: 'No employees were found for this project.',
    fibu_invoice_projectBudgetsContracts_header: 'Project budgets and contracts',
    fibu_invoice_projectBudgetsContracts_hint: 'Select the budget against which the worked hours are invoiced.',
    general_clearSelection_button: 'Clear selection',
    fibu_invoice_noActiveHourBudgets_hint: 'No active hour budgets have been configured for this project yet.',
    fibu_invoice_offerPositionsEditable_hint: 'The line items were imported from the offer and can still be edited in the draft. For a partial invoice, unneeded offer line items can be removed or their quantities adjusted.',
    fibu_invoice_serviceEntries_label: 'Service entries',
    fibu_invoice_alreadyInvoicedExcluded_label: 'already invoiced excluded',
    fibu_invoice_remainingSelectedBudget_label: 'remaining in selected budget',
    fibu_invoice_outsideRemainingBudget_label: 'outside the remaining budget',
    fibu_invoice_timesheetPerMember_hint: 'Output timesheets separately for each employee. Without a selection, one combined timesheet is created.',
    fibu_invoice_applyRemainingProjectAmount_button: 'Use outstanding project amount as line item',
    fibu_invoice_applyBudgetTimes_button: 'Use budget times as line items',
    fibu_invoice_applyServiceData_button: 'Use service data as line items',
    fibu_invoice_intro_description: 'Displayed before the line items on the invoice.',
    fibu_invoice_paymentTerms_description: 'The payment term controls the due date; the text appears on the invoice.',
    fibu_invoice_restoreDefault_button: 'Restore default',
    fibu_invoice_preferredFormat_hint: 'preselected for sending and export',
    fibu_invoice_internalNote_description: 'For internal notes only. This content is never printed on the invoice.',

    fibu_offer_previewZoom_ariaLabel: 'Offer preview zoom',
    fibu_invoice_previewZoom_ariaLabel: 'Invoice preview zoom',
    general_zoomOut_tooltip: 'Zoom out',
    general_zoomIn_tooltip: 'Zoom in',
    general_resetZoom_tooltip: 'Reset to {{zoom}} %',
    general_closeFullscreen_tooltip: 'Close fullscreen',
    billing_selectCustomer_hint: 'Select customer',
    fibu_offer_selectAddress_hint: 'Select offer address',
    fibu_offer_documentTitle: 'Offer',
    billing_subjectMissing_hint: 'Subject missing',
    billing_position_shortLabel: 'Pos.',
    billing_description_label: 'Description',
    billing_quantity_label: 'Quantity',
    billing_unitPrice_label: 'Unit price',
    billing_totalPrice_label: 'Total price',
    billing_descriptionMissing_hint: 'Description missing',
    billing_subtotalCurrency_label: 'Subtotal in {{currency}}',
    billing_grandTotalCurrency_label: 'Grand total in {{currency}}',
    billing_documentNumber_label: 'Document number',
    billing_customerNumber_label: 'Your customer no.',
    general_selectPlease: 'Please select',
    billing_yourContact_label: 'Your contact',
    billing_managingDirectors_label: 'Managing directors',
    billing_bankDetails_label: 'Bank details',
    billing_taxOffice_label: 'Tax office',
    billing_taxNumber_label: 'Tax number',
    billing_registryCourt_label: 'Registry court',
    general_pageOf_label: 'Page {{page}} of {{total}}',
    billing_previewUpdating_label: 'Preview is updating',
    billing_previewStale_label: 'Preview is out of date',
    fibu_invoice_date_label: 'Invoice date',
    fibu_invoice_servicePeriod_label: 'Service period',
    fibu_invoice_orderNumber_label: 'Order no.',
    billing_extension_label: 'Extension',

    billing_textTemplate_save_title: 'Save text template',
    billing_textTemplate_scope_label: 'Scope',
    billing_textTemplate_scope_company: 'Company default',
    billing_textTemplate_scope_customer: 'Customer default',
    billing_textTemplate_scope_project: 'Project default',
    billing_textTemplate_preferredDefault_label: 'Use as preferred default',
    billing_textTemplate_empty_error: 'The current text is empty and cannot be saved as a template.',
    billing_textTemplate_saved_message: '{{scope}} saved.',
    billing_textTemplate_save_error: 'Text template could not be saved.',
    billing_textTemplate_template_label: 'Template',
    billing_textTemplate_default_label: 'Default',
    billing_textTemplate_defaultIntro_name: 'Default introduction',
    billing_textTemplate_defaultPaymentTerms_name: 'Default payment terms',
    billing_textTemplate_defaultClosing_name: 'Default closing text',
    billing_textTemplate_header: 'Templates and defaults',
    billing_textTemplate_priority_hint: 'Project defaults take precedence over customer defaults, the last document and company defaults.',
    billing_textTemplate_applyIntro_label: 'Apply introduction',
    billing_textTemplate_saveIntro_tooltip: 'Save current introduction as template',
    billing_textTemplate_applyPaymentTerms_label: 'Apply payment terms',
    billing_textTemplate_savePaymentTerms_tooltip: 'Save current payment terms as template',
    billing_textTemplate_applyClosing_label: 'Apply closing text',
    billing_textTemplate_saveClosing_tooltip: 'Save current closing text as template',
    billing_textTemplate_bookmark_hint: 'Use the bookmark to save the current text as a company, customer or project default.',

    resourceManager_calendarExport_timesheets_header: 'Timesheets',
    resourceManager_calendarExport_timesheets_description: 'Configure independently of the invoice whether and how timesheets are generated.',
    resourceManager_calendarExport_timesheetOutput_label: 'Timesheet output',
    resourceManager_calendarExport_timesheetNone_option: 'No timesheets',
    resourceManager_calendarExport_timesheetCombined_option: 'One combined document',
    resourceManager_calendarExport_timesheetSeparate_option: 'Separate per employee',
    resourceManager_calendarExport_timesheetSeparate_summary: 'Timesheets separated per employee',
    resourceManager_calendarExport_timesheetCombined_summary: 'One combined timesheet',
    resourceManager_calendarExport_invoiceCreation_header: 'Invoice creation',
    resourceManager_calendarExport_invoiceCreation_description: 'Create one combined invoice or a separate draft for each selected employee.',
    resourceManager_calendarExport_invoiceNone_option: 'Do not create an invoice',
    resourceManager_calendarExport_invoiceSingle_option: 'One combined invoice',
    resourceManager_calendarExport_invoicePerMember_option: 'One invoice per employee',
    resourceManager_calendarExport_invoicePositions_label: 'Invoice line items',
    resourceManager_calendarExport_positionsSummary_option: 'Sum times together',
    resourceManager_calendarExport_positionsMember_option: 'Sum times per employee',
    resourceManager_calendarExport_matchingBudgets_label: '{{count}} matching project budgets are considered.',
    resourceManager_calendarExport_budgetRates_hint: 'Invoice line items use the hourly rates stored in each budget. Different hourly rates are not artificially combined into a blended rate.',
    resourceManager_calendarExport_summary_header: 'Output summary',
    resourceManager_calendarExport_invoiceNone_summary: 'No invoice',
    resourceManager_calendarExport_invoicePerMember_summary: '{{count}} separate invoice drafts',
    resourceManager_calendarExport_invoiceBudget_summary: 'One invoice, budget line items with configured hourly rates',
    resourceManager_calendarExport_invoiceMemberPositions_summary: 'One invoice, line items per employee',
    resourceManager_calendarExport_invoiceCombined_summary: 'One combined invoice',
    resourceManager_calendarExport_invoicePermission_error: 'You do not have permission to create invoice drafts.',
    resourceManager_calendarExport_timesheetPermission_error: 'You do not have permission to export timesheets.',
    resourceManager_calendarExport_invoiceUserRequired_error: 'Please select at least one employee for the invoice.',
    resourceManager_calendarExport_outputRequired_error: 'Please select at least one output: timesheet or invoice.',

    fibu_invoice_preview_name: 'Invoice preview',
    fibu_invoice_title_number: 'Invoice {{invoiceNumber}}',
    fibu_invoice_new_title: 'New invoice',
    fibu_invoice_customerNotSelected_label: 'Customer not selected yet',
    fibu_invoice_noFinalPdf_message: 'No final PDF has been generated for this draft yet.',
    fibu_invoice_batchCompleteRequired_message: 'Please complete and save the required fields of this invoice before moving to the next invoice.',
    fibu_invoice_draftSaved_message: 'Draft was saved.',
    fibu_invoice_previewNotReady_message: 'The invoice preview is not ready yet.',
    fibu_invoice_finalized_message: 'Invoice {{invoiceNumber}} was finalized.',
    fibu_invoice_draftLoad_error: 'Invoice draft could not be loaded.',
    fibu_invoice_customerRequired_error: 'Please select a customer.',
    fibu_invoice_customerContactRequired_error: 'Please select a customer contact.',
    fibu_invoice_addressRequired_error: 'Please select a billing address.',
    fibu_invoice_contactNameRequired_error: 'Please specify a contact person.',
    fibu_invoice_recipientIncomplete_error: 'The invoice recipient is incomplete.',
    fibu_invoice_addressIncomplete_error: 'The billing address is incomplete. Street, postal code, city and country are required.',
    fibu_invoice_recipientEmailInvalid_error: 'The invoice recipient does not have a valid email address.',
    fibu_invoice_sellerContactRequired_error: 'Please select an internal contact.',
    fibu_invoice_bankAccountRequired_error: 'Please select a bank account.',
    fibu_invoice_subjectRequired_error: 'Please enter a service title.',
    fibu_invoice_subjectMaxLength_error: 'The service title may contain at most 250 characters.',
    fibu_invoice_orderNumberMaxLength_error: 'The order number may contain at most 100 characters.',
    fibu_invoice_customerReferenceMaxLength_error: 'The customer reference may contain at most 150 characters.',
    fibu_invoice_lineItemRequired_error: 'Please enter at least one complete invoice line item.',
    fibu_invoice_dateInvalid_error: 'Please select a valid invoice date.',
    fibu_invoice_servicePeriodInvalid_error: 'Please select a valid service period.',
    fibu_invoice_servicePeriodOrder_error: 'The service start must not be after the service end.',
    fibu_invoice_dueDateBeforeInvoiceDate_error: 'The due date must not be before the invoice date.',
    fibu_invoice_paymentTermsDays_error: 'The payment term must be between 0 and 3650 days.',
    fibu_invoice_discountDays_error: 'The discount period must be within the payment term.',
    fibu_invoice_paymentTermsRequired_error: 'Please specify payment terms.',
    fibu_invoice_paymentTermsMaxLength_error: 'The payment terms may contain at most 1000 characters.',
    fibu_invoice_hourlyRateRequired_error: 'A rate greater than 0 is required for time based billing.',
    fibu_invoice_projectBudgetRequired_error: 'Please select at least one project budget for billing.',
    fibu_invoice_paymentTermsOverride_label: 'Overridden for this invoice',
    fibu_invoice_projectBudgetSelect_message: 'Please select at least one project budget.',
    fibu_invoice_noBillableRemainingBudget_message: 'There is currently no billable remaining budget for the project.',
    fibu_invoice_remainingProjectAmount_description: '{{projectName}} · Fixed fee / outstanding project amount',
    fibu_invoice_timeEntry_label: 'Time entry',
    fibu_invoice_noBillableTimes_message: 'No billable time was found in the selected service period.',
    fibu_invoice_positionsGenerated_message: '{{count}} line items imported. {{details}}',
    fibu_invoice_serviceDataLoad_error: 'Service data could not be loaded: {{error}}',
    fibu_invoice_oneEmployee_label: '1 employee',
    fibu_invoice_selectedEmployees_label: '{{count}} selected employees',
    fibu_invoice_projectEmployeesCount_label: '{{count}} project employees',
    fibu_invoice_projectEmployees_label: 'Project employees',
    fibu_invoice_noExportableTimesheet_message: 'No exportable timesheet is available for this invoice.',
    fibu_invoice_noExportableServicePeriod_message: 'No exportable service period is available for this invoice.',
    fibu_invoice_noTimesheetEmployees_message: 'No employees could be determined for the project timesheet.',
    fibu_invoice_customerSearchEmpty_text: 'Search and select a customer',
    fibu_invoice_noProject_option: 'No project',
    fibu_invoice_contactsLoading_text: 'Contacts are loading',
    fibu_invoice_selectContact_text: 'Select contact',
    fibu_invoice_billingAddress_label: 'Billing address',
    fibu_invoice_selectBillingAddress_text: 'Select billing address',
    fibu_invoice_noAddress_text: 'No address configured yet',
    fibu_invoice_details_label: 'Invoice details',
    fibu_invoice_deliveryDate_label: 'Delivery date',
    fibu_invoice_serviceStart_label: 'Service start',
    fibu_invoice_serviceEnd_label: 'Service end',
    fibu_invoice_subject_label: 'Service title',
    fibu_invoice_scope_label: 'Service scope',
    fibu_invoice_defaultSubject: 'Service billing',
    fibu_invoice_systemDefault_label: 'System default',
    fibu_invoice_paymentTermsOverride_hint: 'Different from {{fallback}}. The change applies only to this invoice.',
    fibu_invoice_paymentTermsFromProject_hint: 'Taken from the payment terms of the selected project.',
    fibu_invoice_paymentTermsFromCustomer_hint: 'Taken from the customer default payment terms.',
    fibu_invoice_paymentTermsSystemDefault_hint: 'No project or customer default is configured. The system default applies.',
    fibu_invoice_sharedProjectBudget_label: 'Shared project budget',
    fibu_invoice_projectScopeLoad_error: 'Project scope could not be loaded: {{error}}',
    fibu_invoice_customerContactsLoad_error: 'Customer contacts could not be loaded: {{error}}',
    fibu_invoice_customerDetailsLoad_error: 'Customer details could not be loaded: {{error}}',
    fibu_invoice_customerNumberFallback: 'Customer #{{customerId}}',
    fibu_invoice_projectServicesSubject: 'Support services “{{projectName}}”',
    general_actionFailed_error: 'The action could not be completed.',

    fibu_invoice_dueDate_label: 'Due on',
    fibu_invoice_defaultPaymentTerms: '{{days}} days net without deduction.',
    fibu_invoice_defaultIntroText: 'According to your order, we invoice the following services:',
    fibu_invoice_defaultClosingText: 'Thank you for your order. We look forward to continuing our cooperation.',
    fibu_invoice_deliveryStatus_notSent: 'Not sent',
    fibu_invoice_deliveryStatus_sent: 'Sent',
    fibu_invoice_deliveryStatus_ready: 'Ready to send',
    fibu_invoice_copySubject: '{{subject}} copy',
    fibu_invoice_defaultCopySubject: 'Service billing copy',
    fibu_invoice_projectBilling_label: 'Project billing',

    fibu_invoice_imported_message: 'Invoice {{invoiceNumber}} was imported.',
    fibu_invoice_revisionCreated_message: 'Revision {{revision}} of {{invoiceNumber}} was created as a draft.',
    fibu_invoice_revisionCreate_error: 'Revision could not be created: {{error}}',
    fibu_invoice_duplicated_message: 'Invoice was duplicated as a new draft.',
    fibu_invoice_markedPaid_message: '{{invoiceNumber}} was marked as paid.',
    fibu_invoice_cancelled_message: '{{invoiceNumber}} was cancelled.',
    fibu_invoice_deleteActive_error: 'Active finalized invoices must be cancelled before deletion.',
    fibu_invoice_draftWithId_label: 'Draft {{id}}',
    fibu_invoice_deleted_message: 'Invoice {{invoice}} was deleted.',
    fibu_invoice_delete_error: 'Invoice could not be deleted: {{error}}',
    fibu_invoice_structuredExportDraft_error: 'Structured formats can only be exported after saving or finalizing.',
    fibu_invoice_noBatchExport_message: 'There are not multiple invoices open for export.',
    fibu_invoice_finalizeBeforeBatchExport_error: 'Please finalize all invoices first. {{count}} invoice(s) do not have a final PDF yet.',
    fibu_invoice_batchExportStarted_message: 'Export started for {{count}} invoices and related timesheets.',
    fibu_invoice_sent_message: '{{invoiceNumber}} was sent.',
    fibu_invoice_number_label: 'Invoice number',
    fibu_invoice_due_label: 'Due',
    fibu_invoice_noMatchingProjectBudget_error: 'No matching project budget was found for the selected employee.',
    fibu_invoice_projectService_label: 'Project service',
    fibu_invoice_customersLoad_error: 'Customers could not be loaded: {{error}}',
    fibu_invoice_projectsLoad_error: 'Projects could not be loaded: {{error}}',
    fibu_invoice_sellerContactsLoad_error: 'Internal contacts could not be loaded: {{error}}',
    fibu_invoice_projectBillingAddressLoad_error: 'The billing address of the project customer could not be loaded: {{error}}',
    fibu_invoice_positionsGenerate_error: 'Invoice line items could not be generated automatically: {{error}}',
    fibu_invoice_projectForCreationLoad_error: 'The project could not be loaded for invoice creation: {{error}}',

    general_unknownError: 'Unknown error',

    resourceManager_projectStatistics_budgetExport_receiver_hint: 'Company shown as recipient with address in the customer export.',
    resourceManager_projectStatistics_budgetExport_period_label: 'Evaluation period',
    resourceManager_projectStatistics_budgetExport_period_hint: 'Defaults to the end of the previous month.',
    resourceManager_projectStatistics_budgetExport_untilToday_button: 'Until today',
    resourceManager_projectStatistics_budgets_label: 'Budgets',
    resourceManager_weekStats_statistics_header: 'Statistics',
    resourceManager_weekStats_total_header: 'Total',
    resourceManager_weekStats_actual_header: 'Actual',
    resourceManager_weekStats_balance_header: 'Balance',
    resourceManager_weekStats_weekHoursTotal_label: 'Hrs/week total',
    resourceManager_weekStats_weekHoursToDate_label: 'Hrs/week to date',
    resourceManager_weekStats_overtimeTotal_label: 'Overtime (total)',
    resourceManager_weekStats_workDaysPerWeek_label: 'Workdays/week',
    billing_quickCreate_defaultAddress_label: 'Use as default address',
    billing_quickCreate_contactCreate_error: 'Contact could not be created: {{error}}',
    billing_quickCreate_addressCreate_error: 'Address could not be created: {{error}}',
    general_dataTools_button: 'Data tools',
    general_details_button: 'Details',
    resourceManager_calendarStatistic_vacationDays_label: 'Vacation days',
    general_actionCompleted: 'Action completed successfully.',
    fibu_ocrImport_bookingsImported_message: '{{count}} bookings imported successfully.',
    fibu_ocrImport_bookingsFailed_message: 'Errors for bookings: {{files}}',
    notification_close_ariaLabel: 'Close notification',

    resourceManager_projectStatistics_serviceValue_label: 'Service value',
    notification_center_title: 'Notifications',
    notification_center_empty: 'No notifications available',
    billing_addPosition_action: 'Add position',
    administration_companyLogo_subtitle: 'Manage company logo',
    administration_noContent_text: 'No content is currently available for this area.',
    administration_environment_global_header: 'Global environment',
    administration_environment_companyName_label: 'Company name',
    administration_environment_aspNet_label: 'ASP.NET environment',
    administration_environment_paths_header: 'Paths and directories',
    administration_environment_endpoints_header: 'Endpoints',
    administration_addresses_title: 'Addresses',
    administration_addresses_description: 'View and edit company addresses',
    administration_addresses_subtitle: 'Stored company addresses and delivery information',
    administration_payment_title: 'Payment details',
    administration_payment_description: 'Manage bank accounts and payment methods',
    administration_payment_newAccount_button: 'New account',
    administration_payment_accounts_title: 'Bank accounts',
    administration_payment_accounts_subtitle: 'Manage default accounts, IBAN and payment information',
    calendar_previousYearRange_ariaLabel: 'Show previous year range',
    calendar_nextYearRange_ariaLabel: 'Show next year range',

    general_notImplemented: 'This area is not implemented yet.',
    general_moreActions_ariaLabel: 'More actions',
    product_featureMenu_ariaLabel: 'Feature menu',
    fibu_journal_empty_text: 'No data is available yet. Please post entries to the journal using batch booking.',

    fibu_offer_preview_name: 'Offer preview',
    fibu_offer_load_error: 'Offers could not be loaded',
    fibu_offer_noGeneratedPositions_message: 'No positions were found for the selected basis.',
    fibu_offer_generatedPositions_message: '{{count}} positions imported from the project. You can edit them directly below.',
    fibu_offer_projectBudgetImport_error: 'Project budget could not be imported',
    fibu_offer_finalized_message: '{{offerNumber}} was finalized.',
    fibu_offer_draftSaved_message: 'Offer draft saved.',
    fibu_offer_finalize_error: 'Offer could not be finalized',
    fibu_offer_save_error: 'Offer could not be saved',
    fibu_offer_previewNotReady_error: 'Offer preview has not been rendered yet.',
    fibu_offer_sent_message: '{{offerNumber}} was sent.',
    fibu_offer_send_error: 'Offer could not be sent',
    fibu_offer_cancel_error: 'Offer could not be cancelled',
    fibu_offer_draftWithId_label: 'Draft {{id}}',
    fibu_offer_deleted_message: 'Offer {{offer}} deleted.',
    fibu_offer_delete_error: 'Offer could not be deleted',
    fibu_offer_invoiceDraft_error: 'Invoice draft could not be created',
    fibu_offer_filePrefix: 'Offer',
    fibu_offer_noFinalPdf_message: 'There is no final PDF for this draft yet.',
    fibu_offer_title_number: 'Offer {{offerNumber}}',
    fibu_offer_new_title: 'New offer',
    fibu_offer_customerNotSelected_label: 'Customer not selected yet',
    fibu_offer_selectCustomerFirst_message: 'Please select a customer first.',
    fibu_offer_customerWithId_label: 'Customer #{{id}}',
    fibu_offer_customerDataLoad_error: 'Customer data could not be loaded',
    fibu_offer_projectScopeLoad_error: 'Project scope could not be loaded',
    fibu_offer_projectSubject: 'Offer “{{projectName}}”',
    fibu_offer_projectLoad_error: 'Project could not be loaded for the offer',
    fibu_offer_defaultSubject: 'Project offer',
    fibu_offer_defaultIntroText: 'Thank you for your inquiry. We are pleased to offer the following services:',
    fibu_offer_defaultClosingText: 'We hope our offer meets your expectations and look forward to working with you.',
    fibu_offer_defaultPaymentTerms: '30 days net without deduction.',
    fibu_offer_markedAccepted_message: '{{offerNumber}} was marked as accepted.',
    fibu_offer_markedRejected_message: '{{offerNumber}} was marked as rejected.',
    fibu_offer_statusChange_error: 'Status could not be changed',
    fibu_offer_number_label: 'Offer number',
    fibu_offer_freeOffer_label: 'Free offer',
    fibu_offer_customerRequired_error: 'Please select a customer.',
    fibu_offer_buyerContactRequired_error: 'Please select a customer contact.',
    fibu_offer_buyerContactUnavailable_error: 'The selected customer contact is no longer available.',
    fibu_offer_buyerContactEmail_error: 'The customer contact does not have a valid email address.',
    fibu_offer_addressRequired_error: 'Please select an offer address.',
    fibu_offer_addressUnavailable_error: 'The selected offer address is no longer available.',
    fibu_offer_addressIncomplete_error: 'The offer address is incomplete. Street, house number, postal code, city and country are required.',
    fibu_offer_sellerContactRequired_error: 'Please select an internal contact.',
    fibu_offer_bankAccountRequired_error: 'Please select a bank account.',
    fibu_offer_paymentTermsRequired_error: 'Please enter payment terms.',
    fibu_offer_paymentTermsLength_error: 'Payment terms may contain at most 1000 characters.',
    fibu_offer_paymentTermsDays_error: 'The payment term must be between 0 and 3650 days.',
    fibu_offer_discountPair_error: 'Discount percentage and deadline are both required.',
    fibu_offer_discountDays_error: 'The discount deadline must be within the payment term.',
    fibu_offer_dateRequired_error: 'Please select a valid offer date.',
    fibu_offer_validUntilRequired_error: 'Please select a valid validity date.',
    fibu_offer_validUntilBeforeDate_error: 'The validity date must not be before the offer date.',
    fibu_offer_subjectRequired_error: 'Please enter a subject.',
    fibu_offer_subjectLength_error: 'The subject may contain at most 250 characters.',
    fibu_offer_introRequired_error: 'Please enter introductory text.',
    fibu_offer_introLength_error: 'The introductory text may contain at most 4000 characters.',
    fibu_offer_closingLength_error: 'The closing text may contain at most 4000 characters.',
    fibu_offer_customerReferenceLength_error: 'The customer reference may contain at most 150 characters.',
    fibu_offer_projectUnavailable_error: 'The selected project is no longer available.',
    fibu_offer_projectCustomerMismatch_error: 'The selected project belongs to a different customer.',
    fibu_offer_projectRequiredForBasis_error: 'A project must be selected for the chosen calculation basis.',
    fibu_offer_positionsRequired_error: 'The offer requires at least one position.',
    fibu_offer_positionsInvalid_error: 'Please complete all positions with a valid quantity, price and VAT rate.',
    fibu_offer_hourlyRateRequired_error: 'An hourly rate greater than 0 is required for hourly calculation.',
    fibu_offer_defaultHoursRequired_error: 'Planned hours must be greater than 0.',
    fibu_offer_paymentTermsWithDiscount: '{{days}} days net, {{percent}}% discount when paid within {{discountDays}} days.',
    fibu_offer_paymentTermsNet: '{{days}} days net without deduction.',

    resourceManager_projectStatistics_customerWithId_label: 'Customer {{id}}',
    resourceManager_projectStatistics_timesheetReceiverWithId_label: 'Timesheet recipient {{id}}',

    billingSendAttachments_header: 'Attachments',
    billingSendAttachments_description: 'PDF and the preferred structured format are preselected.',
    billingSendFormatsLess_button: 'Less',
    billingSendFormatsMore_button: 'More formats',
    billingSendPreferredStandard_label: 'Customer or project default',
    billingSendFormats_hint: 'Select at least one format. EDIFACT and VW may require additional partner data.',

    fibu_invoice_import_eyebrow: 'Invoice import',
    fibu_invoice_import_title: 'Import external invoice',
    fibu_invoice_import_description: 'XRechnung and ZUGFeRD XML as well as EDIFACT INVOIC and Volkswagen VDA 4938 T2 are supported.',
    fibu_invoice_import_checking_label: 'Checking invoice …',
    fibu_invoice_import_selectFile_label: 'Select invoice file',
    fibu_invoice_import_upload_hint: 'XML, EDI or TXT · The original file is stored unchanged during import.',
    fibu_invoice_import_detectedFormat_label: 'Detected format',
    fibu_invoice_import_issuer_label: 'Issuer',
    fibu_invoice_import_preview_hint: 'The preview is generated from the structured invoice data. When saving, the uploaded file is also retained as the original document.',
    fibu_invoice_import_otherFile_button: 'Different file',
    fibu_invoice_import_importing_label: 'Importing …',
    fibu_invoice_import_action: 'Import invoice',
    fibu_invoice_import_structuredInvoice_label: 'Structured invoice',
    fibu_invoice_import_read_error: 'The invoice could not be read.',

    fibu_invoice_previewPng_error: 'Invoice preview could not be converted to PNG.',
    fibu_offer_previewPng_error: 'Offer preview could not be converted to PNG.',
    resourceManager_timeTracking_noProject_label: 'No project',
    resourceManager_timeTracking_projectWithId_label: 'Project {{id}}',

    fibu_invoice_freeRecipientRequired_error: 'Please enter a company or recipient.',
    fibu_invoice_introRequired_error: 'Please enter introductory text.',
    fibu_invoice_introMaxLength_error: 'The introductory text may contain at most 4000 characters.',
    fibu_invoice_closingMaxLength_error: 'The closing text may contain at most 4000 characters.',
    fibu_invoice_internalNoteMaxLength_error: 'The internal note may contain at most 8000 characters.',
    fibu_invoice_discountPair_error: 'Discount percentage and deadline are both required.',
    fibu_invoice_discountPercent_error: 'The discount must be between 0 and 100 percent.',
    fibu_invoice_alreadyBilledExcluded_message: '{{count}} already invoiced entries were automatically excluded.',
    fibu_invoice_budgetOverflow_message: '{{hours}} h no longer fit into the selected remaining budget and were not included.',

    fibu_invoice_filePrefix: 'Invoice',
    resourceManager_employeeTimeOverview_overtimeSheet: 'Overtime',


    calendarTypeTraining: 'Training',
    calendarTypeBusinessTrip: 'Business trip',
    calendarTypeProjectStart: 'Project start',
    calendarTypeProjectEnd: 'Project end',
    calendarTypePublicHoliday: 'Public holiday',
    calendarTypeSpecialLeave: 'Special leave',
    calendarTypeBirthday: 'Birthday',
    calendarTypeTeamsStatus: 'Teams status',
    calendarTypeUnknownWithId: 'Type {{type}}',
    resourceManager_projectStatistics_orderedValue_label: 'Ordered value',
    resourceManager_projectStatistics_remainingValue_label: 'Remaining value',
    fibu_offer_discountPercent_error: 'The discount must be greater than 0 and at most 100 percent.',
    fibu_offer_internalNoteMaxLength_error: 'The internal note may contain at most 8000 characters.',
    general_validationFailed: 'Validation failed',

    fibu_invoice_previewNotReady_error: 'The invoice preview has not been rendered yet.',
    calendarTypeBirthdays: 'Birthdays',
    calendar_birthday_single_tooltip: 'It is {{name}}\'s birthday',
    calendar_birthday_multiple_tooltip: 'Birthdays: {{names}}',
    billing_unit_hour_short: 'hrs',
    billing_unit_day_short: 'day',
    billing_unit_piece_short: 'pcs',
    billing_unit_flat_short: 'flat',

    fibu_invoice_paymentTermsWithDiscount: '{{days}} days net, {{percent}}% discount for payment within {{discountDays}} days.',

    resourceManager_projectStatistics_performance_label: 'Performance',

    general_germany: 'Germany',
    fibu_invoice_notFound_error: 'Invoice was not found.',
    fibu_invoice_mock_freePosition: 'Free invoice item',
    fibu_invoice_mock_manualPosition: 'Manual item',
    fibu_invoice_quantityPositive_error: 'Item quantities must be greater than zero.',
    fibu_invoice_priceNonNegative_error: 'Prices must not be negative.',
    fibu_invoice_mock_accountingContact: 'Accounting',
    fibu_invoice_mock_projectServicesDescription: '{{projectName}} · Development and support services',
    fibu_invoice_mock_projectService: 'Mock project service',
}
